export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Byte: { input: any; output: any };
  DateOnly: { input: any; output: any };
  DateTime: { input: any; output: any };
  Decimal: { input: any; output: any };
  Guid: { input: any; output: any };
  Long: { input: any; output: any };
  StringifiedDecimal: { input: any; output: any };
  UInt: { input: any; output: any };
  UShort: { input: any; output: any };
};

export type AbandonSalesOrderByBillingCycleInputType = {
  comment: Scalars['String']['input'];
  isAbandoned: Scalars['Boolean']['input'];
  reasonCode: Scalars['String']['input'];
  soByBcId: Scalars['ID']['input'];
};

export type AddProductMergeDefaultInputType = {
  mergeType?: InputMaybe<ProductMergeTypeEnum>;
  stockCodeContains: Scalars['String']['input'];
};

export type AddPurchaseOrderInputType = {
  customerId: Scalars['ID']['input'];
  poCurrency: Scalars['String']['input'];
  poDate?: InputMaybe<Scalars['DateTime']['input']>;
  poEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  poNote?: InputMaybe<Scalars['String']['input']>;
  poNumber: Scalars['String']['input'];
  poStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  poStatus?: InputMaybe<PurchaseOrderStatusEnum>;
  poTotalValue?: InputMaybe<Scalars['Decimal']['input']>;
};

export type AddUpliftIndexRatesInputType = {
  upliftIndexId: Scalars['ID']['input'];
  upliftIndexRates: Array<UpliftIndexRateInputType>;
};

export type AddUpliftIndexWithRatesInputType = {
  name: Scalars['String']['input'];
  type: UpliftIndexTypePascalCaseEnum;
  upliftIndexRates?: InputMaybe<Array<UpliftIndexRateInputType>>;
  upliftRegionId: Scalars['ID']['input'];
};

export type AddVerifiableFieldInputType = {
  entityType: EntityTypeEnum;
  field: Scalars['String']['input'];
  reasonCode: Scalars['String']['input'];
};

export type ApproveContractLinesInputType = {
  comment: Scalars['String']['input'];
  contractId?: InputMaybe<Scalars['ID']['input']>;
  contractLines: Array<ContractLineDataType>;
};

export type BillingCycleFilterInput = {
  billingCustomerAccountName?: InputMaybe<StringFilterInput>;
  billingCustomerAccountNumber?: InputMaybe<StringFilterInput>;
  billingCycleID?: InputMaybe<GuidFilterInput>;
  billingDate?: InputMaybe<DateTimeFilterInput>;
  consolidationCriteriaCode?: InputMaybe<StringFilterInput>;
  contractLineID?: InputMaybe<GuidFilterInput>;
  contractNumber?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  currency?: InputMaybe<StringFilterInput>;
  endDate?: InputMaybe<DateTimeFilterInput>;
  net?: InputMaybe<StringifiedDecimalFilterInput>;
  price?: InputMaybe<StringifiedDecimalFilterInput>;
  processingStatus?: InputMaybe<BillingCycleStatusPascalCaseEnumFilterInput>;
  quantity?: InputMaybe<LongFilterInput>;
  salesOrderNumber?: InputMaybe<StringFilterInput>;
  salesOrderStatus?: InputMaybe<StringFilterInput>;
  soCount?: InputMaybe<IntFilterInput>;
  startDate?: InputMaybe<DateTimeFilterInput>;
  statusReason?: InputMaybe<StringFilterInput>;
  stockCode?: InputMaybe<StringFilterInput>;
  stockName?: InputMaybe<StringFilterInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<DateTimeFilterInput>;
};

export type BillingCycleOutput = {
  __typename?: 'BillingCycleOutput';
  billingCustomerAccountName?: Maybe<Scalars['String']['output']>;
  billingCustomerAccountNumber?: Maybe<Scalars['String']['output']>;
  billingCycleID?: Maybe<Scalars['Guid']['output']>;
  billingDate?: Maybe<Scalars['DateTime']['output']>;
  billingValue?: Maybe<Scalars['Decimal']['output']>;
  consolidationCriteriaCode?: Maybe<Scalars['String']['output']>;
  contractID?: Maybe<Scalars['Guid']['output']>;
  contractLineID?: Maybe<Scalars['Guid']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  firstSalesOrderId?: Maybe<Scalars['Guid']['output']>;
  latestSalesOrderId?: Maybe<Scalars['Guid']['output']>;
  net?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  processingStatus?: Maybe<BillingCycleStatusEnum>;
  quantity?: Maybe<Scalars['Long']['output']>;
  salesOrderNumber?: Maybe<Scalars['String']['output']>;
  salesOrderStatus?: Maybe<Scalars['String']['output']>;
  soCount?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  statusReason?: Maybe<Scalars['String']['output']>;
  stockCode?: Maybe<Scalars['String']['output']>;
  stockName?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection from an object to a list of objects of type `BillingCycleOutput`. */
export type BillingCycleOutputConnection = {
  __typename?: 'BillingCycleOutputConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<BillingCycleOutputEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<BillingCycleOutput>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `BillingCycleOutput`. */
export type BillingCycleOutputEdge = {
  __typename?: 'BillingCycleOutputEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<BillingCycleOutput>;
};

export enum BillingCycleSort {
  BillingCustomerAccountName = 'BillingCustomerAccountName',
  BillingCustomerAccountNumber = 'BillingCustomerAccountNumber',
  BillingCycleID = 'BillingCycleID',
  BillingDate = 'BillingDate',
  ConsolidationCriteriaCode = 'ConsolidationCriteriaCode',
  ContractLineID = 'ContractLineID',
  ContractNumber = 'ContractNumber',
  Created = 'Created',
  Currency = 'Currency',
  EndDate = 'EndDate',
  Net = 'Net',
  Price = 'Price',
  ProcessingStatus = 'ProcessingStatus',
  Quantity = 'Quantity',
  SalesOrderNumber = 'SalesOrderNumber',
  SalesOrderStatus = 'SalesOrderStatus',
  SoCount = 'SoCount',
  StartDate = 'StartDate',
  StatusReason = 'StatusReason',
  StockCode = 'StockCode',
  StockName = 'StockName',
  Updated = 'Updated',
}

export type BillingCycleSortSortByInput = {
  /** Field */
  field?: InputMaybe<BillingCycleSort>;
  order: OrderType;
};

export enum BillingCycleStatusEnum {
  ActivePending = 'ActivePending',
  Excluded = 'Excluded',
  Ignored = 'Ignored',
  SoCreated = 'SoCreated',
  SoCreationStarted = 'SoCreationStarted',
}

export type BillingCycleStatusPascalCaseEnumFilterInput = {
  containsValues?: InputMaybe<Array<InputMaybe<BillingCycleStatusEnum>>>;
  eq?: InputMaybe<BillingCycleStatusEnum>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<BillingCycleStatusEnum>;
  notContainsValues?: InputMaybe<Array<InputMaybe<BillingCycleStatusEnum>>>;
};

export type BillingHealthSalesOrderTotalsFilterInput = {
  created?: InputMaybe<DateTimeFilterInput>;
  currency?: InputMaybe<StringFilterInput>;
};

export type BillingHealthSalesOrderTotalsOutput = {
  __typename?: 'BillingHealthSalesOrderTotalsOutput';
  statusCounts?: Maybe<Array<Maybe<BillingHealthStatusCount>>>;
  totalCount: Scalars['Int']['output'];
};

export type BillingHealthStatusCount = {
  __typename?: 'BillingHealthStatusCount';
  count: Scalars['Int']['output'];
  formattedStatus?: Maybe<Scalars['String']['output']>;
  totalAmount: Scalars['Decimal']['output'];
};

export type BillingIntervalType = {
  __typename?: 'BillingIntervalType';
  billingInterval: Scalars['String']['output'];
  contractDBRLimit: RenewalRangeType;
  enabled: Scalars['Boolean']['output'];
  formattedBillingInterval: Scalars['String']['output'];
  globalDBRLimit: RenewalRangeType;
  monthsCount: Scalars['Int']['output'];
  showable: Scalars['Boolean']['output'];
};

export type BillingPeriodType = {
  __typename?: 'BillingPeriodType';
  billingEndDate?: Maybe<Scalars['DateTime']['output']>;
  billingStartDate: Scalars['DateTime']['output'];
};

export type BillingType = {
  __typename?: 'BillingType';
  formattedType: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum BillingTypeEnum {
  Deposit = 'Deposit',
  Initials = 'Initials',
  Subscription = 'Subscription',
  Variable = 'Variable',
}

export type BooleanFilterInput = {
  /** ContainsValues */
  containsValues?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  /** NotContainsValues */
  notContainsValues?: InputMaybe<
    Array<InputMaybe<Scalars['Boolean']['input']>>
  >;
};

export type BulkAssignPurchaseOrderInput = {
  contractLineIds: Array<Scalars['Guid']['input']>;
  purchaseOrderId: Scalars['Guid']['input'];
};

export type BulkCancelUpliftsErrorType = {
  __typename?: 'BulkCancelUpliftsErrorType';
  error?: Maybe<Scalars['String']['output']>;
  upliftId: Scalars['ID']['output'];
};

export type BulkCancelUpliftsResponseType = {
  __typename?: 'BulkCancelUpliftsResponseType';
  errors: Array<BulkCancelUpliftsErrorType>;
  status: ResultEnum;
};

export type BulkContractLineUpliftsInputType = {
  contractLineUplifts: Array<ContractLineBulkUpliftInputType>;
  subscriptionId?: InputMaybe<Scalars['ID']['input']>;
};

export type BulkUnassignPurchaseOrderInput = {
  contractLineIds: Array<Scalars['Guid']['input']>;
};

export type BulkUpdateContractLineInvoiceToCustomerInputType = {
  contractLineIds: Array<Scalars['ID']['input']>;
  invoiceToCustomerId: Scalars['ID']['input'];
  purchaseOrderId?: InputMaybe<Scalars['ID']['input']>;
};

export type BulkUpdateContractLineShipToCustomerInputType = {
  contractLineIds: Array<Scalars['ID']['input']>;
  shipToCustomerId: Scalars['ID']['input'];
};

export type BulkUpdateContractLinesInputType = {
  contractAndContractLines: Array<ContractAndContractLinesInputType>;
};

export type BulkUpdateContractLinesResponseType = {
  __typename?: 'BulkUpdateContractLinesResponseType';
  results: Array<UpdateContractAndContractLinesStatusType>;
  status: ResultEnum;
};

export type BulkUpdateProRataEndDateErrorType = {
  __typename?: 'BulkUpdateProRataEndDateErrorType';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export type BulkUpdateProRataEndDateInputType = {
  contractId: Scalars['ID']['input'];
  contractLineIds: Array<Scalars['Guid']['input']>;
  proRataEndDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BulkUpdateProRataEndDateResponseType = {
  __typename?: 'BulkUpdateProRataEndDateResponseType';
  errors: Array<BulkUpdateProRataEndDateErrorType>;
  status: ResultEnum;
};

export type BulkUpliftContractLinesPayload = {
  __typename?: 'BulkUpliftContractLinesPayload';
  code: ResultEnum;
  message?: Maybe<Scalars['String']['output']>;
};

export type BundleFilterInput = {
  contractId?: InputMaybe<GuidFilterInput>;
  contractNumber?: InputMaybe<StringFilterInput>;
  currency?: InputMaybe<StringFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  hideInvoiceLines?: InputMaybe<BooleanFilterInput>;
  hideInvoiceValues?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<GuidFilterInput>;
  softwareCompany?: InputMaybe<StringFilterInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BundleTypePascalCaseEnumFilterInput>;
};

export type BundleOutput = {
  __typename?: 'BundleOutput';
  contractId: Scalars['ID']['output'];
  contractNumber?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hideInvoiceLines: Scalars['Boolean']['output'];
  hideInvoiceValues: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  softwareCompany?: Maybe<Scalars['String']['output']>;
  totalAnnualBillingValue?: Maybe<Scalars['Decimal']['output']>;
  totalPredictedAnnualValue?: Maybe<Scalars['Decimal']['output']>;
  type?: Maybe<BundleTypeEnum>;
};

/** A connection from an object to a list of objects of type `BundleOutput`. */
export type BundleOutputConnection = {
  __typename?: 'BundleOutputConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<BundleOutputEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<BundleOutput>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `BundleOutput`. */
export type BundleOutputEdge = {
  __typename?: 'BundleOutputEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<BundleOutput>;
};

export enum BundleSort {
  ContractNumber = 'ContractNumber',
  Currency = 'Currency',
  Description = 'Description',
  HideInvoiceLines = 'HideInvoiceLines',
  HideInvoiceValues = 'HideInvoiceValues',
  Id = 'Id',
  SoftwareCompany = 'SoftwareCompany',
  Type = 'Type',
}

export type BundleSortSortByInput = {
  /** Field */
  field?: InputMaybe<BundleSort>;
  order: OrderType;
};

export enum BundleTypeEnum {
  Contractual = 'Contractual',
  Custom = 'Custom',
  Suite = 'Suite',
}

export type BundleTypePascalCaseEnumFilterInput = {
  containsValues?: InputMaybe<Array<InputMaybe<BundleTypeEnum>>>;
  eq?: InputMaybe<BundleTypeEnum>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<BundleTypeEnum>;
  notContainsValues?: InputMaybe<Array<InputMaybe<BundleTypeEnum>>>;
};

export type CalculateUpliftedContractLinesInputType = {
  amount: Scalars['Decimal']['input'];
  applicableDate?: InputMaybe<Scalars['DateTime']['input']>;
  filter: FilterContractLinesForUpliftType;
  nextUpliftDate?: InputMaybe<Scalars['DateTime']['input']>;
  upliftMethod?: InputMaybe<UpliftMethodEnum>;
};

export type CancelContractLinesInputType = {
  cancelDate: Scalars['DateTime']['input'];
  comment: Scalars['String']['input'];
  contractId: Scalars['ID']['input'];
  contractLines: Array<ContractLineDataType>;
  reasonCode: Scalars['String']['input'];
};

export type CancelUpliftsInputType = {
  reason: Scalars['String']['input'];
  uplifIds: Array<Scalars['ID']['input']>;
};

export type ChangeReasonInputType = {
  comment?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type ChangeSetType = {
  __typename?: 'ChangeSetType';
  changeSetID: Scalars['ID']['output'];
  changes: Array<ChangeType>;
  entityID: Scalars['ID']['output'];
  entityType: EntityTypeEnum;
  eventSourceId?: Maybe<Scalars['ID']['output']>;
  eventSourceType?: Maybe<EventSourceTypeEnum>;
  eventType: EventTypeEnum;
  header: Scalars['String']['output'];
  staticData: Array<StaticDataType>;
  timeStamp: Scalars['DateTime']['output'];
};

export type ChangeType = {
  __typename?: 'ChangeType';
  changeID: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  newValue: Scalars['String']['output'];
  oldValue: Scalars['String']['output'];
};

export enum ChangeTypeEnum {
  CREATED = 'CREATED',
  DELETED = 'DELETED',
  UPDATED = 'UPDATED',
}

export type ClientDatabaseFilterInput = {
  id?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type ClientDatabaseOutput = {
  __typename?: 'ClientDatabaseOutput';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** A connection from an object to a list of objects of type `ClientDatabaseOutput`. */
export type ClientDatabaseOutputConnection = {
  __typename?: 'ClientDatabaseOutputConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<ClientDatabaseOutputEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<ClientDatabaseOutput>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `ClientDatabaseOutput`. */
export type ClientDatabaseOutputEdge = {
  __typename?: 'ClientDatabaseOutputEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ClientDatabaseOutput>;
};

export enum ClientDatabaseSort {
  Id = 'Id',
  Name = 'Name',
}

export type ClientDatabaseSortSortByInput = {
  /** Field */
  field?: InputMaybe<ClientDatabaseSort>;
  order: OrderType;
};

export type ClientDatabaseType = {
  __typename?: 'ClientDatabaseType';
  clientDatabaseReference: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ClientDatabases = {
  __typename?: 'ClientDatabases';
  iD?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ColumnInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CommissionsReportFilterInput = {
  /** Filter by billing interval of SO items */
  billingInterval?: InputMaybe<Scalars['String']['input']>;
  /** Search by InvoiceToAccountCode or InvoiceToAccountName */
  invoiceTo?: InputMaybe<Scalars['String']['input']>;
  /** Page number (1-based). Optional, defaults to 1. */
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Page size. Optional, defaults to 50. */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /** Filter sending date from (INV Start Date From) */
  sendingDateFrom?: InputMaybe<Scalars['DateOnly']['input']>;
  /** Filter sending date to (INV End Date To) */
  sendingDateTo?: InputMaybe<Scalars['DateOnly']['input']>;
};

export type CommissionsReportLine = {
  __typename?: 'CommissionsReportLine';
  amount: Scalars['Decimal']['output'];
  billingCycleEndDate: Scalars['DateTime']['output'];
  billingCycleStartDate: Scalars['DateTime']['output'];
  billingInterval?: Maybe<Scalars['String']['output']>;
  consolidated: Scalars['Boolean']['output'];
  contractNumber?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  invoiceToAccountCode?: Maybe<Scalars['String']['output']>;
  invoiceToAccountId?: Maybe<Scalars['Guid']['output']>;
  invoiceToAccountName?: Maybe<Scalars['String']['output']>;
  net?: Maybe<Scalars['Decimal']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  proRataType?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Long']['output']>;
  salesOrderId: Scalars['Guid']['output'];
  salesOrderReferenceId?: Maybe<Scalars['String']['output']>;
  sendingDate?: Maybe<Scalars['DateTime']['output']>;
  stockCode?: Maybe<Scalars['String']['output']>;
  unitCost: Scalars['Decimal']['output'];
};

export type ConfigMasterRecordQueries = {
  __typename?: 'ConfigMasterRecordQueries';
  userPermissions: Array<Scalars['String']['output']>;
};

export type ConfigMutations = {
  __typename?: 'ConfigMutations';
  /** Saved search */
  savedSearch?: Maybe<SavedSearchMutation>;
  /** User configuration */
  userConfiguration?: Maybe<UserConfigurationMutation>;
};

export type ConfigQueries = {
  __typename?: 'ConfigQueries';
  /** Master records */
  masterRecords?: Maybe<ConfigMasterRecordQueries>;
  recentSavedSearches?: Maybe<Array<Search>>;
  savedSearches?: Maybe<Array<Search>>;
  /** User configuration */
  userConfiguration?: Maybe<UserConfigurationQuery>;
};

export type ConfigQueriesrecentSavedSearchesArgs = {
  filter: RecentSavedSearchFilterInput;
};

export type ConfigQueriessavedSearchesArgs = {
  filter: SavedSearchFilterInput;
};

export type ContractAndContractLinesInputType = {
  contractId: Scalars['ID']['input'];
  contractLines: Array<ContractLineToUpdateType>;
};

export type ContractBillingStatusEnumEnumFilterInput = {
  containsValues?: InputMaybe<
    Array<InputMaybe<ContractBillingStatusPascalCaseEnum>>
  >;
  eq?: InputMaybe<ContractBillingStatusPascalCaseEnum>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<ContractBillingStatusPascalCaseEnum>;
  notContainsValues?: InputMaybe<
    Array<InputMaybe<ContractBillingStatusPascalCaseEnum>>
  >;
};

export enum ContractBillingStatusPascalCaseEnum {
  FuturePause = 'FuturePause',
  On = 'On',
  Paused = 'Paused',
}

export type ContractBillingType = {
  __typename?: 'ContractBillingType';
  collectible?: Maybe<Scalars['Boolean']['output']>;
  currentStatusEndDate?: Maybe<Scalars['DateTime']['output']>;
  nextStatus?: Maybe<ContractBillingStatusPascalCaseEnum>;
  reasonCode?: Maybe<ReasonCodeType>;
  status: ContractBillingStatusPascalCaseEnum;
  statusUpdateComment?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is depreciated use 'reasonCode' */
  statusUpdateReasonCode?: Maybe<Scalars['String']['output']>;
  statusUpdateReference?: Maybe<Scalars['String']['output']>;
  statusUpdated?: Maybe<Scalars['DateTime']['output']>;
};

export type ContractByBillingCyclesType = {
  __typename?: 'ContractByBillingCyclesType';
  billToParent: Scalars['Boolean']['output'];
  billing: ContractBillingType;
  billingType: Array<Scalars['String']['output']>;
  calculatedTerm: Scalars['String']['output'];
  clientDatabase?: Maybe<ClientDatabaseType>;
  clientDatabaseReference?: Maybe<Scalars['String']['output']>;
  consolidateBilling: Scalars['Boolean']['output'];
  contractEndDate: Scalars['DateTime']['output'];
  contractID: Scalars['ID']['output'];
  contractLines: PaginatedContractLinesByBillingCyclesType;
  contractNotes: PaginatedContractNotes;
  contractNumber: Scalars['String']['output'];
  contractStartDate: Scalars['DateTime']['output'];
  contractUpliftSettings?: Maybe<ContractUpliftSettingsType>;
  contractedToCustomerAccount?: Maybe<Scalars['String']['output']>;
  contractedToCustomerId?: Maybe<Scalars['Guid']['output']>;
  created: Scalars['DateTime']['output'];
  currency: CurrencyType;
  customer: CustomerType;
  daysBeforeRenewal?: Maybe<Scalars['Int']['output']>;
  defaultInvoiceToCustomerAccount?: Maybe<Scalars['String']['output']>;
  defaultInvoiceToCustomerId?: Maybe<Scalars['Guid']['output']>;
  defaultShipToCustomerAccount?: Maybe<Scalars['String']['output']>;
  defaultShipToCustomerId?: Maybe<Scalars['Guid']['output']>;
  directDebit?: Maybe<DirectDebitType>;
  displaySettings: DisplaySettingsType;
  divertCustomer?: Maybe<CustomerType>;
  externalContractID?: Maybe<Scalars['String']['output']>;
  initialTermPassed?: Maybe<Scalars['Boolean']['output']>;
  invoiceToCustomer: CustomerType;
  mainProductFamily?: Maybe<Scalars['String']['output']>;
  nextUpliftDate?: Maybe<Scalars['DateTime']['output']>;
  oneEvoContractNumber?: Maybe<Scalars['String']['output']>;
  oneEvoMigrated: Scalars['Boolean']['output'];
  oneEvoMigrationDate?: Maybe<Scalars['DateTime']['output']>;
  origin?: Maybe<ContractOriginEnum>;
  productFamily: Array<Scalars['String']['output']>;
  purchaseOrder?: Maybe<ContractPurchaseOrderType>;
  renewableTerm: Scalars['Int']['output'];
  reseller: Scalars['Boolean']['output'];
  rolloverDate?: Maybe<Scalars['DateTime']['output']>;
  sfContractId?: Maybe<Scalars['String']['output']>;
  shipToCustomer: CustomerType;
  status: ContractStatusType;
  term: Scalars['Int']['output'];
  totalBillingPeriodValue: Scalars['String']['output'];
  totalContractValue: Scalars['String']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
  upliftExemption: ContractUpliftExemptionType;
};

export type ContractByBillingCyclesTypecontractLinesArgs = {
  billingTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ContractByBillingCyclesTypecontractNotesArgs = {
  input: GetPaginatedContractNotesInputType;
};

export type ContractChangeType = {
  __typename?: 'ContractChangeType';
  changeType: ChangeTypeEnum;
  changed: ContractType;
  changedOn: Scalars['DateTime']['output'];
};

export type ContractClientDatabaseReferenceType = {
  __typename?: 'ContractClientDatabaseReferenceType';
  clientDatabaseReference?: Maybe<Scalars['String']['output']>;
  contractID: Scalars['ID']['output'];
};

export type ContractFilterInput = {
  accountManagerName?: InputMaybe<StringFilterInput>;
  address?: InputMaybe<StringFilterInput>;
  billingStatus?: InputMaybe<ContractBillingStatusEnumEnumFilterInput>;
  billingType?: InputMaybe<StringFilterInput>;
  calculatedTerm?: InputMaybe<StringFilterInput>;
  ccEmailAddress?: InputMaybe<StringFilterInput>;
  consolidateBilling?: InputMaybe<BooleanFilterInput>;
  contactName?: InputMaybe<StringFilterInput>;
  contactPhoneNumber?: InputMaybe<StringFilterInput>;
  contractEndDate?: InputMaybe<DateTimeFilterInput>;
  contractNumber?: InputMaybe<StringFilterInput>;
  contractStartDate?: InputMaybe<DateTimeFilterInput>;
  contractStatus?: InputMaybe<StringFilterInput>;
  country?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  currency?: InputMaybe<StringFilterInput>;
  customerAccountNumber?: InputMaybe<StringFilterInput>;
  customerId?: InputMaybe<GuidFilterInput>;
  customerName?: InputMaybe<StringFilterInput>;
  directDebit?: InputMaybe<StringFilterInput>;
  emailAddress?: InputMaybe<StringFilterInput>;
  externalContractId?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<GuidFilterInput>;
  invoiceDate?: InputMaybe<DateFilterInput>;
  invoiceToAccountManagerName?: InputMaybe<StringFilterInput>;
  invoiceToAddress?: InputMaybe<StringFilterInput>;
  invoiceToCCEmailAddress?: InputMaybe<StringFilterInput>;
  invoiceToContactName?: InputMaybe<StringFilterInput>;
  invoiceToContactPhoneNumber?: InputMaybe<StringFilterInput>;
  invoiceToCountry?: InputMaybe<StringFilterInput>;
  invoiceToCustomerAccountNumber?: InputMaybe<StringFilterInput>;
  invoiceToCustomerName?: InputMaybe<StringFilterInput>;
  invoiceToEmailAddress?: InputMaybe<StringFilterInput>;
  invoiceToPostCode?: InputMaybe<StringFilterInput>;
  invoiceToSalesPersonName?: InputMaybe<StringFilterInput>;
  invoiceToState?: InputMaybe<StringFilterInput>;
  invoiceToTown?: InputMaybe<StringFilterInput>;
  lineStartDate?: InputMaybe<DateTimeFilterInput>;
  oneEvoContractNumber?: InputMaybe<StringFilterInput>;
  oneEvoMigrated?: InputMaybe<BooleanFilterInput>;
  oneEvoMigrationDate?: InputMaybe<DateTimeFilterInput>;
  origin?: InputMaybe<ContractOriginPascalCaseEnumFilterInput>;
  pONumber?: InputMaybe<StringFilterInput>;
  pONumberEndDate?: InputMaybe<DateTimeFilterInput>;
  pONumberStartDate?: InputMaybe<DateFilterInput>;
  postCode?: InputMaybe<StringFilterInput>;
  product?: InputMaybe<ProductFilterInput>;
  productFamily?: InputMaybe<StringFilterInput>;
  renewableTerm?: InputMaybe<IntFilterInput>;
  rolloverDate?: InputMaybe<DateFilterInput>;
  salesPersonName?: InputMaybe<StringFilterInput>;
  shipToAccountManagerName?: InputMaybe<StringFilterInput>;
  shipToAddress?: InputMaybe<StringFilterInput>;
  shipToCCEmailAddress?: InputMaybe<StringFilterInput>;
  shipToContactName?: InputMaybe<StringFilterInput>;
  shipToContactPhoneNumber?: InputMaybe<StringFilterInput>;
  shipToCountry?: InputMaybe<StringFilterInput>;
  shipToCustomerAccountNumber?: InputMaybe<StringFilterInput>;
  shipToCustomerName?: InputMaybe<StringFilterInput>;
  shipToEmailAddress?: InputMaybe<StringFilterInput>;
  shipToPostCode?: InputMaybe<StringFilterInput>;
  shipToSalesPersonName?: InputMaybe<StringFilterInput>;
  shipToState?: InputMaybe<StringFilterInput>;
  shipToTown?: InputMaybe<StringFilterInput>;
  state?: InputMaybe<StringFilterInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<IntFilterInput>;
  totalBillingPeriodValue?: InputMaybe<StringifiedDecimalFilterInput>;
  totalContractValue?: InputMaybe<StringifiedDecimalFilterInput>;
  town?: InputMaybe<StringFilterInput>;
  unitPriceFrequency?: InputMaybe<StringFilterInput>;
  updated?: InputMaybe<DateTimeFilterInput>;
};

export type ContractIdentifiersInputType = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  contractNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ContractIdentifiersOutputType = {
  __typename?: 'ContractIdentifiersOutputType';
  contractId: Scalars['ID']['output'];
  contractNumber: Scalars['String']['output'];
};

export type ContractInputType = {
  clientDatabaseReference?: InputMaybe<Scalars['String']['input']>;
  contractNumber: Scalars['String']['input'];
  contractStartDate: Scalars['DateTime']['input'];
  currency: Scalars['String']['input'];
  customerID: Scalars['ID']['input'];
  directDebit?: InputMaybe<Scalars['String']['input']>;
  externalContractID?: InputMaybe<Scalars['String']['input']>;
  invoiceToCustomerID?: InputMaybe<Scalars['ID']['input']>;
  origin?: InputMaybe<ContractOriginEnum>;
  pONumber?: InputMaybe<PONumberInputType>;
  renewableTerm: Scalars['Int']['input'];
  shipToCustomerID?: InputMaybe<Scalars['ID']['input']>;
  term: Scalars['Int']['input'];
};

export type ContractLineBillingCycleOutput = {
  __typename?: 'ContractLineBillingCycleOutput';
  annualBillingPeriodValue?: Maybe<Scalars['String']['output']>;
  billingInterval?: Maybe<Scalars['String']['output']>;
  billingIntervalMonthsCount?: Maybe<Scalars['Int']['output']>;
  billingPeriodValue?: Maybe<Scalars['String']['output']>;
  billingType?: Maybe<BillingTypeEnum>;
  bundleDescription?: Maybe<Scalars['String']['output']>;
  bundleHideInvoiceLines?: Maybe<Scalars['Boolean']['output']>;
  bundleHideInvoiceValues?: Maybe<Scalars['Boolean']['output']>;
  bundleId?: Maybe<Scalars['ID']['output']>;
  bundleSoftwareCompany?: Maybe<Scalars['String']['output']>;
  bundleType?: Maybe<BundleTypeEnum>;
  comments?: Maybe<Scalars['String']['output']>;
  contractId: Scalars['Guid']['output'];
  created: Scalars['DateTime']['output'];
  id: Scalars['Guid']['output'];
  invoiceToAccountManagerName?: Maybe<Scalars['String']['output']>;
  invoiceToCCEmailAddress?: Maybe<Scalars['String']['output']>;
  invoiceToContactName?: Maybe<Scalars['String']['output']>;
  invoiceToContactPhoneNumber?: Maybe<Scalars['String']['output']>;
  invoiceToCountry?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerAccountNumber?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerAddress?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerId: Scalars['Guid']['output'];
  invoiceToCustomerName?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerPostcode?: Maybe<Scalars['String']['output']>;
  invoiceToEmailAddress?: Maybe<Scalars['String']['output']>;
  invoiceToSalesPersonName?: Maybe<Scalars['String']['output']>;
  invoiceToState?: Maybe<Scalars['String']['output']>;
  invoiceToTown?: Maybe<Scalars['String']['output']>;
  isFromMerge?: Maybe<Scalars['Boolean']['output']>;
  lastBillingDate?: Maybe<Scalars['DateTime']['output']>;
  lastBillingEndDate?: Maybe<Scalars['DateTime']['output']>;
  lastBillingStartDate?: Maybe<Scalars['DateTime']['output']>;
  lineBillingCurrentStatusEndDate?: Maybe<Scalars['DateTime']['output']>;
  lineBillingCurrentStatusStartDate?: Maybe<Scalars['DateTime']['output']>;
  lineBillingStatus?: Maybe<ContractBillingStatusPascalCaseEnum>;
  lineBillingStatusUpdateComment?: Maybe<Scalars['String']['output']>;
  lineBillingStatusUpdateReasonCode?: Maybe<Scalars['String']['output']>;
  lineBillingStatusUpdateReference?: Maybe<Scalars['String']['output']>;
  lineBillingStatusUpdated?: Maybe<Scalars['DateTime']['output']>;
  lineStartDate?: Maybe<Scalars['DateTime']['output']>;
  mergedLineId?: Maybe<Scalars['Guid']['output']>;
  minCharge?: Maybe<Scalars['Decimal']['output']>;
  nextBillingEndDate?: Maybe<Scalars['DateTime']['output']>;
  nextBillingStartDate?: Maybe<Scalars['DateTime']['output']>;
  nextInvoiceDate?: Maybe<Scalars['DateTime']['output']>;
  nextSoIssueDate?: Maybe<Scalars['DateTime']['output']>;
  nextUpliftDate?: Maybe<Scalars['DateTime']['output']>;
  noFurtherBilling?: Maybe<Scalars['Boolean']['output']>;
  noFurtherBillingDate?: Maybe<Scalars['DateTime']['output']>;
  oppHeaderId?: Maybe<Scalars['String']['output']>;
  oppLineId?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<ContractOriginEnum>;
  originalStartDate?: Maybe<Scalars['DateTime']['output']>;
  poDate?: Maybe<Scalars['DateTime']['output']>;
  poEndDate?: Maybe<Scalars['DateTime']['output']>;
  poNote?: Maybe<Scalars['String']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  poRemainingValue?: Maybe<Scalars['String']['output']>;
  poStartDate?: Maybe<Scalars['DateTime']['output']>;
  poStatus?: Maybe<PurchaseOrderStatusEnum>;
  poTotalValue?: Maybe<Scalars['String']['output']>;
  proRataEndDate?: Maybe<Scalars['DateTime']['output']>;
  productId: Scalars['Guid']['output'];
  quantity?: Maybe<Scalars['Long']['output']>;
  salesHandoverNumber?: Maybe<Scalars['String']['output']>;
  shipToAccountManagerName?: Maybe<Scalars['String']['output']>;
  shipToCCEmailAddress?: Maybe<Scalars['String']['output']>;
  shipToContactName?: Maybe<Scalars['String']['output']>;
  shipToContactPhoneNumber?: Maybe<Scalars['String']['output']>;
  shipToCountry?: Maybe<Scalars['String']['output']>;
  shipToCustomerAccountNumber?: Maybe<Scalars['String']['output']>;
  shipToCustomerAddress?: Maybe<Scalars['String']['output']>;
  shipToCustomerId: Scalars['Guid']['output'];
  shipToCustomerName?: Maybe<Scalars['String']['output']>;
  shipToCustomerPostcode?: Maybe<Scalars['String']['output']>;
  shipToEmailAddress?: Maybe<Scalars['String']['output']>;
  shipToSalesPersonName?: Maybe<Scalars['String']['output']>;
  shipToState?: Maybe<Scalars['String']['output']>;
  shipToTown?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ContractStatusEnum>;
  statusChangeComment?: Maybe<Scalars['String']['output']>;
  statusChangeDate?: Maybe<Scalars['DateTime']['output']>;
  statusChangeReason?: Maybe<Scalars['String']['output']>;
  statusChangeReasonName?: Maybe<Scalars['String']['output']>;
  statusChangeReasonType?: Maybe<Scalars['String']['output']>;
  stockCode?: Maybe<Scalars['String']['output']>;
  stockName?: Maybe<Scalars['String']['output']>;
  terminationDate?: Maybe<Scalars['DateTime']['output']>;
  unitPrice: Scalars['String']['output'];
  unitPriceFrequency?: Maybe<Scalars['String']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection from an object to a list of objects of type `ContractLineBillingCycleOutput`. */
export type ContractLineBillingCycleOutputConnection = {
  __typename?: 'ContractLineBillingCycleOutputConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<ContractLineBillingCycleOutputEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<ContractLineBillingCycleOutput>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `ContractLineBillingCycleOutput`. */
export type ContractLineBillingCycleOutputEdge = {
  __typename?: 'ContractLineBillingCycleOutputEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ContractLineBillingCycleOutput>;
};

export type ContractLineBillingType = {
  __typename?: 'ContractLineBillingType';
  currentStatusEndDate?: Maybe<Scalars['DateTime']['output']>;
  currentStatusStartDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<ContractBillingStatusPascalCaseEnum>;
  statusUpdateComment?: Maybe<Scalars['String']['output']>;
  statusUpdateReasonCode?: Maybe<Scalars['String']['output']>;
  statusUpdateReasonName?: Maybe<Scalars['String']['output']>;
  statusUpdateReference?: Maybe<Scalars['String']['output']>;
  statusUpdated?: Maybe<Scalars['DateTime']['output']>;
};

export type ContractLineBulkUpliftInputType = {
  contractLineId: Scalars['ID']['input'];
  nextUpliftDate?: InputMaybe<Scalars['DateTime']['input']>;
  upliftAmount: Scalars['Decimal']['input'];
  upliftMethod?: InputMaybe<UpliftMethodEnum>;
};

export type ContractLineByBillingCycleChangeType = {
  __typename?: 'ContractLineByBillingCycleChangeType';
  changeType: ChangeTypeEnum;
  changed: ContractLineByBillingCyclesType;
  changedOn: Scalars['DateTime']['output'];
};

export type ContractLineByBillingCyclesType = {
  __typename?: 'ContractLineByBillingCyclesType';
  annualBillingPeriodValue?: Maybe<Scalars['String']['output']>;
  billingEndDate?: Maybe<Scalars['DateTime']['output']>;
  billingInterval?: Maybe<BillingIntervalType>;
  billingPeriodValue?: Maybe<Scalars['String']['output']>;
  billingStartDate: Scalars['DateTime']['output'];
  billingType: BillingType;
  comments?: Maybe<Scalars['String']['output']>;
  contractID: Scalars['Guid']['output'];
  contractLineID: Scalars['Guid']['output'];
  contractOneEvoMigrated: Scalars['Boolean']['output'];
  created: Scalars['DateTime']['output'];
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceToCustomer: CustomerType;
  /** Indicates if the contract line billing is paused */
  isPaused?: Maybe<Scalars['Boolean']['output']>;
  lastSoEndDate?: Maybe<Scalars['DateTime']['output']>;
  lastSoStartDate?: Maybe<Scalars['DateTime']['output']>;
  latestSoEndDate?: Maybe<Scalars['DateTime']['output']>;
  latestSoStartDate?: Maybe<Scalars['DateTime']['output']>;
  lineBilling?: Maybe<ContractLineBillingType>;
  lineStartDate?: Maybe<Scalars['DateTime']['output']>;
  minCharge?: Maybe<Scalars['Decimal']['output']>;
  nextBillingDate?: Maybe<Scalars['DateTime']['output']>;
  nextUpliftDate?: Maybe<Scalars['DateTime']['output']>;
  noFurtherBilling?: Maybe<Scalars['Boolean']['output']>;
  noFurtherBillingDate?: Maybe<Scalars['DateTime']['output']>;
  oppHeaderId?: Maybe<Scalars['String']['output']>;
  oppLineId?: Maybe<Scalars['String']['output']>;
  poDate?: Maybe<Scalars['DateTime']['output']>;
  poEndDate?: Maybe<Scalars['DateTime']['output']>;
  poNote?: Maybe<Scalars['String']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  poStartDate?: Maybe<Scalars['DateTime']['output']>;
  poStatus?: Maybe<PurchaseOrderStatusEnum>;
  poTotalValue?: Maybe<Scalars['String']['output']>;
  predictedSoEndDate?: Maybe<Scalars['DateTime']['output']>;
  predictedSoStartDate?: Maybe<Scalars['DateTime']['output']>;
  pricePerUnit: Scalars['String']['output'];
  proRataEndDate?: Maybe<Scalars['DateTime']['output']>;
  product?: Maybe<ProductType>;
  productVersion?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Long']['output']>;
  salesHandoverNumber?: Maybe<Scalars['String']['output']>;
  sfContractLineId?: Maybe<Scalars['String']['output']>;
  shipToCustomer: CustomerType;
  status: ContractLineStatusType;
  statusChangeComment?: Maybe<Scalars['String']['output']>;
  statusChangeDate?: Maybe<Scalars['DateTime']['output']>;
  statusChangeReason?: Maybe<ReasonCodeType>;
  terminationDate?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated 'UnitPrice' is Depreciated, use 'PricePerUnit' instead. This gives a fuller representation of the decimal value */
  unitPrice: Scalars['Decimal']['output'];
  unitPriceFrequency?: Maybe<UnitPriceFrequencyType>;
  unitType?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type ContractLineChangeOutputType = {
  __typename?: 'ContractLineChangeOutputType';
  annualBillingPeriodValue?: Maybe<Scalars['String']['output']>;
  billingCycleBillingDate?: Maybe<Scalars['DateTime']['output']>;
  billingCycleCreated?: Maybe<Scalars['DateTime']['output']>;
  billingCycleNumber?: Maybe<Scalars['Int']['output']>;
  billingCycleStatus?: Maybe<Scalars['String']['output']>;
  billingCycleUpdated?: Maybe<Scalars['DateTime']['output']>;
  billingInterval?: Maybe<Scalars['String']['output']>;
  billingPeriodValue?: Maybe<Scalars['String']['output']>;
  billingType: Scalars['String']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  contractID: Scalars['Guid']['output'];
  contractLineID: Scalars['Guid']['output'];
  contractedToCustomerAccount?: Maybe<Scalars['String']['output']>;
  contractedToCustomerId?: Maybe<Scalars['Guid']['output']>;
  created: Scalars['DateTime']['output'];
  invoiceToCustomerAccount?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerId?: Maybe<Scalars['Guid']['output']>;
  lastBilledEndDate?: Maybe<Scalars['DateTime']['output']>;
  lastBilledStartDate?: Maybe<Scalars['DateTime']['output']>;
  lineBillingCurrentStatusEndDate?: Maybe<Scalars['DateTime']['output']>;
  lineBillingCurrentStatusStartDate?: Maybe<Scalars['DateTime']['output']>;
  lineBillingStatus?: Maybe<Scalars['String']['output']>;
  lineBillingStatusUpdateComment?: Maybe<Scalars['String']['output']>;
  lineBillingStatusUpdateReasonCode?: Maybe<Scalars['String']['output']>;
  lineBillingStatusUpdateReasonName?: Maybe<Scalars['String']['output']>;
  lineBillingStatusUpdateReference?: Maybe<Scalars['String']['output']>;
  lineBillingStatusUpdated?: Maybe<Scalars['DateTime']['output']>;
  minCharge?: Maybe<Scalars['Decimal']['output']>;
  noFurtherBilling?: Maybe<Scalars['Boolean']['output']>;
  noFurtherBillingDate?: Maybe<Scalars['DateTime']['output']>;
  oppHeaderId?: Maybe<Scalars['String']['output']>;
  oppLineId?: Maybe<Scalars['String']['output']>;
  pricePerUnit: Scalars['String']['output'];
  proRataEndDate?: Maybe<Scalars['DateTime']['output']>;
  productDivision: Scalars['String']['output'];
  productFamily: Scalars['String']['output'];
  productID: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Long']['output']>;
  salesHandoverNumber?: Maybe<Scalars['String']['output']>;
  sfContractLineId?: Maybe<Scalars['String']['output']>;
  shipToCustomerAccount?: Maybe<Scalars['String']['output']>;
  shipToCustomerId?: Maybe<Scalars['Guid']['output']>;
  status: Scalars['String']['output'];
  statusChangeComment?: Maybe<Scalars['String']['output']>;
  stockCode: Scalars['String']['output'];
  stockName: Scalars['String']['output'];
  terminationDate?: Maybe<Scalars['DateTime']['output']>;
  unitPriceFrequency?: Maybe<Scalars['String']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type ContractLineChangeType = {
  __typename?: 'ContractLineChangeType';
  changeType: ChangeTypeEnum;
  changed: ContractLineChangeOutputType;
  changedOn: Scalars['DateTime']['output'];
};

export type ContractLineDataType = {
  contractLineID: Scalars['ID']['input'];
};

export type ContractLineErrorType = {
  __typename?: 'ContractLineErrorType';
  contractLineId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export type ContractLineFilterInput = {
  /** ContractId */
  contractId?: InputMaybe<GuidFilterInput>;
  /** Created */
  created?: InputMaybe<DateTimeFilterInput>;
  /** Id */
  id?: InputMaybe<GuidFilterInput>;
  /** IsFromMerge */
  isFromMerge?: InputMaybe<BooleanFilterInput>;
  /** MergedLineId */
  mergedLineId?: InputMaybe<GuidFilterInput>;
  /** Updated */
  updated?: InputMaybe<DateTimeFilterInput>;
};

export type ContractLineForBulkAddInputType = {
  billingInterval?: InputMaybe<Scalars['String']['input']>;
  billingStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  billingType: Scalars['String']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  invoiceToCustomerAccountNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceToCustomerId?: InputMaybe<Scalars['ID']['input']>;
  isAwaitingApproval?: InputMaybe<Scalars['Boolean']['input']>;
  lineStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  oppHeaderId?: InputMaybe<Scalars['String']['input']>;
  oppLineId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<ContractOriginEnum>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  proRataEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Long']['input']>;
  salesHandoverNumber?: InputMaybe<Scalars['String']['input']>;
  shipToCustomerId?: InputMaybe<Scalars['ID']['input']>;
  stockCode?: InputMaybe<Scalars['String']['input']>;
  unitPrice: Scalars['Decimal']['input'];
  unitPriceFrequency?: InputMaybe<Scalars['String']['input']>;
  unitType?: InputMaybe<Scalars['String']['input']>;
};

export type ContractLineGridFilterInput = {
  annualBillingPeriodValue?: InputMaybe<StringifiedDecimalFilterInput>;
  billingInterval?: InputMaybe<StringFilterInput>;
  billingIntervalMonthsCount?: InputMaybe<IntFilterInput>;
  billingPeriodValue?: InputMaybe<StringifiedDecimalFilterInput>;
  billingType?: InputMaybe<StringFilterInput>;
  bundleDescription?: InputMaybe<StringFilterInput>;
  bundleId?: InputMaybe<GuidFilterInput>;
  comments?: InputMaybe<StringFilterInput>;
  contractBillingStatus?: InputMaybe<ContractBillingStatusEnumEnumFilterInput>;
  contractCurrency?: InputMaybe<StringFilterInput>;
  contractEndDate?: InputMaybe<DateTimeFilterInput>;
  contractId?: InputMaybe<GuidFilterInput>;
  contractLineStatus?: InputMaybe<StringFilterInput>;
  contractNumber?: InputMaybe<StringFilterInput>;
  contractStatus?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  customerAccountManagerName?: InputMaybe<StringFilterInput>;
  customerAddress?: InputMaybe<StringFilterInput>;
  customerCCEmailAddress?: InputMaybe<StringFilterInput>;
  customerCode?: InputMaybe<StringFilterInput>;
  customerContactName?: InputMaybe<StringFilterInput>;
  customerContactPhoneNumber?: InputMaybe<StringFilterInput>;
  customerCountry?: InputMaybe<StringFilterInput>;
  customerEmailAddress?: InputMaybe<StringFilterInput>;
  customerId?: InputMaybe<GuidFilterInput>;
  customerName?: InputMaybe<StringFilterInput>;
  customerPostcode?: InputMaybe<StringFilterInput>;
  customerSalesPersonName?: InputMaybe<StringFilterInput>;
  customerState?: InputMaybe<StringFilterInput>;
  customerTown?: InputMaybe<StringFilterInput>;
  daysBeforeRenewal?: InputMaybe<IntFilterInput>;
  globalRenewalDays?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<GuidFilterInput>;
  invoiceToCustomerAccountManagerName?: InputMaybe<StringFilterInput>;
  invoiceToCustomerAccountNumber?: InputMaybe<StringFilterInput>;
  invoiceToCustomerAddress?: InputMaybe<StringFilterInput>;
  invoiceToCustomerCCEmailAddress?: InputMaybe<StringFilterInput>;
  invoiceToCustomerContactName?: InputMaybe<StringFilterInput>;
  invoiceToCustomerContactPhoneNumber?: InputMaybe<StringFilterInput>;
  invoiceToCustomerCountry?: InputMaybe<StringFilterInput>;
  invoiceToCustomerEmailAddress?: InputMaybe<StringFilterInput>;
  invoiceToCustomerName?: InputMaybe<StringFilterInput>;
  invoiceToCustomerPostcode?: InputMaybe<StringFilterInput>;
  invoiceToCustomerSalesPersonName?: InputMaybe<StringFilterInput>;
  invoiceToCustomerState?: InputMaybe<StringFilterInput>;
  invoiceToCustomerTown?: InputMaybe<StringFilterInput>;
  isFromMerge?: InputMaybe<BooleanFilterInput>;
  lineBillingCurrentStatusEndDate?: InputMaybe<DateTimeFilterInput>;
  lineBillingCurrentStatusStartDate?: InputMaybe<DateTimeFilterInput>;
  lineBillingStatus?: InputMaybe<ContractBillingStatusEnumEnumFilterInput>;
  lineBillingStatusUpdateComment?: InputMaybe<StringFilterInput>;
  lineBillingStatusUpdateReasonCode?: InputMaybe<StringFilterInput>;
  lineBillingStatusUpdateReference?: InputMaybe<StringFilterInput>;
  lineBillingStatusUpdated?: InputMaybe<DateTimeFilterInput>;
  lineStartDate?: InputMaybe<DateTimeFilterInput>;
  mergedLineId?: InputMaybe<GuidFilterInput>;
  minCharge?: InputMaybe<StringifiedDecimalFilterInput>;
  noFurtherBilling?: InputMaybe<BooleanFilterInput>;
  noFurtherBillingDate?: InputMaybe<DateTimeFilterInput>;
  oneEvoContractNumber?: InputMaybe<StringFilterInput>;
  oneEvoMigrated?: InputMaybe<BooleanFilterInput>;
  oneEvoMigrationDate?: InputMaybe<DateTimeFilterInput>;
  oppHeaderId?: InputMaybe<StringFilterInput>;
  oppLineId?: InputMaybe<StringFilterInput>;
  origin?: InputMaybe<ContractOriginPascalCaseEnumFilterInput>;
  originalStartDate?: InputMaybe<DateTimeFilterInput>;
  poCurrency?: InputMaybe<StringFilterInput>;
  poDate?: InputMaybe<DateTimeFilterInput>;
  poEndDate?: InputMaybe<DateTimeFilterInput>;
  poNote?: InputMaybe<StringFilterInput>;
  poNumber?: InputMaybe<StringFilterInput>;
  poRemainingValue?: InputMaybe<StringifiedDecimalFilterInput>;
  poStartDate?: InputMaybe<DateTimeFilterInput>;
  poStatus?: InputMaybe<PurchaseOrderStatusEnumFilterInput>;
  poTotalValue?: InputMaybe<StringifiedDecimalFilterInput>;
  proRataEndDate?: InputMaybe<DateTimeFilterInput>;
  productFamily?: InputMaybe<StringFilterInput>;
  productId?: InputMaybe<GuidFilterInput>;
  quantity?: InputMaybe<LongFilterInput>;
  renewableTerm?: InputMaybe<IntFilterInput>;
  salesHandoverNumber?: InputMaybe<StringFilterInput>;
  shipToCustomerAccountManagerName?: InputMaybe<StringFilterInput>;
  shipToCustomerAccountNumber?: InputMaybe<StringFilterInput>;
  shipToCustomerAddress?: InputMaybe<StringFilterInput>;
  shipToCustomerCCEmailAddress?: InputMaybe<StringFilterInput>;
  shipToCustomerContactName?: InputMaybe<StringFilterInput>;
  shipToCustomerContactPhoneNumber?: InputMaybe<StringFilterInput>;
  shipToCustomerCountry?: InputMaybe<StringFilterInput>;
  shipToCustomerEmailAddress?: InputMaybe<StringFilterInput>;
  shipToCustomerName?: InputMaybe<StringFilterInput>;
  shipToCustomerPostcode?: InputMaybe<StringFilterInput>;
  shipToCustomerSalesPersonName?: InputMaybe<StringFilterInput>;
  shipToCustomerState?: InputMaybe<StringFilterInput>;
  shipToCustomerTown?: InputMaybe<StringFilterInput>;
  statusChangeComment?: InputMaybe<StringFilterInput>;
  statusChangeDate?: InputMaybe<DateTimeFilterInput>;
  statusChangeReason?: InputMaybe<StringFilterInput>;
  statusChangeReasonName?: InputMaybe<StringFilterInput>;
  statusChangeReasonType?: InputMaybe<StringFilterInput>;
  stockCode?: InputMaybe<StringFilterInput>;
  stockName?: InputMaybe<StringFilterInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
  terminationDate?: InputMaybe<DateTimeFilterInput>;
  unitPrice?: InputMaybe<StringifiedDecimalFilterInput>;
  unitPriceFrequency?: InputMaybe<StringFilterInput>;
  unitType?: InputMaybe<StringFilterInput>;
  updated?: InputMaybe<DateTimeFilterInput>;
};

export type ContractLineGridOutput = {
  __typename?: 'ContractLineGridOutput';
  annualBillingPeriodValue?: Maybe<Scalars['String']['output']>;
  billingInterval?: Maybe<Scalars['String']['output']>;
  billingIntervalMonthsCount?: Maybe<Scalars['Int']['output']>;
  billingPeriodValue?: Maybe<Scalars['String']['output']>;
  billingType?: Maybe<Scalars['String']['output']>;
  bundleDescription?: Maybe<Scalars['String']['output']>;
  bundleHideInvoiceLines?: Maybe<Scalars['Boolean']['output']>;
  bundleHideInvoiceValues?: Maybe<Scalars['Boolean']['output']>;
  bundleId?: Maybe<Scalars['ID']['output']>;
  bundleSoftwareCompany?: Maybe<Scalars['String']['output']>;
  bundleType?: Maybe<BundleTypeEnum>;
  comments?: Maybe<Scalars['String']['output']>;
  contractCurrency?: Maybe<Scalars['String']['output']>;
  contractId: Scalars['Guid']['output'];
  contractLineStatus?: Maybe<Scalars['String']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  contractStatus?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  customerAccountManagerName?: Maybe<Scalars['String']['output']>;
  customerAddress?: Maybe<Scalars['String']['output']>;
  customerCCEmailAddress?: Maybe<Scalars['String']['output']>;
  customerCode?: Maybe<Scalars['String']['output']>;
  customerContactName?: Maybe<Scalars['String']['output']>;
  customerContactPhoneNumber?: Maybe<Scalars['String']['output']>;
  customerCountry?: Maybe<Scalars['String']['output']>;
  customerEmailAddress?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['Guid']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  customerPostcode?: Maybe<Scalars['String']['output']>;
  customerSalesPersonName?: Maybe<Scalars['String']['output']>;
  customerState?: Maybe<Scalars['String']['output']>;
  customerTown?: Maybe<Scalars['String']['output']>;
  id: Scalars['Guid']['output'];
  invoiceToCustomerAccountManagerName?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerAccountNumber?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerAddress?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerCCEmailAddress?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerContactName?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerContactPhoneNumber?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerCountry?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerEmailAddress?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerId: Scalars['Guid']['output'];
  invoiceToCustomerName?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerPostcode?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerSalesPersonName?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerState?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerTown?: Maybe<Scalars['String']['output']>;
  isFromMerge?: Maybe<Scalars['Boolean']['output']>;
  lastBillingEndDate?: Maybe<Scalars['DateTime']['output']>;
  lastBillingStartDate?: Maybe<Scalars['DateTime']['output']>;
  lastSOEndDate?: Maybe<Scalars['DateTime']['output']>;
  lastSOQuantity?: Maybe<Scalars['Long']['output']>;
  lastSOStartDate?: Maybe<Scalars['DateTime']['output']>;
  lastSOTotalValue?: Maybe<Scalars['String']['output']>;
  lineBillingCurrentStatusEndDate?: Maybe<Scalars['DateTime']['output']>;
  lineBillingCurrentStatusStartDate?: Maybe<Scalars['DateTime']['output']>;
  lineBillingStatus?: Maybe<ContractBillingStatusPascalCaseEnum>;
  lineBillingStatusUpdateComment?: Maybe<Scalars['String']['output']>;
  lineBillingStatusUpdateReasonCode?: Maybe<Scalars['String']['output']>;
  lineBillingStatusUpdateReference?: Maybe<Scalars['String']['output']>;
  lineBillingStatusUpdated?: Maybe<Scalars['DateTime']['output']>;
  lineStartDate?: Maybe<Scalars['DateTime']['output']>;
  mergedLineId?: Maybe<Scalars['Guid']['output']>;
  minCharge?: Maybe<Scalars['String']['output']>;
  nextBillingEndDate?: Maybe<Scalars['DateTime']['output']>;
  nextBillingStartDate?: Maybe<Scalars['DateTime']['output']>;
  nextInvoiceDate?: Maybe<Scalars['DateTime']['output']>;
  nextSoIssueDate?: Maybe<Scalars['DateTime']['output']>;
  noFurtherBilling?: Maybe<Scalars['Boolean']['output']>;
  noFurtherBillingDate?: Maybe<Scalars['DateTime']['output']>;
  oneEvoContractNumber?: Maybe<Scalars['String']['output']>;
  oneEvoMigrated: Scalars['Boolean']['output'];
  oneEvoMigrationDate?: Maybe<Scalars['DateTime']['output']>;
  oppHeaderId?: Maybe<Scalars['String']['output']>;
  oppLineId?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<ContractOriginEnum>;
  originalStartDate?: Maybe<Scalars['DateTime']['output']>;
  poCurrency?: Maybe<Scalars['String']['output']>;
  poDate?: Maybe<Scalars['DateTime']['output']>;
  poEndDate?: Maybe<Scalars['DateTime']['output']>;
  poNote?: Maybe<Scalars['String']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  poRemainingValue?: Maybe<Scalars['String']['output']>;
  poStartDate?: Maybe<Scalars['DateTime']['output']>;
  poStatus?: Maybe<PurchaseOrderStatusEnum>;
  poTotalValue?: Maybe<Scalars['String']['output']>;
  predictedAnnualValue?: Maybe<Scalars['String']['output']>;
  predictedSOEndDate?: Maybe<Scalars['DateTime']['output']>;
  predictedSOInvoiceDate?: Maybe<Scalars['DateTime']['output']>;
  predictedSOStartDate?: Maybe<Scalars['DateTime']['output']>;
  proRataEndDate?: Maybe<Scalars['DateTime']['output']>;
  productFamily?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['Guid']['output']>;
  quantity?: Maybe<Scalars['Long']['output']>;
  salesHandoverNumber?: Maybe<Scalars['String']['output']>;
  shipToCustomerAccountManagerName?: Maybe<Scalars['String']['output']>;
  shipToCustomerAccountNumber?: Maybe<Scalars['String']['output']>;
  shipToCustomerAddress?: Maybe<Scalars['String']['output']>;
  shipToCustomerCCEmailAddress?: Maybe<Scalars['String']['output']>;
  shipToCustomerContactName?: Maybe<Scalars['String']['output']>;
  shipToCustomerContactPhoneNumber?: Maybe<Scalars['String']['output']>;
  shipToCustomerCountry?: Maybe<Scalars['String']['output']>;
  shipToCustomerEmailAddress?: Maybe<Scalars['String']['output']>;
  shipToCustomerId: Scalars['Guid']['output'];
  shipToCustomerName?: Maybe<Scalars['String']['output']>;
  shipToCustomerPostcode?: Maybe<Scalars['String']['output']>;
  shipToCustomerSalesPersonName?: Maybe<Scalars['String']['output']>;
  shipToCustomerState?: Maybe<Scalars['String']['output']>;
  shipToCustomerTown?: Maybe<Scalars['String']['output']>;
  statusChangeComment?: Maybe<Scalars['String']['output']>;
  statusChangeDate?: Maybe<Scalars['DateTime']['output']>;
  statusChangeReason?: Maybe<Scalars['String']['output']>;
  statusChangeReasonName?: Maybe<Scalars['String']['output']>;
  statusChangeReasonType?: Maybe<Scalars['String']['output']>;
  stockCode?: Maybe<Scalars['String']['output']>;
  stockName?: Maybe<Scalars['String']['output']>;
  terminationDate?: Maybe<Scalars['DateTime']['output']>;
  unitPrice: Scalars['String']['output'];
  unitPriceFrequency?: Maybe<Scalars['String']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection from an object to a list of objects of type `ContractLineGridOutput`. */
export type ContractLineGridOutputConnection = {
  __typename?: 'ContractLineGridOutputConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<ContractLineGridOutputEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<ContractLineGridOutput>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `ContractLineGridOutput`. */
export type ContractLineGridOutputEdge = {
  __typename?: 'ContractLineGridOutputEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ContractLineGridOutput>;
};

export enum ContractLineGridSort {
  AnnualBillingPeriodValue = 'AnnualBillingPeriodValue',
  BillingInterval = 'BillingInterval',
  BillingIntervalMonthsCount = 'BillingIntervalMonthsCount',
  BillingPeriodValue = 'BillingPeriodValue',
  BillingType = 'BillingType',
  BundleDescription = 'BundleDescription',
  BundleId = 'BundleId',
  Comments = 'Comments',
  ContractCurrency = 'ContractCurrency',
  ContractId = 'ContractId',
  ContractLineStatus = 'ContractLineStatus',
  ContractNumber = 'ContractNumber',
  ContractStatus = 'ContractStatus',
  Created = 'Created',
  CustomerAccountManagerName = 'CustomerAccountManagerName',
  CustomerAddress = 'CustomerAddress',
  CustomerCCEmailAddress = 'CustomerCCEmailAddress',
  CustomerCode = 'CustomerCode',
  CustomerContactName = 'CustomerContactName',
  CustomerContactPhoneNumber = 'CustomerContactPhoneNumber',
  CustomerCountry = 'CustomerCountry',
  CustomerEmailAddress = 'CustomerEmailAddress',
  CustomerId = 'CustomerId',
  CustomerName = 'CustomerName',
  CustomerPostcode = 'CustomerPostcode',
  CustomerSalesPersonName = 'CustomerSalesPersonName',
  CustomerState = 'CustomerState',
  CustomerTown = 'CustomerTown',
  Id = 'Id',
  InvoiceToCustomerAccountManagerName = 'InvoiceToCustomerAccountManagerName',
  InvoiceToCustomerAccountNumber = 'InvoiceToCustomerAccountNumber',
  InvoiceToCustomerAddress = 'InvoiceToCustomerAddress',
  InvoiceToCustomerCCEmailAddress = 'InvoiceToCustomerCCEmailAddress',
  InvoiceToCustomerContactName = 'InvoiceToCustomerContactName',
  InvoiceToCustomerContactPhoneNumber = 'InvoiceToCustomerContactPhoneNumber',
  InvoiceToCustomerCountry = 'InvoiceToCustomerCountry',
  InvoiceToCustomerEmailAddress = 'InvoiceToCustomerEmailAddress',
  InvoiceToCustomerName = 'InvoiceToCustomerName',
  InvoiceToCustomerPostcode = 'InvoiceToCustomerPostcode',
  InvoiceToCustomerSalesPersonName = 'InvoiceToCustomerSalesPersonName',
  InvoiceToCustomerState = 'InvoiceToCustomerState',
  InvoiceToCustomerTown = 'InvoiceToCustomerTown',
  IsFromMerge = 'IsFromMerge',
  LineBillingCurrentStatusEndDate = 'LineBillingCurrentStatusEndDate',
  LineBillingCurrentStatusStartDate = 'LineBillingCurrentStatusStartDate',
  LineBillingStatus = 'LineBillingStatus',
  LineBillingStatusUpdateComment = 'LineBillingStatusUpdateComment',
  LineBillingStatusUpdateReasonCode = 'LineBillingStatusUpdateReasonCode',
  LineBillingStatusUpdateReference = 'LineBillingStatusUpdateReference',
  LineBillingStatusUpdated = 'LineBillingStatusUpdated',
  LineStartDate = 'LineStartDate',
  MergedLineId = 'MergedLineId',
  MinCharge = 'MinCharge',
  NoFurtherBilling = 'NoFurtherBilling',
  NoFurtherBillingDate = 'NoFurtherBillingDate',
  OneEvoContractNumber = 'OneEvoContractNumber',
  OneEvoMigrated = 'OneEvoMigrated',
  OneEvoMigrationDate = 'OneEvoMigrationDate',
  OppHeaderId = 'OppHeaderId',
  OppLineId = 'OppLineId',
  Origin = 'Origin',
  OriginalStartDate = 'OriginalStartDate',
  PoCurrency = 'PoCurrency',
  PoDate = 'PoDate',
  PoEndDate = 'PoEndDate',
  PoNote = 'PoNote',
  PoNumber = 'PoNumber',
  PoRemainingValue = 'PoRemainingValue',
  PoStartDate = 'PoStartDate',
  PoStatus = 'PoStatus',
  PoTotalValue = 'PoTotalValue',
  ProRataEndDate = 'ProRataEndDate',
  ProductFamily = 'ProductFamily',
  ProductId = 'ProductId',
  Quantity = 'Quantity',
  SalesHandoverNumber = 'SalesHandoverNumber',
  ShipToCustomerAccountManagerName = 'ShipToCustomerAccountManagerName',
  ShipToCustomerAccountNumber = 'ShipToCustomerAccountNumber',
  ShipToCustomerAddress = 'ShipToCustomerAddress',
  ShipToCustomerCCEmailAddress = 'ShipToCustomerCCEmailAddress',
  ShipToCustomerContactName = 'ShipToCustomerContactName',
  ShipToCustomerContactPhoneNumber = 'ShipToCustomerContactPhoneNumber',
  ShipToCustomerCountry = 'ShipToCustomerCountry',
  ShipToCustomerEmailAddress = 'ShipToCustomerEmailAddress',
  ShipToCustomerName = 'ShipToCustomerName',
  ShipToCustomerPostcode = 'ShipToCustomerPostcode',
  ShipToCustomerSalesPersonName = 'ShipToCustomerSalesPersonName',
  ShipToCustomerState = 'ShipToCustomerState',
  ShipToCustomerTown = 'ShipToCustomerTown',
  StatusChangeComment = 'StatusChangeComment',
  StatusChangeDate = 'StatusChangeDate',
  StatusChangeReason = 'StatusChangeReason',
  StatusChangeReasonName = 'StatusChangeReasonName',
  StatusChangeReasonType = 'StatusChangeReasonType',
  StockCode = 'StockCode',
  StockName = 'StockName',
  TerminationDate = 'TerminationDate',
  UnitPrice = 'UnitPrice',
  UnitPriceFrequency = 'UnitPriceFrequency',
  UnitType = 'UnitType',
  Updated = 'Updated',
}

export type ContractLineGridSortSortByInput = {
  /** Field */
  field?: InputMaybe<ContractLineGridSort>;
  order: OrderType;
};

export type ContractLineInputType = {
  billingInterval?: InputMaybe<Scalars['String']['input']>;
  billingStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  billingType: Scalars['String']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  contractID: Scalars['ID']['input'];
  invoiceToCustomerId?: InputMaybe<Scalars['ID']['input']>;
  isAwaitingApproval?: InputMaybe<Scalars['Boolean']['input']>;
  lineStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  oppHeaderId?: InputMaybe<Scalars['String']['input']>;
  oppLineId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<ContractOriginEnum>;
  proRataEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Long']['input']>;
  salesHandoverNumber?: InputMaybe<Scalars['String']['input']>;
  shipToCustomerId?: InputMaybe<Scalars['ID']['input']>;
  stockCode?: InputMaybe<Scalars['String']['input']>;
  unitPrice: Scalars['Decimal']['input'];
  unitPriceFrequency?: InputMaybe<Scalars['String']['input']>;
  unitType?: InputMaybe<Scalars['String']['input']>;
};

export enum ContractLineSort {
  CREATED = 'CREATED',
  ID = 'ID',
  IS_FROM_MERGE = 'IS_FROM_MERGE',
  MERGED_LINE_ID = 'MERGED_LINE_ID',
  UPDATED = 'UPDATED',
}

export type ContractLineSortSortByInput = {
  /** Field */
  field?: InputMaybe<ContractLineSort>;
  order: OrderType;
};

export type ContractLineStatusType = {
  __typename?: 'ContractLineStatusType';
  formattedStatus: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ContractLineToUpdateType = {
  contractLineID: Scalars['ID']['input'];
  lineStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  quantity?: InputMaybe<Scalars['Long']['input']>;
  salesHandoverNumber?: InputMaybe<Scalars['String']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitType?: InputMaybe<Scalars['String']['input']>;
};

export type ContractLinesInputType = {
  contractID: Scalars['ID']['input'];
  contractLines: Array<ContractLineForBulkAddInputType>;
};

export type ContractNoteInputType = {
  contractID: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type ContractNoteType = {
  __typename?: 'ContractNoteType';
  contractID: Scalars['ID']['output'];
  contractNoteID: Scalars['ID']['output'];
  created: Scalars['DateTime']['output'];
  text: Scalars['String']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
  userID: Scalars['ID']['output'];
};

export enum ContractOriginEnum {
  AutoAttach = 'AutoAttach',
  CnB = 'CnB',
  Dimensions = 'Dimensions',
  Import = 'Import',
  OneEvo = 'OneEvo',
}

export type ContractOriginPascalCaseEnumFilterInput = {
  containsValues?: InputMaybe<Array<InputMaybe<ContractOriginEnum>>>;
  eq?: InputMaybe<ContractOriginEnum>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<ContractOriginEnum>;
  notContainsValues?: InputMaybe<Array<InputMaybe<ContractOriginEnum>>>;
};

export type ContractOutput = {
  __typename?: 'ContractOutput';
  accountManagerName?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  billingStatus?: Maybe<ContractBillingStatusPascalCaseEnum>;
  billingType?: Maybe<Array<Scalars['String']['output']>>;
  calculatedTerm?: Maybe<Scalars['String']['output']>;
  ccEmailAddress?: Maybe<Scalars['String']['output']>;
  clientDatabaseReference?: Maybe<Scalars['String']['output']>;
  consolidateBilling?: Maybe<Scalars['Boolean']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhoneNumber?: Maybe<Scalars['String']['output']>;
  contractEndDate?: Maybe<Scalars['DateTime']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  contractStartDate?: Maybe<Scalars['DateTime']['output']>;
  contractStatus?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customerAccountNumber?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['Guid']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  directDebit?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  externalContractId?: Maybe<Scalars['String']['output']>;
  hasContractLines?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Guid']['output'];
  invoiceToAccountManagerName?: Maybe<Scalars['String']['output']>;
  invoiceToAddress?: Maybe<Scalars['String']['output']>;
  invoiceToCCEmailAddress?: Maybe<Scalars['String']['output']>;
  invoiceToContactName?: Maybe<Scalars['String']['output']>;
  invoiceToContactPhoneNumber?: Maybe<Scalars['String']['output']>;
  invoiceToCountry?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerAccountNumber?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerId: Scalars['Guid']['output'];
  invoiceToCustomerName?: Maybe<Scalars['String']['output']>;
  invoiceToEmailAddress?: Maybe<Scalars['String']['output']>;
  invoiceToPostCode?: Maybe<Scalars['String']['output']>;
  invoiceToSalesPersonName?: Maybe<Scalars['String']['output']>;
  invoiceToState?: Maybe<Scalars['String']['output']>;
  invoiceToTown?: Maybe<Scalars['String']['output']>;
  mainProductFamily?: Maybe<Scalars['String']['output']>;
  oneEvoContractNumber?: Maybe<Scalars['String']['output']>;
  oneEvoMigrated: Scalars['Boolean']['output'];
  oneEvoMigrationDate?: Maybe<Scalars['DateTime']['output']>;
  origin?: Maybe<ContractOriginEnum>;
  pONumber?: Maybe<Scalars['String']['output']>;
  pONumberEndDate?: Maybe<Scalars['DateTime']['output']>;
  pONumberStartDate?: Maybe<Scalars['DateTime']['output']>;
  parentCustomerAccountNumber?: Maybe<Scalars['String']['output']>;
  parentCustomerName?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  productFamily?: Maybe<Array<Scalars['String']['output']>>;
  renewableTerm?: Maybe<Scalars['Int']['output']>;
  rolloverDate?: Maybe<Scalars['DateTime']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  shipToAccountManagerName?: Maybe<Scalars['String']['output']>;
  shipToAddress?: Maybe<Scalars['String']['output']>;
  shipToCCEmailAddress?: Maybe<Scalars['String']['output']>;
  shipToContactName?: Maybe<Scalars['String']['output']>;
  shipToContactPhoneNumber?: Maybe<Scalars['String']['output']>;
  shipToCountry?: Maybe<Scalars['String']['output']>;
  shipToCustomerAccountNumber?: Maybe<Scalars['String']['output']>;
  shipToCustomerId: Scalars['Guid']['output'];
  shipToCustomerName?: Maybe<Scalars['String']['output']>;
  shipToEmailAddress?: Maybe<Scalars['String']['output']>;
  shipToPostCode?: Maybe<Scalars['String']['output']>;
  shipToSalesPersonName?: Maybe<Scalars['String']['output']>;
  shipToState?: Maybe<Scalars['String']['output']>;
  shipToTown?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Scalars['Int']['output']>;
  totalBillingPeriodValue?: Maybe<Scalars['String']['output']>;
  totalContractValue?: Maybe<Scalars['String']['output']>;
  town?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection from an object to a list of objects of type `ContractOutput`. */
export type ContractOutputConnection = {
  __typename?: 'ContractOutputConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<ContractOutputEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<ContractOutput>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `ContractOutput`. */
export type ContractOutputEdge = {
  __typename?: 'ContractOutputEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ContractOutput>;
};

export type ContractPurchaseOrderType = {
  __typename?: 'ContractPurchaseOrderType';
  pONumber?: Maybe<Scalars['String']['output']>;
  pONumberEndDate?: Maybe<Scalars['DateTime']['output']>;
  pONumberRequired: Scalars['Boolean']['output'];
  pONumberStartDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ContractRenewalInput = {
  contractId: Scalars['ID']['input'];
  daysBeforeRenewal?: InputMaybe<Scalars['Int']['input']>;
};

export enum ContractSort {
  AccountManagerName = 'AccountManagerName',
  Address = 'Address',
  BillingStatus = 'BillingStatus',
  BillingType = 'BillingType',
  CCEmailAddress = 'CCEmailAddress',
  CalculatedTerm = 'CalculatedTerm',
  ConsolidateBilling = 'ConsolidateBilling',
  ContactName = 'ContactName',
  ContactPhoneNumber = 'ContactPhoneNumber',
  ContractEndDate = 'ContractEndDate',
  ContractNumber = 'ContractNumber',
  ContractStartDate = 'ContractStartDate',
  ContractStatus = 'ContractStatus',
  Country = 'Country',
  Created = 'Created',
  CustomerAccountNumber = 'CustomerAccountNumber',
  CustomerId = 'CustomerId',
  CustomerName = 'CustomerName',
  DirectDebit = 'DirectDebit',
  EmailAddress = 'EmailAddress',
  ExternalContractId = 'ExternalContractId',
  Id = 'Id',
  InvoiceToAccountManagerName = 'InvoiceToAccountManagerName',
  InvoiceToAddress = 'InvoiceToAddress',
  InvoiceToCCEmailAddress = 'InvoiceToCCEmailAddress',
  InvoiceToContactName = 'InvoiceToContactName',
  InvoiceToContactPhoneNumber = 'InvoiceToContactPhoneNumber',
  InvoiceToCountry = 'InvoiceToCountry',
  InvoiceToCustomerAccountNumber = 'InvoiceToCustomerAccountNumber',
  InvoiceToCustomerName = 'InvoiceToCustomerName',
  InvoiceToEmailAddress = 'InvoiceToEmailAddress',
  InvoiceToPostCode = 'InvoiceToPostCode',
  InvoiceToSalesPersonName = 'InvoiceToSalesPersonName',
  InvoiceToState = 'InvoiceToState',
  InvoiceToTown = 'InvoiceToTown',
  OneEvoContractNumber = 'OneEvoContractNumber',
  OneEvoMigrated = 'OneEvoMigrated',
  OneEvoMigrationDate = 'OneEvoMigrationDate',
  Origin = 'Origin',
  PONumber = 'PONumber',
  PONumberEndDate = 'PONumberEndDate',
  PONumberStartDate = 'PONumberStartDate',
  PostCode = 'PostCode',
  ProductFamily = 'ProductFamily',
  RenewableTerm = 'RenewableTerm',
  RolloverDate = 'RolloverDate',
  SalesPersonName = 'SalesPersonName',
  ShipToAccountManagerName = 'ShipToAccountManagerName',
  ShipToAddress = 'ShipToAddress',
  ShipToCCEmailAddress = 'ShipToCCEmailAddress',
  ShipToContactName = 'ShipToContactName',
  ShipToContactPhoneNumber = 'ShipToContactPhoneNumber',
  ShipToCountry = 'ShipToCountry',
  ShipToCustomerAccountNumber = 'ShipToCustomerAccountNumber',
  ShipToCustomerName = 'ShipToCustomerName',
  ShipToEmailAddress = 'ShipToEmailAddress',
  ShipToPostCode = 'ShipToPostCode',
  ShipToSalesPersonName = 'ShipToSalesPersonName',
  ShipToState = 'ShipToState',
  ShipToTown = 'ShipToTown',
  State = 'State',
  Term = 'Term',
  TotalBillingPeriodValue = 'TotalBillingPeriodValue',
  TotalContractValue = 'TotalContractValue',
  Town = 'Town',
  Updated = 'Updated',
}

export type ContractSortSortByInput = {
  /** Field */
  field?: InputMaybe<ContractSort>;
  order: OrderType;
};

export enum ContractStatusEnum {
  Active = 'Active',
  ActiveDNR = 'ActiveDNR',
  AwaitingApproval = 'AwaitingApproval',
  Cancelled = 'Cancelled',
  Expired = 'Expired',
  Inactive = 'Inactive',
  Merged = 'Merged',
  Terminated = 'Terminated',
  Terminating = 'Terminating',
}

export type ContractStatusType = {
  __typename?: 'ContractStatusType';
  formattedStatus: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ContractTermsAndConditions = {
  __typename?: 'ContractTermsAndConditions';
  breakClauseAdditionalInfo?: Maybe<Scalars['String']['output']>;
  breakClauseEnabled: Scalars['Boolean']['output'];
  breakClauseReviewDate?: Maybe<Scalars['DateTime']['output']>;
  breakClauseUpdatedBy?: Maybe<Scalars['ID']['output']>;
  breakClauseUpdatedDate?: Maybe<Scalars['DateTime']['output']>;
  cancellationAdditionalInfo?: Maybe<Scalars['String']['output']>;
  cancellationUpdatedBy?: Maybe<Scalars['ID']['output']>;
  cancellationUpdatedDate?: Maybe<Scalars['DateTime']['output']>;
  contractId: Scalars['ID']['output'];
  fixedTermAdditionalInfo?: Maybe<Scalars['String']['output']>;
  fixedTermReviewDate?: Maybe<Scalars['DateTime']['output']>;
  fixedTermUpdatedBy?: Maybe<Scalars['ID']['output']>;
  fixedTermUpdatedDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  noticePeriodType: NoticePeriodTypeEnum;
  specialContractType: SpecialContractTypeEnum;
};

export type ContractType = {
  __typename?: 'ContractType';
  billToParent: Scalars['Boolean']['output'];
  billing: ContractBillingType;
  billingType: Array<Scalars['String']['output']>;
  calculatedTerm: Scalars['String']['output'];
  clientDatabase?: Maybe<ClientDatabaseType>;
  clientDatabaseReference?: Maybe<Scalars['String']['output']>;
  consolidateBilling: Scalars['Boolean']['output'];
  contractEndDate: Scalars['DateTime']['output'];
  contractID: Scalars['ID']['output'];
  contractLines: PaginatedContractLines;
  contractNotes: PaginatedContractNotes;
  contractNumber: Scalars['String']['output'];
  contractStartDate: Scalars['DateTime']['output'];
  contractUpliftSettings?: Maybe<ContractUpliftSettingsType>;
  contractedToCustomerAccount?: Maybe<Scalars['String']['output']>;
  contractedToCustomerId?: Maybe<Scalars['Guid']['output']>;
  created: Scalars['DateTime']['output'];
  currency: CurrencyType;
  customer: CustomerType;
  daysBeforeRenewal?: Maybe<Scalars['Int']['output']>;
  defaultInvoiceToCustomerAccount?: Maybe<Scalars['String']['output']>;
  defaultInvoiceToCustomerId?: Maybe<Scalars['Guid']['output']>;
  defaultShipToCustomerAccount?: Maybe<Scalars['String']['output']>;
  defaultShipToCustomerId?: Maybe<Scalars['Guid']['output']>;
  directDebit?: Maybe<DirectDebitType>;
  displaySettings: DisplaySettingsType;
  divertCustomer?: Maybe<CustomerType>;
  externalContractID?: Maybe<Scalars['String']['output']>;
  initialTermPassed?: Maybe<Scalars['Boolean']['output']>;
  invoiceToCustomer: CustomerType;
  mainProductFamily?: Maybe<Scalars['String']['output']>;
  nextUpliftDate?: Maybe<Scalars['DateTime']['output']>;
  oneEvoContractNumber?: Maybe<Scalars['String']['output']>;
  oneEvoMigrated: Scalars['Boolean']['output'];
  oneEvoMigrationDate?: Maybe<Scalars['DateTime']['output']>;
  origin?: Maybe<ContractOriginEnum>;
  productFamily: Array<Scalars['String']['output']>;
  purchaseOrder?: Maybe<ContractPurchaseOrderType>;
  renewableTerm: Scalars['Int']['output'];
  reseller: Scalars['Boolean']['output'];
  rolloverDate?: Maybe<Scalars['DateTime']['output']>;
  sfContractId?: Maybe<Scalars['String']['output']>;
  shipToCustomer: CustomerType;
  status: ContractStatusType;
  term: Scalars['Int']['output'];
  totalBillingPeriodValue: Scalars['String']['output'];
  totalContractValue: Scalars['String']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
  upliftExemption: ContractUpliftExemptionType;
};

export type ContractTypecontractLinesArgs = {
  billingTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ContractTypecontractNotesArgs = {
  input: GetPaginatedContractNotesInputType;
};

export type ContractUpliftCapInputType = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  modifier1: UpliftModifierEnum;
  modifier2?: InputMaybe<UpliftModifierEnum>;
  rate1?: InputMaybe<ContractUpliftCapRateInputType>;
  rate2?: InputMaybe<ContractUpliftCapRateInputType>;
  rate3?: InputMaybe<ContractUpliftCapRateInputType>;
};

export type ContractUpliftCapRateInputType = {
  fixedValue?: InputMaybe<Scalars['Decimal']['input']>;
  indexId?: InputMaybe<Scalars['ID']['input']>;
  type: UpliftCapRateTypeEnum;
};

export type ContractUpliftCapsInputType = {
  existingUpliftCap?: InputMaybe<ContractUpliftCapInputType>;
  furtherUpliftCap?: InputMaybe<ContractUpliftCapInputType>;
};

export type ContractUpliftCapsOutput = {
  __typename?: 'ContractUpliftCapsOutput';
  existingUpliftCap?: Maybe<UpliftCap>;
  furtherUpliftCap?: Maybe<UpliftCap>;
};

export type ContractUpliftExemptionType = {
  __typename?: 'ContractUpliftExemptionType';
  currentStatusEndDate?: Maybe<Scalars['DateTime']['output']>;
  reasonCode?: Maybe<ReasonCodeType>;
  status: ContractUpliftStatusEnum;
  /** @deprecated This field is depreciated use 'reasonCode' */
  statusUpdateReasonCode?: Maybe<Scalars['String']['output']>;
  statusUpdated?: Maybe<Scalars['DateTime']['output']>;
};

export type ContractUpliftSettingsType = {
  __typename?: 'ContractUpliftSettingsType';
  notes?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
  upliftType?: Maybe<UpliftType>;
  validThrough?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Decimal']['output']>;
};

export enum ContractUpliftStatusEnum {
  EXEMPTED = 'EXEMPTED',
  ON = 'ON',
}

export type ContractVarBIllingSummaryOutputType = {
  __typename?: 'ContractVarBIllingSummaryOutputType';
  lastAnnualVarBillingValue: Scalars['String']['output'];
  predictedAnnualVarBillingValue: Scalars['String']['output'];
};

export type ContractWithContractLinesInputType = {
  contractId: Scalars['ID']['input'];
  contractLines: Array<ContractLineDataType>;
};

export type ContractsAndBillingMutation = {
  __typename?: 'ContractsAndBillingMutation';
  abandonSalesOrderByBillingCycle?: Maybe<SalesOrderType>;
  abandonUsageHeader: UsageHeader;
  addContractNote: ContractNoteType;
  addProductMergeDefault: ProductMergeDefaultOutputType;
  addPurchaseOrder: PurchaseOrderOutputType;
  addUpliftIndex: UpliftIndex;
  addUpliftRatesToIndex: UpliftIndex;
  addVerifiableField: VerifiableFieldType;
  approveContractLines: Array<ContractLineByBillingCyclesType>;
  archiveUsageHeader: UsageHeader;
  batchUpliftContractLines: BulkUpliftContractLinesPayload;
  bulkAssignPurchaseOrder?: Maybe<SucceededResultGraphType>;
  bulkCancelUplifts: BulkCancelUpliftsResponseType;
  bulkDeletePurchaseOrder?: Maybe<SucceededResultGraphType>;
  bulkUnassignPurchaseOrder?: Maybe<SucceededResultGraphType>;
  bulkUpdateContractLineInvoiceToCustomer: Array<ContractLineByBillingCyclesType>;
  bulkUpdateContractLineShipToCustomer: Array<ContractLineByBillingCyclesType>;
  bulkUpdateContractLines: BulkUpdateContractLinesResponseType;
  bulkUpdateProRataEndDate?: Maybe<BulkUpdateProRataEndDateResponseType>;
  cancelContractLines?: Maybe<Array<Maybe<ContractLineByBillingCyclesType>>>;
  config?: Maybe<ConfigMutations>;
  createContract: ContractType;
  createContractLine: ContractLineByBillingCyclesType;
  createContractLines: Array<Maybe<ContractLineByBillingCyclesType>>;
  createCustomer: CustomerType;
  createFullContract: ContractType;
  createManualSalesOrderByBillingCycle?: Maybe<SalesOrderType>;
  createOrAssignBundle: BundleOutput;
  createProduct: ProductType;
  createReasonCode: ReasonCodeType;
  createSearchTag?: Maybe<SearchTagType>;
  createUsageHeader: UsageHeader;
  deleteProductMergeDefault: DeleteProductMergeDefaultResultType;
  deleteSearch?: Maybe<SucceededResultGraphType>;
  deleteUpliftIndex: Scalars['Boolean']['output'];
  deleteUpliftIndexRates: Scalars['Boolean']['output'];
  deleteUserConfiguration?: Maybe<SucceededResultGraphType>;
  dnrContractLines?: Maybe<Array<Maybe<ContractLineByBillingCyclesType>>>;
  editPurchaseOrder: PurchaseOrderOutputType;
  exemptFromUplift: ContractType;
  /** General */
  general?: Maybe<GeneralMutations>;
  ignoreBillingCycle: IgnoreBillingCycleResult;
  ignoreBillingCycles: IgnoreBillingCyclesResult;
  ignoreUsageDetails: UsageHeader;
  instantPushSalesOrderByBillingCycle?: Maybe<SalesOrderType>;
  matchUsageDetails: UsageHeader;
  mergeCustomers: CustomerType;
  migrateContractsToOneEvo: Array<ContractType>;
  pauseBilling: ContractType;
  /** Pause billing for a list of contract lines */
  pauseContractLines: Array<ContractLineByBillingCyclesType>;
  processUsageDetails: UsageHeader;
  raiseProformaByBillingCycles: RaiseProformaResultType;
  removeFieldVerification: FieldVerificationType;
  removeUpliftExemption: ContractType;
  removeVerifiableField: Scalars['Boolean']['output'];
  restoreUsageDetails: UsageHeader;
  resumeBilling: ContractType;
  /** Resume billing for a list of contract lines */
  resumeContractLines: Array<ContractLineByBillingCyclesType>;
  revertOneEvoMigration: Array<ContractType>;
  saveSearch?: Maybe<SearchRowKeyResultGraphType>;
  terminateContractLines?: Maybe<Array<Maybe<ContractLineByBillingCyclesType>>>;
  toggleBillToParent: ContractType;
  toggleConsolidateBilling: ContractType;
  toggleHidingContractLines: ToggleHidingContractLinesPayload;
  togglePONumberRequired: ContractType;
  toggleReasonCode: ReasonCodeType;
  toggleReseller: ContractType;
  triggerResendSalesOrdersByBillingCycles?: Maybe<TriggerResendSalesOrdersResultType>;
  unbundle?: Maybe<SucceededResultGraphType>;
  updateBundle: BundleOutput;
  updateContract: ContractType;
  updateContractAdminData?: Maybe<UpdateContractAdminDataResponseType>;
  updateContractClientDatabaseReference: ContractClientDatabaseReferenceType;
  updateContractCustomer: ContractType;
  updateContractLine: ContractLineByBillingCyclesType;
  updateContractLines: Array<ContractLineByBillingCyclesType>;
  updateContractLinesBillingCyclesCadence: Array<ContractLineByBillingCyclesType>;
  updateContractMessage: UpdateContractMessagePayload;
  updateContractRenewal: ContractType;
  updateContractTermsAndConditions: ContractTermsAndConditions;
  updateContractUpliftSettings: ContractType;
  updateCustomer: CustomerType;
  updateDNRContractLines: Array<ContractLineByBillingCyclesType>;
  updateDirectDebit: ContractType;
  updateDivertCustomer: ContractType;
  updateFullContractLine: ContractLineByBillingCyclesType;
  updateInvoiceToCustomer: ContractType;
  updatePONumber: ContractType;
  updateParentCustomer: CustomerType;
  updatePauseBilling: ContractType;
  /** Update pause billing details for a list of contract lines */
  updatePauseBillingContractLines: Array<ContractLineByBillingCyclesType>;
  updateProduct: ProductType;
  updateProductDefaultBillingType: ProductType;
  updateProductMergeDefault: ProductMergeDefaultOutputType;
  updateRenewalSettings: Array<RenewalSettingsType>;
  updateSearch?: Maybe<SearchRowKeyResultGraphType>;
  updateShipToCustomer: ContractType;
  updateTerminateContractLines: Array<ContractLineByBillingCyclesType>;
  updateUpliftIndex: UpliftIndex;
  updateUpliftIndexRate: UpliftIndexRate;
  updateUsageHeader: UsageHeader;
  upsertContractUpliftCaps: ContractUpliftCapsOutput;
  upsertCustomer: CustomerType;
  upsertProduct: ProductType;
  verifyFields: FieldVerificationType;
  writeUserConfiguration?: Maybe<SucceededErrorResultGraphType>;
};

export type ContractsAndBillingMutationabandonSalesOrderByBillingCycleArgs = {
  input: AbandonSalesOrderByBillingCycleInputType;
};

export type ContractsAndBillingMutationabandonUsageHeaderArgs = {
  id: Scalars['ID']['input'];
};

export type ContractsAndBillingMutationaddContractNoteArgs = {
  input: ContractNoteInputType;
};

export type ContractsAndBillingMutationaddProductMergeDefaultArgs = {
  input: AddProductMergeDefaultInputType;
};

export type ContractsAndBillingMutationaddPurchaseOrderArgs = {
  input: AddPurchaseOrderInputType;
};

export type ContractsAndBillingMutationaddUpliftIndexArgs = {
  input: AddUpliftIndexWithRatesInputType;
};

export type ContractsAndBillingMutationaddUpliftRatesToIndexArgs = {
  input: AddUpliftIndexRatesInputType;
};

export type ContractsAndBillingMutationaddVerifiableFieldArgs = {
  input: AddVerifiableFieldInputType;
};

export type ContractsAndBillingMutationapproveContractLinesArgs = {
  input: ApproveContractLinesInputType;
};

export type ContractsAndBillingMutationarchiveUsageHeaderArgs = {
  id: Scalars['ID']['input'];
};

export type ContractsAndBillingMutationbatchUpliftContractLinesArgs = {
  input: BulkContractLineUpliftsInputType;
};

export type ContractsAndBillingMutationbulkAssignPurchaseOrderArgs = {
  input: BulkAssignPurchaseOrderInput;
};

export type ContractsAndBillingMutationbulkCancelUpliftsArgs = {
  input: CancelUpliftsInputType;
};

export type ContractsAndBillingMutationbulkDeletePurchaseOrderArgs = {
  purchaseOrderIds: Array<Scalars['Guid']['input']>;
};

export type ContractsAndBillingMutationbulkUnassignPurchaseOrderArgs = {
  input: BulkUnassignPurchaseOrderInput;
};

export type ContractsAndBillingMutationbulkUpdateContractLineInvoiceToCustomerArgs =
  {
    input: BulkUpdateContractLineInvoiceToCustomerInputType;
  };

export type ContractsAndBillingMutationbulkUpdateContractLineShipToCustomerArgs =
  {
    input: BulkUpdateContractLineShipToCustomerInputType;
  };

export type ContractsAndBillingMutationbulkUpdateContractLinesArgs = {
  input: BulkUpdateContractLinesInputType;
};

export type ContractsAndBillingMutationbulkUpdateProRataEndDateArgs = {
  input: BulkUpdateProRataEndDateInputType;
};

export type ContractsAndBillingMutationcancelContractLinesArgs = {
  input: CancelContractLinesInputType;
};

export type ContractsAndBillingMutationcreateContractArgs = {
  contract: ContractInputType;
};

export type ContractsAndBillingMutationcreateContractLineArgs = {
  contractLine: ContractLineInputType;
};

export type ContractsAndBillingMutationcreateContractLinesArgs = {
  input: ContractLinesInputType;
};

export type ContractsAndBillingMutationcreateCustomerArgs = {
  customer: CustomerInputType;
};

export type ContractsAndBillingMutationcreateFullContractArgs = {
  input: CreateFullContractInputType;
};

export type ContractsAndBillingMutationcreateManualSalesOrderByBillingCycleArgs =
  {
    input: CreateManualSalesOrderByBillingCycleInputType;
  };

export type ContractsAndBillingMutationcreateOrAssignBundleArgs = {
  input: CreateOrAssingBundleInputType;
};

export type ContractsAndBillingMutationcreateProductArgs = {
  input: CreateProductInputType;
};

export type ContractsAndBillingMutationcreateReasonCodeArgs = {
  input: ReasonCodeInputType;
};

export type ContractsAndBillingMutationcreateSearchTagArgs = {
  input: SearchTagInputType;
};

export type ContractsAndBillingMutationcreateUsageHeaderArgs = {
  input: CreateUsageHeaderInputType;
};

export type ContractsAndBillingMutationdeleteProductMergeDefaultArgs = {
  id: Scalars['ID']['input'];
};

export type ContractsAndBillingMutationdeleteSearchArgs = {
  form: Forms;
  rowKey: Scalars['String']['input'];
};

export type ContractsAndBillingMutationdeleteUpliftIndexArgs = {
  upliftIndexId: Scalars['ID']['input'];
};

export type ContractsAndBillingMutationdeleteUpliftIndexRatesArgs = {
  upliftIndexId: Scalars['ID']['input'];
  upliftIndexRateIds: Array<Scalars['ID']['input']>;
};

export type ContractsAndBillingMutationdeleteUserConfigurationArgs = {
  formName: Scalars['String']['input'];
  userName: Scalars['String']['input'];
};

export type ContractsAndBillingMutationdnrContractLinesArgs = {
  input: DNRContractLinesInputType;
};

export type ContractsAndBillingMutationeditPurchaseOrderArgs = {
  input: EditPurchaseOrderInputType;
};

export type ContractsAndBillingMutationexemptFromUpliftArgs = {
  input: ExemptFromUpliftInputType;
};

export type ContractsAndBillingMutationignoreBillingCycleArgs = {
  input: IgnoreBillingCycleInput;
};

export type ContractsAndBillingMutationignoreBillingCyclesArgs = {
  input: IgnoreBillingCyclesInput;
};

export type ContractsAndBillingMutationignoreUsageDetailsArgs = {
  input: IgnoreUsageDetailsInputType;
};

export type ContractsAndBillingMutationinstantPushSalesOrderByBillingCycleArgs =
  {
    salesOrderId: Scalars['ID']['input'];
  };

export type ContractsAndBillingMutationmatchUsageDetailsArgs = {
  input: MatchUsageDetailsInputType;
};

export type ContractsAndBillingMutationmergeCustomersArgs = {
  input: MergeCustomersInputType;
};

export type ContractsAndBillingMutationmigrateContractsToOneEvoArgs = {
  input: MigrateContractsToOneEvoInput;
};

export type ContractsAndBillingMutationpauseBillingArgs = {
  input: PauseBillingInputType;
};

export type ContractsAndBillingMutationpauseContractLinesArgs = {
  input: PauseContractLineInputType;
};

export type ContractsAndBillingMutationprocessUsageDetailsArgs = {
  input: ProcessUsageDetailsInputType;
};

export type ContractsAndBillingMutationraiseProformaByBillingCyclesArgs = {
  input: RaiseProformaInputType;
};

export type ContractsAndBillingMutationremoveFieldVerificationArgs = {
  input: RemoveFieldVerificationInputType;
};

export type ContractsAndBillingMutationremoveUpliftExemptionArgs = {
  input: RemoveUpliftExemptionInputType;
};

export type ContractsAndBillingMutationremoveVerifiableFieldArgs = {
  input: RemoveVerifiableFieldInputType;
};

export type ContractsAndBillingMutationrestoreUsageDetailsArgs = {
  input: RestoreUsageDetailsInputType;
};

export type ContractsAndBillingMutationresumeBillingArgs = {
  input: ResumeBillingInput;
};

export type ContractsAndBillingMutationresumeContractLinesArgs = {
  input: ResumeContractLineInputType;
};

export type ContractsAndBillingMutationrevertOneEvoMigrationArgs = {
  input: RevertOneEvoMigrationInput;
};

export type ContractsAndBillingMutationsaveSearchArgs = {
  search: SearchInput;
};

export type ContractsAndBillingMutationterminateContractLinesArgs = {
  input: TerminateContractLinesInputType;
};

export type ContractsAndBillingMutationtoggleBillToParentArgs = {
  input: ToggleBillToParentInput;
};

export type ContractsAndBillingMutationtoggleConsolidateBillingArgs = {
  input: ToggleConsolidateBillingInput;
};

export type ContractsAndBillingMutationtoggleHidingContractLinesArgs = {
  input: ToggleHidingContractLinesInput;
};

export type ContractsAndBillingMutationtogglePONumberRequiredArgs = {
  input: TogglePONumberRequiredInput;
};

export type ContractsAndBillingMutationtoggleReasonCodeArgs = {
  input: ToggleReasonCodeInputType;
};

export type ContractsAndBillingMutationtoggleResellerArgs = {
  input: ToggleResellerInput;
};

export type ContractsAndBillingMutationtriggerResendSalesOrdersByBillingCyclesArgs =
  {
    input?: InputMaybe<ResendSalesOrdersInputType>;
  };

export type ContractsAndBillingMutationunbundleArgs = {
  input: UnbundleInputType;
};

export type ContractsAndBillingMutationupdateBundleArgs = {
  input: UpdateBundleInputType;
};

export type ContractsAndBillingMutationupdateContractArgs = {
  input: UpdateContractInputType;
};

export type ContractsAndBillingMutationupdateContractAdminDataArgs = {
  input: UpdateContractAdminDataInputType;
};

export type ContractsAndBillingMutationupdateContractClientDatabaseReferenceArgs =
  {
    input: UpdateContractClientDatabaseReferenceInputType;
  };

export type ContractsAndBillingMutationupdateContractCustomerArgs = {
  input: UpdateContractCustomerInputType;
};

export type ContractsAndBillingMutationupdateContractLineArgs = {
  input: UpdateContractLineInputType;
};

export type ContractsAndBillingMutationupdateContractLinesArgs = {
  input: UpdateContractLinesInputType;
};

export type ContractsAndBillingMutationupdateContractLinesBillingCyclesCadenceArgs =
  {
    input: UpdateContractLineBillingCyclesCadenceInputType;
  };

export type ContractsAndBillingMutationupdateContractMessageArgs = {
  contractId: Scalars['Guid']['input'];
  message: Scalars['String']['input'];
};

export type ContractsAndBillingMutationupdateContractRenewalArgs = {
  input: ContractRenewalInput;
};

export type ContractsAndBillingMutationupdateContractTermsAndConditionsArgs = {
  input: UpdateContractTermsAndConditionsInputType;
};

export type ContractsAndBillingMutationupdateContractUpliftSettingsArgs = {
  input: UpdateContractUpliftSettingsInputType;
};

export type ContractsAndBillingMutationupdateCustomerArgs = {
  input: UpdateCustomerInputType;
};

export type ContractsAndBillingMutationupdateDNRContractLinesArgs = {
  input: UpdateDNRContractLinesInputType;
};

export type ContractsAndBillingMutationupdateDirectDebitArgs = {
  input: DirectDebitInputType;
};

export type ContractsAndBillingMutationupdateDivertCustomerArgs = {
  input: UpdateDivertCustomerInputType;
};

export type ContractsAndBillingMutationupdateFullContractLineArgs = {
  input: UpdateFullContractLineInputType;
};

export type ContractsAndBillingMutationupdateInvoiceToCustomerArgs = {
  input: UpdateInvoiceToCustomerInputType;
};

export type ContractsAndBillingMutationupdatePONumberArgs = {
  input: UpdatePONumberInputType;
};

export type ContractsAndBillingMutationupdateParentCustomerArgs = {
  input: UpdateParentCustomerInputType;
};

export type ContractsAndBillingMutationupdatePauseBillingArgs = {
  input: UpdatePauseBillingInputType;
};

export type ContractsAndBillingMutationupdatePauseBillingContractLinesArgs = {
  input: PauseContractLineInputType;
};

export type ContractsAndBillingMutationupdateProductArgs = {
  input: UpdateProductInputType;
};

export type ContractsAndBillingMutationupdateProductDefaultBillingTypeArgs = {
  input: UpdateProductDefaultBillingTypeInputType;
};

export type ContractsAndBillingMutationupdateProductMergeDefaultArgs = {
  input: UpdateProductMergeDefaultInputType;
};

export type ContractsAndBillingMutationupdateRenewalSettingsArgs = {
  input: UpdateRenewalSettingsInputType;
};

export type ContractsAndBillingMutationupdateSearchArgs = {
  search: SearchInput;
};

export type ContractsAndBillingMutationupdateShipToCustomerArgs = {
  input: UpdateShipToCustomerInputType;
};

export type ContractsAndBillingMutationupdateTerminateContractLinesArgs = {
  input: UpdateTerminateContractLinesInputType;
};

export type ContractsAndBillingMutationupdateUpliftIndexArgs = {
  input: UpdateIndexInput;
};

export type ContractsAndBillingMutationupdateUpliftIndexRateArgs = {
  input: UpdateUpliftIndexRateInput;
};

export type ContractsAndBillingMutationupdateUsageHeaderArgs = {
  input: UpdateUsageHeaderInputType;
};

export type ContractsAndBillingMutationupsertContractUpliftCapsArgs = {
  input: UpsertContractUpliftCapsInputType;
};

export type ContractsAndBillingMutationupsertCustomerArgs = {
  input: UpsertCustomerInputType;
};

export type ContractsAndBillingMutationupsertProductArgs = {
  input: UpsertProductInputType;
};

export type ContractsAndBillingMutationverifyFieldsArgs = {
  input: VerifyFieldsInputType;
};

export type ContractsAndBillingMutationwriteUserConfigurationArgs = {
  configuration: UserConfigurationInput;
};

export type ContractsAndBillingQuery = {
  __typename?: 'ContractsAndBillingQuery';
  billingCycleStatuses: Array<FormattedBillingCycleStatusEnum>;
  billingIntervalTypes: Array<BillingIntervalType>;
  billingTypes: Array<BillingType>;
  calculateUpliftedContractLinesByBillingCycles?: Maybe<
    Array<Maybe<ContractLineByBillingCyclesType>>
  >;
  clientDatabases?: Maybe<Array<Maybe<ClientDatabases>>>;
  config?: Maybe<ConfigQueries>;
  contract: ContractType;
  contractByBillingCycles: ContractByBillingCyclesType;
  contractChanges: Array<ContractChangeType>;
  contractIdentifiers: Array<ContractIdentifiersOutputType>;
  contractLineByBillingCycleChanges: Array<ContractLineByBillingCycleChangeType>;
  contractLineChanges: Array<ContractLineChangeType>;
  contractLineStatuses: Array<ContractLineStatusType>;
  contractLinesByUpliftFilterByBillingCycles: Array<
    Maybe<UpliftSearchResultType>
  >;
  contractOrigins: Array<FormattedContractOriginEnum>;
  contractStatuses: Array<ContractStatusType>;
  contractTermsAndConditions?: Maybe<ContractTermsAndConditions>;
  contractUpliftCaps?: Maybe<ContractUpliftCapsOutput>;
  contracts: Array<ContractType>;
  currencyTypes: Array<CurrencyType>;
  customer: CustomerType;
  customerByAccountNumber: CustomerType;
  customerChanges: Array<CustomerChangeType>;
  customerDetails: CustomerDetailsType;
  customerGrid?: Maybe<CustomerGridQueries>;
  customers: Array<CustomerType>;
  directDebits: Array<DirectDebitType>;
  getAllCommissionsReport?: Maybe<Array<CommissionsReportLine>>;
  getBillingHealthSalesOrderTotals?: Maybe<BillingHealthSalesOrderTotalsOutput>;
  getCommissionsReport?: Maybe<PaginatedCommissionsReport>;
  getCustomerContractsCount: Scalars['Int']['output'];
  getPreviewSalesOrderByBillingCycle?: Maybe<SalesOrderType>;
  getProductMergeDefaults: Array<ProductMergeDefaultOutputType>;
  getUpliftIndexRatesByIndexId: Array<UpliftIndexRate>;
  getUpliftIndexes: Array<UpliftIndex>;
  getUpliftRegions: Array<UpliftRegion>;
  history: Array<ChangeSetType>;
  historyExists: Scalars['Boolean']['output'];
  latestFieldVerifications: Array<LatestFieldVerificationType>;
  paginatedContractChanges?: Maybe<PaginatedContractChanges>;
  paginatedContractLineByBillingCycleChanges?: Maybe<PaginatedContractLineChanges>;
  paginatedContractLineChanges?: Maybe<PaginatedContractLineChanges>;
  paginatedContracts?: Maybe<PaginatedContracts>;
  paginatedCustomerChanges?: Maybe<PaginatedCustomerChanges>;
  paginatedFieldVerifications: PaginatedFieldVerifications;
  paginatedFilteredBillingCycles?: Maybe<BillingCycleOutputConnection>;
  paginatedFilteredBundles?: Maybe<BundleOutputConnection>;
  paginatedFilteredClientDatabases?: Maybe<ClientDatabaseOutputConnection>;
  paginatedFilteredContractLinesByBillingCycles?: Maybe<ContractLineBillingCycleOutputConnection>;
  paginatedFilteredContracts?: Maybe<ContractOutputConnection>;
  paginatedFilteredGridContractLines?: Maybe<ContractLineGridOutputConnection>;
  paginatedFilteredRevenueLeakageBillingCycles?: Maybe<RevenueLeakageBillingCycleOutputConnection>;
  paginatedFilteredSalesOrders?: Maybe<NullableUnionSalesOrderSearchOutputConnection>;
  paginatedFilteredSalesOrdersByBillingCycles?: Maybe<NullableUnionSalesOrderSearchOutputConnection>;
  paginatedFilteredUplifts?: Maybe<PaginatedFilteredUpliftConnection>;
  paginatedFilteredVarBillingUsageDetails?: Maybe<VarBillingUsageDetailOutputConnection>;
  paginatedFilteredVariableContractLines?: Maybe<VariableContractLineOutputConnection>;
  paginatedReasonCodes?: Maybe<PaginatedReasonCodes>;
  preReinvoicingChecks?: Maybe<PreReinvoicingChecksOutputType>;
  prevNextContractIds: PrevNextContractIds;
  product?: Maybe<ProductType>;
  productNames: Array<Scalars['String']['output']>;
  products?: Maybe<ProductOutputConnection>;
  purchaseOrders?: Maybe<PurchaseOrderOutputConnection>;
  reasonCodes: Array<ReasonCodeType>;
  reasonTypes: Array<ReasonType>;
  recentSavedSearches?: Maybe<Array<Search>>;
  renewalRange: RenewalRangeType;
  renewalSettings: Array<RenewalSettingsType>;
  revenueForecast?: Maybe<Array<Maybe<RevenueForecastOutput>>>;
  revenueLeakageByContractLineStatus?: Maybe<
    Array<Maybe<RevenueLeakageSummaryByStatus>>
  >;
  revenueLeakageByContractStatus?: Maybe<
    Array<Maybe<RevenueLeakageSummaryByStatus>>
  >;
  revenueLeakageByLineBillingStatus?: Maybe<
    Array<Maybe<RevenueLeakageSummaryByStatus>>
  >;
  revenueLeakageByProcessingStatus?: Maybe<
    Array<Maybe<RevenueLeakageSummaryByStatus>>
  >;
  revenueLeakageContextFlags?: Maybe<Array<Maybe<RevenueLeakageContextFlag>>>;
  revenueLeakageDiagnosisBreakdown?: Maybe<
    Array<Maybe<RevenueLeakageDiagnosisBreakdown>>
  >;
  revenueLeakageMonthlyTrend?: Maybe<Array<Maybe<RevenueLeakageMonthlyTrend>>>;
  revenueLeakageOverdueDistribution?: Maybe<
    Array<Maybe<RevenueLeakageOverdueDistribution>>
  >;
  revenueLeakageSummary?: Maybe<RevenueLeakageSummary>;
  revenueLeakageSummaryByCurrency?: Maybe<
    Array<Maybe<RevenueLeakageSummaryByCurrency>>
  >;
  revenueLeakageTopConsolidationGroups?: Maybe<
    Array<Maybe<RevenueLeakageConsolidationGroup>>
  >;
  revenueLeakageTopContracts?: Maybe<Array<Maybe<RevenueLeakageByContract>>>;
  revenueLeakageTopCustomers?: Maybe<Array<Maybe<RevenueLeakageByCustomer>>>;
  revenueLeakageTopProducts?: Maybe<Array<Maybe<RevenueLeakageByProduct>>>;
  revenueRisk?: Maybe<Array<Maybe<RevenueRiskOutput>>>;
  salesOrderByBillingCyclesDetails?: Maybe<SalesOrderDetailsType>;
  salesOrderDetails?: Maybe<SalesOrderDetailsType>;
  salesOrdersByBillingCyclePrediction?: Maybe<SalesOrdersPredictionResultsType>;
  salesOrdersByBillingCycles?: Maybe<PaginatedSalesOrders>;
  salesOrdersByBillingCyclesTotals?: Maybe<SalesOrdersTotalsOutput>;
  salesOrdersTotals?: Maybe<SalesOrdersTotalsOutput>;
  savedSearches?: Maybe<Array<Search>>;
  search: Array<ProductType>;
  searchById: ProductType;
  searchByIds: Array<ProductType>;
  searchByStockCodes: Array<ProductType>;
  searchContracts: Array<ContractType>;
  searchContractsAndCustomers?: Maybe<ContractsAndCustomersSearchResult>;
  searchCustomers: Array<CustomerType>;
  searchTags: Array<SearchTagType>;
  unitPriceFrequencies: Array<UnitPriceFrequencyType>;
  upliftTypes?: Maybe<Array<Maybe<UpliftType>>>;
  usageHeaderStatuses: Array<UsageHeaderStatus>;
  usageHeaders?: Maybe<UsageHeaderOutputConnection>;
  usageHeadersTotals?: Maybe<UsageHeaderTotalsOutput>;
  userConfigurationByRowKey?: Maybe<UserConfiguration>;
  userPermissions: Array<Scalars['String']['output']>;
  varBillingUsageDetailStatuses: Array<UsageDetailStatus>;
  varBillingUsageDetailsTotals?: Maybe<VarBillingUsageDetailsTotalsOutput>;
  varBillingUsageHeader: UsageHeader;
  variableContractLinesSummary: ContractVarBIllingSummaryOutputType;
  verifiableFields: Array<VerifiableFieldType>;
};

export type ContractsAndBillingQuerybillingIntervalTypesArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  includeNonShowable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContractsAndBillingQuerycalculateUpliftedContractLinesByBillingCyclesArgs =
  {
    input: CalculateUpliftedContractLinesInputType;
  };

export type ContractsAndBillingQuerycontractArgs = {
  contractId: Scalars['ID']['input'];
};

export type ContractsAndBillingQuerycontractByBillingCyclesArgs = {
  contractId: Scalars['ID']['input'];
};

export type ContractsAndBillingQuerycontractChangesArgs = {
  input: GetChangesInput;
};

export type ContractsAndBillingQuerycontractIdentifiersArgs = {
  input: Array<ContractIdentifiersInputType>;
};

export type ContractsAndBillingQuerycontractLineByBillingCycleChangesArgs = {
  input: GetChangesInput;
};

export type ContractsAndBillingQuerycontractLineChangesArgs = {
  input: GetChangesInput;
};

export type ContractsAndBillingQuerycontractLinesByUpliftFilterByBillingCyclesArgs =
  {
    upliftFilter: FilterContractLinesForUpliftType;
  };

export type ContractsAndBillingQuerycontractTermsAndConditionsArgs = {
  contractId: Scalars['Guid']['input'];
};

export type ContractsAndBillingQuerycontractUpliftCapsArgs = {
  contractId: Scalars['Guid']['input'];
};

export type ContractsAndBillingQuerycontractsArgs = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ContractsAndBillingQuerycurrencyTypesArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContractsAndBillingQuerycustomerArgs = {
  customerId: Scalars['ID']['input'];
};

export type ContractsAndBillingQuerycustomerByAccountNumberArgs = {
  customerAccountNumber: Scalars['String']['input'];
};

export type ContractsAndBillingQuerycustomerChangesArgs = {
  input: GetChangesInput;
};

export type ContractsAndBillingQuerycustomerDetailsArgs = {
  customerId: Scalars['ID']['input'];
};

export type ContractsAndBillingQuerygetAllCommissionsReportArgs = {
  filter?: InputMaybe<CommissionsReportFilterInput>;
};

export type ContractsAndBillingQuerygetBillingHealthSalesOrderTotalsArgs = {
  filter?: InputMaybe<BillingHealthSalesOrderTotalsFilterInput>;
};

export type ContractsAndBillingQuerygetCommissionsReportArgs = {
  filter?: InputMaybe<CommissionsReportFilterInput>;
};

export type ContractsAndBillingQuerygetCustomerContractsCountArgs = {
  input: GetCustomerContractsCountInputType;
};

export type ContractsAndBillingQuerygetPreviewSalesOrderByBillingCycleArgs = {
  input: GetPreviewSalesOrderByBillingCycleInputType;
};

export type ContractsAndBillingQuerygetUpliftIndexRatesByIndexIdArgs = {
  indexId: Scalars['Guid']['input'];
};

export type ContractsAndBillingQuerygetUpliftIndexesArgs = {
  includeRates?: InputMaybe<Scalars['Boolean']['input']>;
  region: Scalars['String']['input'];
  type?: InputMaybe<UpliftIndexTypePascalCaseEnum>;
};

export type ContractsAndBillingQueryhistoryArgs = {
  entityId: Scalars['Guid']['input'];
  entityType: EntityTypeEnum;
  includeRelated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContractsAndBillingQueryhistoryExistsArgs = {
  entityId: Scalars['Guid']['input'];
  entityType: EntityTypeEnum;
  includeRelated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContractsAndBillingQuerylatestFieldVerificationsArgs = {
  input: GetLatestFieldVerificationsInputType;
};

export type ContractsAndBillingQuerypaginatedContractChangesArgs = {
  input: GetPaginatedChangesInput;
};

export type ContractsAndBillingQuerypaginatedContractLineByBillingCycleChangesArgs =
  {
    input: GetPaginatedChangesInput;
  };

export type ContractsAndBillingQuerypaginatedContractLineChangesArgs = {
  input: GetPaginatedChangesInput;
};

export type ContractsAndBillingQuerypaginatedContractsArgs = {
  input: PaginatedContractsInputType;
};

export type ContractsAndBillingQuerypaginatedCustomerChangesArgs = {
  input: GetPaginatedChangesInput;
};

export type ContractsAndBillingQuerypaginatedFieldVerificationsArgs = {
  input: GetPaginatedFieldVerificationsInputType;
};

export type ContractsAndBillingQuerypaginatedFilteredBillingCyclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<BillingCycleFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<BillingCycleSort>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BillingCycleSortSortByInput>>;
};

export type ContractsAndBillingQuerypaginatedFilteredBundlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<BundleFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<BundleSort>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BundleSortSortByInput>>;
};

export type ContractsAndBillingQuerypaginatedFilteredClientDatabasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ClientDatabaseFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<ClientDatabaseSort>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ClientDatabaseSortSortByInput>>;
};

export type ContractsAndBillingQuerypaginatedFilteredContractLinesByBillingCyclesArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    filter?: InputMaybe<ContractLineFilterInput>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    sort?: InputMaybe<Array<ContractLineSortSortByInput>>;
  };

export type ContractsAndBillingQuerypaginatedFilteredContractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ContractFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<ContractSort>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ContractSortSortByInput>>;
};

export type ContractsAndBillingQuerypaginatedFilteredGridContractLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ContractLineGridFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<ContractLineGridSort>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ContractLineGridSortSortByInput>>;
};

export type ContractsAndBillingQuerypaginatedFilteredRevenueLeakageBillingCyclesArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    filter?: InputMaybe<RevenueLeakageBillingCycleFilterInput>;
    first?: InputMaybe<Scalars['Int']['input']>;
    group?: InputMaybe<RevenueLeakageBillingCycleSort>;
    last?: InputMaybe<Scalars['Int']['input']>;
    sort?: InputMaybe<Array<RevenueLeakageBillingCycleSortSortByInput>>;
  };

export type ContractsAndBillingQuerypaginatedFilteredSalesOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SalesOrderFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<SalesOrderSort>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SalesOrderSortSortByInput>>;
};

export type ContractsAndBillingQuerypaginatedFilteredSalesOrdersByBillingCyclesArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    filter?: InputMaybe<SalesOrderByBillingCycleFilterInput>;
    first?: InputMaybe<Scalars['Int']['input']>;
    group?: InputMaybe<SalesOrderByBillingCycleSort>;
    last?: InputMaybe<Scalars['Int']['input']>;
    sort?: InputMaybe<Array<SalesOrderByBillingCycleSortSortByInput>>;
  };

export type ContractsAndBillingQuerypaginatedFilteredUpliftsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UpliftFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<UpliftSort>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UpliftSortSortByInput>>;
};

export type ContractsAndBillingQuerypaginatedFilteredVarBillingUsageDetailsArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    filter?: InputMaybe<VarBillingUsageDetailFilterInput>;
    first?: InputMaybe<Scalars['Int']['input']>;
    group?: InputMaybe<VarBillingUsageDetailSort>;
    last?: InputMaybe<Scalars['Int']['input']>;
    sort?: InputMaybe<Array<VarBillingUsageDetailSortSortByInput>>;
  };

export type ContractsAndBillingQuerypaginatedFilteredVariableContractLinesArgs =
  {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
    filter?: InputMaybe<VariableContractLineFilterInput>;
    first?: InputMaybe<Scalars['Int']['input']>;
    last?: InputMaybe<Scalars['Int']['input']>;
    sort?: InputMaybe<Array<VariableContractLineSortSortByInput>>;
  };

export type ContractsAndBillingQuerypaginatedReasonCodesArgs = {
  input: PaginatedReasonCodesInputType;
};

export type ContractsAndBillingQuerypreReinvoicingChecksArgs = {
  input: PreReinvoicingChecksInputType;
};

export type ContractsAndBillingQueryprevNextContractIdsArgs = {
  contractId: Scalars['ID']['input'];
  filter?: InputMaybe<ContractFilterInput>;
  rowIndex?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ContractSortSortByInput>>;
};

export type ContractsAndBillingQueryproductArgs = {
  stockCode: Scalars['String']['input'];
};

export type ContractsAndBillingQueryproductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<ProductSort>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ProductSortSortByInput>>>;
};

export type ContractsAndBillingQuerypurchaseOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PurchaseOrderFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<PurchaseOrderSort>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PurchaseOrderSortSortByInput>>>;
};

export type ContractsAndBillingQueryreasonCodesArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ContractsAndBillingQueryrecentSavedSearchesArgs = {
  filter: RecentSavedSearchFilterInput;
};

export type ContractsAndBillingQueryrenewalSettingsArgs = {
  includeNonEditable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContractsAndBillingQueryrevenueForecastArgs = {
  createdAfterMonths?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  groupBy: RevenueForecastGroupBy;
  months: Scalars['Int']['input'];
  productFamily?: InputMaybe<Scalars['String']['input']>;
  top?: InputMaybe<Scalars['Int']['input']>;
};

export type ContractsAndBillingQueryrevenueLeakageTopConsolidationGroupsArgs = {
  top?: InputMaybe<Scalars['Int']['input']>;
};

export type ContractsAndBillingQueryrevenueLeakageTopContractsArgs = {
  top?: InputMaybe<Scalars['Int']['input']>;
};

export type ContractsAndBillingQueryrevenueLeakageTopCustomersArgs = {
  top?: InputMaybe<Scalars['Int']['input']>;
};

export type ContractsAndBillingQueryrevenueLeakageTopProductsArgs = {
  top?: InputMaybe<Scalars['Int']['input']>;
};

export type ContractsAndBillingQueryrevenueRiskArgs = {
  category: RevenueRiskCategory;
  currency?: InputMaybe<Scalars['String']['input']>;
  groupBy: RevenueRiskGroupBy;
  months: Scalars['Int']['input'];
  top?: InputMaybe<Scalars['Int']['input']>;
};

export type ContractsAndBillingQuerysalesOrderByBillingCyclesDetailsArgs = {
  salesOrderId: Scalars['ID']['input'];
};

export type ContractsAndBillingQuerysalesOrderDetailsArgs = {
  salesOrderId: Scalars['ID']['input'];
};

export type ContractsAndBillingQuerysalesOrdersByBillingCyclePredictionArgs = {
  input: SalesOrdersPredictionInputType;
};

export type ContractsAndBillingQuerysalesOrdersByBillingCyclesArgs = {
  input: PaginatedSalesOrdersInputType;
};

export type ContractsAndBillingQuerysalesOrdersByBillingCyclesTotalsArgs = {
  filter?: InputMaybe<SalesOrderFilterInput>;
};

export type ContractsAndBillingQuerysalesOrdersTotalsArgs = {
  filter?: InputMaybe<SalesOrderFilterInput>;
};

export type ContractsAndBillingQuerysavedSearchesArgs = {
  filter: SavedSearchFilterInput;
};

export type ContractsAndBillingQuerysearchArgs = {
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  searchString: Scalars['String']['input'];
};

export type ContractsAndBillingQuerysearchByIdArgs = {
  id: Scalars['Guid']['input'];
};

export type ContractsAndBillingQuerysearchByIdsArgs = {
  input: SearchByIdsInputType;
};

export type ContractsAndBillingQuerysearchByStockCodesArgs = {
  stockCodes: Array<Scalars['String']['input']>;
};

export type ContractsAndBillingQuerysearchContractsArgs = {
  contractNumber: Scalars['String']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
};

export type ContractsAndBillingQuerysearchContractsAndCustomersArgs = {
  searchString: Scalars['String']['input'];
};

export type ContractsAndBillingQuerysearchCustomersArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  customerName: Scalars['String']['input'];
};

export type ContractsAndBillingQuerysearchTagsArgs = {
  count: Scalars['Int']['input'];
};

export type ContractsAndBillingQueryupliftTypesArgs = {
  searchString?: InputMaybe<Scalars['String']['input']>;
};

export type ContractsAndBillingQueryusageHeadersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UsageHeaderFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UsageHeaderSortSortByInput>>>;
};

export type ContractsAndBillingQueryusageHeadersTotalsArgs = {
  filter?: InputMaybe<UsageHeaderFilterInput>;
};

export type ContractsAndBillingQueryuserConfigurationByRowKeyArgs = {
  formName: Scalars['String']['input'];
  userName: Scalars['String']['input'];
};

export type ContractsAndBillingQueryvarBillingUsageDetailsTotalsArgs = {
  filter?: InputMaybe<VarBillingUsageDetailFilterInput>;
};

export type ContractsAndBillingQueryvarBillingUsageHeaderArgs = {
  id: Scalars['ID']['input'];
};

export type ContractsAndBillingQueryvariableContractLinesSummaryArgs = {
  contractId: Scalars['ID']['input'];
};

export type ContractsAndBillingQueryverifiableFieldsArgs = {
  entityType: EntityTypeEnum;
  reasonCode: Scalars['String']['input'];
};

export type ContractsAndCustomersSearchResult = {
  __typename?: 'ContractsAndCustomersSearchResult';
  contracts: Array<ContractType>;
  customers: Array<CustomerType>;
};

export type ContractsToMigrateInput = {
  contractIds: Array<Scalars['Guid']['input']>;
  oneEvoContractNumber: Scalars['String']['input'];
};

export type CreateFullContractInputType = {
  bundles?: InputMaybe<Array<InputMaybe<CreateOrAssingBundleBaseInputType>>>;
  contract: FullContractInputType;
  contractLines: Array<InputMaybe<CreateFullContractLineInputType>>;
  customer: UpsertCustomerInputType;
  /** If true, the created sales order will be instantly pushed after creation. */
  instantSend?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceToCustomer?: InputMaybe<UpsertCustomerInputType>;
  shipToCustomer?: InputMaybe<UpsertCustomerInputType>;
};

export type CreateFullContractLineInputType = {
  billingInterval?: InputMaybe<Scalars['String']['input']>;
  billingStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  billingType: Scalars['String']['input'];
  bundleDescription?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  invoiceToCustomer?: InputMaybe<UpsertCustomerInputType>;
  lineStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  oppHeaderId?: InputMaybe<Scalars['String']['input']>;
  oppLineId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<ContractOriginEnum>;
  proRataEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  product?: InputMaybe<UpsertProductInputType>;
  purchaseOrder?: InputMaybe<UpsertPurchaseOrderInputType>;
  quantity?: InputMaybe<Scalars['Long']['input']>;
  salesHandoverNumber?: InputMaybe<Scalars['String']['input']>;
  sfContractLineId?: InputMaybe<Scalars['String']['input']>;
  shipToCustomer?: InputMaybe<UpsertCustomerInputType>;
  unitPrice: Scalars['Decimal']['input'];
  unitPriceFrequency?: InputMaybe<Scalars['String']['input']>;
};

export type CreateManualSalesOrderByBillingCycleInputType = {
  billingCycleId?: InputMaybe<Scalars['ID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  /** If true, the created sales order will be instantly pushed after creation. */
  instantSend?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional invoice date to override SendingDate and OrderDate. Must be >= today if provided. */
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  newPayloadJson?: InputMaybe<Scalars['String']['input']>;
  reasonCode: Scalars['String']['input'];
  soByBcId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateOrAssingBundleBaseInputType = {
  description?: InputMaybe<Scalars['String']['input']>;
  hideInvoiceLines?: InputMaybe<Scalars['Boolean']['input']>;
  hideInvoiceValues?: InputMaybe<Scalars['Boolean']['input']>;
  softwareCompany?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BundleTypeEnum>;
};

export type CreateOrAssingBundleInputType = {
  bundleId?: InputMaybe<Scalars['ID']['input']>;
  contractId: Scalars['ID']['input'];
  contractLineIds: Array<InputMaybe<Scalars['Guid']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  hideInvoiceLines?: InputMaybe<Scalars['Boolean']['input']>;
  hideInvoiceValues?: InputMaybe<Scalars['Boolean']['input']>;
  softwareCompany?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BundleTypeEnum>;
};

export type CreateProductInputType = {
  defaultBillingType?: InputMaybe<Scalars['String']['input']>;
  productDivision: Scalars['String']['input'];
  productFamily: Scalars['String']['input'];
  productName: Scalars['String']['input'];
  softwareCompany?: InputMaybe<Scalars['String']['input']>;
  stockCode: Scalars['String']['input'];
  stockName: Scalars['String']['input'];
};

export type CreateUsageHeaderInputType = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  numberOfRows?: InputMaybe<Scalars['Int']['input']>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
};

export type CurrencyType = {
  __typename?: 'CurrencyType';
  currency: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  formattedCurrency: Scalars['String']['output'];
  numericCode: Scalars['UShort']['output'];
};

export type CustomerAdditionalFilterInput = {
  /** CustomerAccountNumber */
  customerAccountNumber?: InputMaybe<StringFilterInput>;
  /** CustomerName */
  customerName?: InputMaybe<StringFilterInput>;
};

export type CustomerChangeType = {
  __typename?: 'CustomerChangeType';
  changeType: ChangeTypeEnum;
  changed: CustomerType;
  changedOn: Scalars['DateTime']['output'];
};

export type CustomerDetailsType = {
  __typename?: 'CustomerDetailsType';
  accountManagerName?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  billParent?: Maybe<Scalars['Boolean']['output']>;
  ccEmailAddress?: Maybe<Scalars['String']['output']>;
  childAccounts: PaginatedCustomersDetails;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhoneNumber?: Maybe<Scalars['String']['output']>;
  contractVolume: Scalars['Int']['output'];
  contracts?: Maybe<Array<Maybe<ContractType>>>;
  country?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  customerAccountNumber: Scalars['String']['output'];
  customerID: Scalars['ID']['output'];
  customerName: Scalars['String']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  parentCustomer?: Maybe<CustomerType>;
  postCode?: Maybe<Scalars['String']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  totalValue: Scalars['String']['output'];
  town?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerDetailsTypechildAccountsArgs = {
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type CustomerFilterInput = {
  accountManagerName?: InputMaybe<StringFilterInput>;
  address?: InputMaybe<StringFilterInput>;
  ccEmailAddress?: InputMaybe<StringFilterInput>;
  childCustomersCount?: InputMaybe<IntFilterInput>;
  contactName?: InputMaybe<StringFilterInput>;
  contactPhoneNumber?: InputMaybe<StringFilterInput>;
  contractVolume?: InputMaybe<IntFilterInput>;
  country?: InputMaybe<StringFilterInput>;
  customerAccountNumber?: InputMaybe<StringFilterInput>;
  customerID?: InputMaybe<GuidFilterInput>;
  customerName?: InputMaybe<StringFilterInput>;
  emailAddress?: InputMaybe<StringFilterInput>;
  parentCustomerAccountNumber?: InputMaybe<StringFilterInput>;
  parentCustomerID?: InputMaybe<GuidFilterInput>;
  parentCustomerName?: InputMaybe<StringFilterInput>;
  postCode?: InputMaybe<StringFilterInput>;
  salesPersonName?: InputMaybe<StringFilterInput>;
  state?: InputMaybe<StringFilterInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
  totalValue?: InputMaybe<StringifiedDecimalFilterInput>;
  town?: InputMaybe<StringFilterInput>;
};

export type CustomerGridQueries = {
  __typename?: 'CustomerGridQueries';
  lists?: Maybe<CustomerListQueries>;
  masterRecords?: Maybe<CustomerMasterRecordQueries>;
};

export type CustomerInfo = {
  __typename?: 'CustomerInfo';
  contractId?: Maybe<Scalars['ID']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
};

export type CustomerInputType = {
  accountManagerName?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  billParent?: InputMaybe<Scalars['Boolean']['input']>;
  ccEmailAddress?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customerAccountNumber: Scalars['String']['input'];
  customerName: Scalars['String']['input'];
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  parentCustomerID?: InputMaybe<Scalars['ID']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  salesPersonName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  town?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerListQueries = {
  __typename?: 'CustomerListQueries';
  customersLookup?: Maybe<CustomerLookupOutputConnection>;
};

export type CustomerListQueriescustomersLookupArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CustomerLookupFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<CustomerLookupSort>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CustomerLookupSortSortByInput>>;
};

export type CustomerLookupFilterInput = {
  /** CustomerAccountNumber */
  customerAccountNumber?: InputMaybe<StringFilterInput>;
  /** CustomerName */
  customerName?: InputMaybe<StringFilterInput>;
  /** ParentCustomerID */
  parentCustomerID?: InputMaybe<GuidFilterInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerLookupOutput = {
  __typename?: 'CustomerLookupOutput';
  customerAccountNumber: Scalars['String']['output'];
  customerID: Scalars['ID']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  parentCustomerID?: Maybe<Scalars['ID']['output']>;
};

/** A connection from an object to a list of objects of type `CustomerLookupOutput`. */
export type CustomerLookupOutputConnection = {
  __typename?: 'CustomerLookupOutputConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<CustomerLookupOutputEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<CustomerLookupOutput>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `CustomerLookupOutput`. */
export type CustomerLookupOutputEdge = {
  __typename?: 'CustomerLookupOutputEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CustomerLookupOutput>;
};

export enum CustomerLookupSort {
  CustomerAccountNumber = 'CustomerAccountNumber',
  CustomerName = 'CustomerName',
  ParentCustomerID = 'ParentCustomerID',
}

export type CustomerLookupSortSortByInput = {
  /** Field */
  field?: InputMaybe<CustomerLookupSort>;
  order: OrderType;
};

export type CustomerMasterRecordQueries = {
  __typename?: 'CustomerMasterRecordQueries';
  customers?: Maybe<CustomerOutputConnection>;
};

export type CustomerMasterRecordQueriescustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CustomerFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<CustomerSort>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CustomerSortSortByInput>>;
};

export type CustomerOutput = {
  __typename?: 'CustomerOutput';
  accountManagerName?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  billToParentContractVolume?: Maybe<Array<Maybe<CustomerInfo>>>;
  ccEmailAddress?: Maybe<Scalars['String']['output']>;
  childCustomersCount?: Maybe<Scalars['Int']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhoneNumber?: Maybe<Scalars['String']['output']>;
  contractVolume?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  customerAccountNumber?: Maybe<Scalars['String']['output']>;
  customerID?: Maybe<Scalars['ID']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  parentCustomerAccountNumber?: Maybe<Scalars['String']['output']>;
  parentCustomerID?: Maybe<Scalars['ID']['output']>;
  parentCustomerName?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  totalValue?: Maybe<Scalars['String']['output']>;
  town?: Maybe<Scalars['String']['output']>;
};

/** A connection from an object to a list of objects of type `CustomerOutput`. */
export type CustomerOutputConnection = {
  __typename?: 'CustomerOutputConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<CustomerOutputEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<CustomerOutput>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `CustomerOutput`. */
export type CustomerOutputEdge = {
  __typename?: 'CustomerOutputEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CustomerOutput>;
};

export enum CustomerSort {
  AccountManagerName = 'AccountManagerName',
  Address = 'Address',
  BillToParentContractVolume = 'BillToParentContractVolume',
  CCEmailAddress = 'CCEmailAddress',
  ChildCustomersCount = 'ChildCustomersCount',
  ContactName = 'ContactName',
  ContactPhoneNumber = 'ContactPhoneNumber',
  ContractVolume = 'ContractVolume',
  Country = 'Country',
  CustomerAccountNumber = 'CustomerAccountNumber',
  CustomerID = 'CustomerID',
  CustomerName = 'CustomerName',
  EmailAddress = 'EmailAddress',
  ParentCustomerAccountNumber = 'ParentCustomerAccountNumber',
  ParentCustomerID = 'ParentCustomerID',
  ParentCustomerName = 'ParentCustomerName',
  PostCode = 'PostCode',
  SalesPersonName = 'SalesPersonName',
  State = 'State',
  TotalValue = 'TotalValue',
  Town = 'Town',
}

export type CustomerSortSortByInput = {
  /** Field */
  field?: InputMaybe<CustomerSort>;
  order: OrderType;
};

export type CustomerType = {
  __typename?: 'CustomerType';
  accountManagerName?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  billParent?: Maybe<Scalars['Boolean']['output']>;
  ccEmailAddress?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhoneNumber?: Maybe<Scalars['String']['output']>;
  contracts?: Maybe<Array<Maybe<ContractType>>>;
  country?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  customerAccountNumber: Scalars['String']['output'];
  customerID: Scalars['ID']['output'];
  customerName: Scalars['String']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  parentCustomer?: Maybe<CustomerType>;
  postCode?: Maybe<Scalars['String']['output']>;
  salesPersonName?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  town?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type DNRContractLineDataType = {
  comment: Scalars['String']['input'];
  contractLineID: Scalars['ID']['input'];
  dnrDate: Scalars['DateTime']['input'];
  noFurtherBilling: Scalars['Boolean']['input'];
  noFurtherBillingDate?: InputMaybe<Scalars['DateTime']['input']>;
  reasonCode: Scalars['String']['input'];
};

export type DNRContractLinesInputType = {
  comment: Scalars['String']['input'];
  contractId: Scalars['ID']['input'];
  contractLines: Array<ContractLineDataType>;
  dnrDate: Scalars['DateTime']['input'];
  noFurtherBilling: Scalars['Boolean']['input'];
  noFurtherBillingDate?: InputMaybe<Scalars['DateTime']['input']>;
  reasonCode: Scalars['String']['input'];
};

export type DateFilterInput = {
  /** Advanced */
  advanced?: InputMaybe<DateTimeDateAdvancedFilterInput>;
  /** Between */
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** ContainsValues */
  containsValues?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  dayX?: InputMaybe<Scalars['Byte']['input']>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  ge?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  lastCalendarMonth?: InputMaybe<Scalars['Boolean']['input']>;
  lastCalendarYear?: InputMaybe<Scalars['Boolean']['input']>;
  lastXDays?: InputMaybe<Scalars['Int']['input']>;
  lastXMonths?: InputMaybe<Scalars['Int']['input']>;
  lastXYears?: InputMaybe<Scalars['Int']['input']>;
  le?: InputMaybe<Scalars['DateTime']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  monthX?: InputMaybe<Scalars['Byte']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  nextCalendarMonth?: InputMaybe<Scalars['Boolean']['input']>;
  nextCalendarYear?: InputMaybe<Scalars['Boolean']['input']>;
  nextXDays?: InputMaybe<Scalars['Int']['input']>;
  nextXMonths?: InputMaybe<Scalars['Int']['input']>;
  nextXYears?: InputMaybe<Scalars['Int']['input']>;
  /** NotBetween */
  notBetween?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** NotContainsValues */
  notContainsValues?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  notDayX?: InputMaybe<Scalars['Byte']['input']>;
  notLastCalendarMonth?: InputMaybe<Scalars['Boolean']['input']>;
  notLastCalendarYear?: InputMaybe<Scalars['Boolean']['input']>;
  notMonthX?: InputMaybe<Scalars['Byte']['input']>;
  notNextCalendarMonth?: InputMaybe<Scalars['Boolean']['input']>;
  notNextCalendarYear?: InputMaybe<Scalars['Boolean']['input']>;
  notThisCalendarMonth?: InputMaybe<Scalars['Boolean']['input']>;
  notThisCalendarYear?: InputMaybe<Scalars['Boolean']['input']>;
  notToday?: InputMaybe<Scalars['Boolean']['input']>;
  notTomorrow?: InputMaybe<Scalars['Boolean']['input']>;
  notYearX?: InputMaybe<Scalars['Int']['input']>;
  notYesterday?: InputMaybe<Scalars['Boolean']['input']>;
  thisCalendarMonth?: InputMaybe<Scalars['Boolean']['input']>;
  thisCalendarMonthInAnyYear?: InputMaybe<Scalars['Boolean']['input']>;
  thisCalendarYear?: InputMaybe<Scalars['Boolean']['input']>;
  today?: InputMaybe<Scalars['Boolean']['input']>;
  todayInAnyYear?: InputMaybe<Scalars['Boolean']['input']>;
  tomorrow?: InputMaybe<Scalars['Boolean']['input']>;
  yearX?: InputMaybe<Scalars['Int']['input']>;
  yesterday?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DateFilterTypes {
  After = 'After',
  Before = 'Before',
  Between = 'Between',
  DayX = 'DayX',
  Equals = 'Equals',
  IsBlank = 'IsBlank',
  IsNotBlank = 'IsNotBlank',
  LastCalendarMonth = 'LastCalendarMonth',
  LastCalendarYear = 'LastCalendarYear',
  LastXDays = 'LastXDays',
  LastXMonths = 'LastXMonths',
  LastXYears = 'LastXYears',
  MonthX = 'MonthX',
  NextCalendarMonth = 'NextCalendarMonth',
  NextCalendarYear = 'NextCalendarYear',
  NextXDays = 'NextXDays',
  NextXMonths = 'NextXMonths',
  NextXYears = 'NextXYears',
  NotLastCalendarMonth = 'NotLastCalendarMonth',
  NotLastCalendarYear = 'NotLastCalendarYear',
  NotNextCalendarMonth = 'NotNextCalendarMonth',
  NotNextCalendarYear = 'NotNextCalendarYear',
  NotThisCalendarMonth = 'NotThisCalendarMonth',
  NotThisCalendarYear = 'NotThisCalendarYear',
  NotToday = 'NotToday',
  NotTomorrow = 'NotTomorrow',
  NotYesterday = 'NotYesterday',
  ThisCalendarMonth = 'ThisCalendarMonth',
  ThisCalendarYear = 'ThisCalendarYear',
  Today = 'Today',
  TodayInAnyYear = 'TodayInAnyYear',
  Tomorrow = 'Tomorrow',
  Yesterday = 'Yesterday',
}

export type DateTimeDateAdvancedFilterInput = {
  counter?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<DateFilterTypes>;
};

export type DateTimeFilterInput = {
  /** Advanced */
  advanced?: InputMaybe<DateTimeDateAdvancedFilterInput>;
  /** Between */
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** ContainsValues */
  containsValues?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** DateOnly */
  dateOnly?: InputMaybe<DateFilterInput>;
  dayX?: InputMaybe<Scalars['Byte']['input']>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  ge?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  lastCalendarMonth?: InputMaybe<Scalars['Boolean']['input']>;
  lastCalendarYear?: InputMaybe<Scalars['Boolean']['input']>;
  lastXDays?: InputMaybe<Scalars['Int']['input']>;
  lastXMonths?: InputMaybe<Scalars['Int']['input']>;
  lastXYears?: InputMaybe<Scalars['Int']['input']>;
  le?: InputMaybe<Scalars['DateTime']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  monthX?: InputMaybe<Scalars['Byte']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  nextCalendarMonth?: InputMaybe<Scalars['Boolean']['input']>;
  nextCalendarYear?: InputMaybe<Scalars['Boolean']['input']>;
  nextXDays?: InputMaybe<Scalars['Int']['input']>;
  nextXMonths?: InputMaybe<Scalars['Int']['input']>;
  nextXYears?: InputMaybe<Scalars['Int']['input']>;
  /** NotBetween */
  notBetween?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** NotContainsValues */
  notContainsValues?: InputMaybe<
    Array<InputMaybe<Scalars['DateTime']['input']>>
  >;
  notDayX?: InputMaybe<Scalars['Byte']['input']>;
  notLastCalendarMonth?: InputMaybe<Scalars['Boolean']['input']>;
  notLastCalendarYear?: InputMaybe<Scalars['Boolean']['input']>;
  notMonthX?: InputMaybe<Scalars['Byte']['input']>;
  notNextCalendarMonth?: InputMaybe<Scalars['Boolean']['input']>;
  notNextCalendarYear?: InputMaybe<Scalars['Boolean']['input']>;
  notThisCalendarMonth?: InputMaybe<Scalars['Boolean']['input']>;
  notThisCalendarYear?: InputMaybe<Scalars['Boolean']['input']>;
  notToday?: InputMaybe<Scalars['Boolean']['input']>;
  notTomorrow?: InputMaybe<Scalars['Boolean']['input']>;
  notYearX?: InputMaybe<Scalars['Int']['input']>;
  notYesterday?: InputMaybe<Scalars['Boolean']['input']>;
  thisCalendarMonth?: InputMaybe<Scalars['Boolean']['input']>;
  thisCalendarMonthInAnyYear?: InputMaybe<Scalars['Boolean']['input']>;
  thisCalendarYear?: InputMaybe<Scalars['Boolean']['input']>;
  today?: InputMaybe<Scalars['Boolean']['input']>;
  todayInAnyYear?: InputMaybe<Scalars['Boolean']['input']>;
  tomorrow?: InputMaybe<Scalars['Boolean']['input']>;
  yearX?: InputMaybe<Scalars['Int']['input']>;
  yesterday?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DecimalFilterInput = {
  /** Between */
  between?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  /** ContainsValues */
  containsValues?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  ge?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  le?: InputMaybe<Scalars['Decimal']['input']>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  ne?: InputMaybe<Scalars['Decimal']['input']>;
  /** NotBetween */
  notBetween?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  /** NotContainsValues */
  notContainsValues?: InputMaybe<
    Array<InputMaybe<Scalars['Decimal']['input']>>
  >;
};

export type DeleteProductMergeDefaultResultType = {
  __typename?: 'DeleteProductMergeDefaultResultType';
  code: ResultEnum;
  message?: Maybe<Scalars['String']['output']>;
};

export type DirectDebitInputType = {
  contractId: Scalars['ID']['input'];
  directDebitType?: InputMaybe<Scalars['String']['input']>;
};

export type DirectDebitType = {
  __typename?: 'DirectDebitType';
  formattedType: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type DisplaySettingsType = {
  __typename?: 'DisplaySettingsType';
  hide: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export enum DocumentTypeEnum {
  BULK_CONTRACT_LINE_UPDATE = 'BULK_CONTRACT_LINE_UPDATE',
  BULK_UPDATE_SUPPORT = 'BULK_UPDATE_SUPPORT',
  IMPORT = 'IMPORT',
  UPLIFT = 'UPLIFT',
  VAR_BILLING = 'VAR_BILLING',
}

export type EditPurchaseOrderInputType = {
  customerId: Scalars['ID']['input'];
  poCurrency?: InputMaybe<Scalars['String']['input']>;
  poDate?: InputMaybe<Scalars['DateTime']['input']>;
  poEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  poNote?: InputMaybe<Scalars['String']['input']>;
  poNumber: Scalars['String']['input'];
  poStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  poStatus?: InputMaybe<PurchaseOrderStatusEnum>;
  poTotalValue?: InputMaybe<Scalars['Decimal']['input']>;
  purchaseOrderId: Scalars['ID']['input'];
};

export enum EntityTypeEnum {
  BUNDLE = 'BUNDLE',
  CONTRACT = 'CONTRACT',
  CONTRACT_LINE = 'CONTRACT_LINE',
  CUSTOMER = 'CUSTOMER',
  PRODUCT = 'PRODUCT',
  PURCHASE_ORDER = 'PURCHASE_ORDER',
  SALES_ORDER = 'SALES_ORDER',
  UPLIFT_INDEX = 'UPLIFT_INDEX',
  UPLIFT_REGION = 'UPLIFT_REGION',
}

export enum EventSourceTypeEnum {
  SYSTEM = 'SYSTEM',
  USER = 'USER',
}

export enum EventTypeEnum {
  CREATED = 'CREATED',
  DELETED = 'DELETED',
  UPDATED = 'UPDATED',
}

export type ExemptFromUpliftInputType = {
  contractId: Scalars['ID']['input'];
  endDate: Scalars['DateTime']['input'];
  reasonCode: Scalars['String']['input'];
};

export type ExportInput = {
  /** Columns */
  columns?: InputMaybe<Array<InputMaybe<ColumnInput>>>;
  filter: Scalars['String']['input'];
  form?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
};

export type ExportJobMutation = {
  __typename?: 'ExportJobMutation';
  createExportJob?: Maybe<ExportRequestReceiptTypeResultGraphType>;
};

export type ExportJobMutationcreateExportJobArgs = {
  input: ExportInput;
};

export type ExportRequestReceipt = {
  __typename?: 'ExportRequestReceipt';
  id: Scalars['ID']['output'];
};

export type ExportRequestReceiptTypeResultGraphType =
  | ExportRequestReceipt
  | FailedValidation
  | UnexpectedError;

export type FailedValidation = {
  __typename?: 'FailedValidation';
  errors: Array<ValidationItem>;
  warnings: Array<ValidationItem>;
};

export type FieldVerificationType = {
  __typename?: 'FieldVerificationType';
  comment?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  entityID: Scalars['ID']['output'];
  entityType: EntityTypeEnum;
  fieldVerificationID: Scalars['ID']['output'];
  fields: Array<Maybe<Scalars['String']['output']>>;
  reasonCode: Scalars['String']['output'];
  type: FieldVerificationTypeEnum;
  updated?: Maybe<Scalars['DateTime']['output']>;
  userID: Scalars['ID']['output'];
  verifiedAt: Scalars['DateTime']['output'];
};

export enum FieldVerificationTypeEnum {
  REMOVED = 'REMOVED',
  UNVERIFY = 'UNVERIFY',
  VERIFY = 'VERIFY',
}

export type FilterContractLinesForUpliftType = {
  billingIntervals?: InputMaybe<Array<Scalars['String']['input']>>;
  includeContractIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  includeContractLineIds?: InputMaybe<
    Array<InputMaybe<Scalars['ID']['input']>>
  >;
  includeCustomerId?: InputMaybe<Scalars['ID']['input']>;
  includeDirectDebits?: InputMaybe<Scalars['Boolean']['input']>;
  includeExemptFromUplift?: InputMaybe<Scalars['Boolean']['input']>;
  nextBillingDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  nextBillingDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  productCodeLookup?: InputMaybe<Scalars['String']['input']>;
};

export type FormattedBillingCycleStatusEnum = {
  __typename?: 'FormattedBillingCycleStatusEnum';
  formattedKey: Scalars['String']['output'];
  key: BillingCycleStatusEnum;
};

export type FormattedContractOriginEnum = {
  __typename?: 'FormattedContractOriginEnum';
  formattedKey: Scalars['String']['output'];
  key: ContractOriginEnum;
};

export enum Forms {
  Billing = 'Billing',
  BillingByBillingCycles = 'BillingByBillingCycles',
  BillingCycles = 'BillingCycles',
  Bundles = 'Bundles',
  ClientDatabases = 'ClientDatabases',
  ContractDetailsSalesOrders = 'ContractDetailsSalesOrders',
  ContractDetailsSalesOrdersByBc = 'ContractDetailsSalesOrdersByBc',
  ContractLines = 'ContractLines',
  Contracts = 'Contracts',
  ContractsBC = 'ContractsBC',
  Customers = 'Customers',
  CustomersLookup = 'CustomersLookup',
  Products = 'Products',
  PurchaseOrders = 'PurchaseOrders',
  Uplifts = 'Uplifts',
}

export type FullContractInputType = {
  clientDatabaseReference?: InputMaybe<Scalars['String']['input']>;
  contractNumber: Scalars['String']['input'];
  contractStartDate: Scalars['DateTime']['input'];
  currency: Scalars['String']['input'];
  daysBeforeRenewal?: InputMaybe<Scalars['Int']['input']>;
  directDebit?: InputMaybe<Scalars['String']['input']>;
  externalContractID?: InputMaybe<Scalars['String']['input']>;
  hideContractLines?: InputMaybe<Scalars['Boolean']['input']>;
  origin?: InputMaybe<ContractOriginEnum>;
  renewableTerm: Scalars['Int']['input'];
  reseller?: InputMaybe<Scalars['Boolean']['input']>;
  sfContractId?: InputMaybe<Scalars['String']['input']>;
  status: ContractStatusEnum;
  term: Scalars['Int']['input'];
  termsAndConditions?: InputMaybe<TermsAndConditionsInputType>;
  upliftCaps?: InputMaybe<ContractUpliftCapsInputType>;
  upliftSettingsInput?: InputMaybe<UpliftSettingsInputType>;
};

export type GeneralMutations = {
  __typename?: 'GeneralMutations';
  /** Export jobs mutations */
  exportJobs?: Maybe<ExportJobMutation>;
};

export type GetChangesInput = {
  entityId?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GetCustomerContractsCountInputType = {
  customerId: Scalars['ID']['input'];
};

export type GetLatestFieldVerificationsInputType = {
  entityID: Scalars['ID']['input'];
  entityType: EntityTypeEnum;
};

export type GetPaginatedChangesInput = {
  entityId?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sortDirection?: InputMaybe<SortDirectionEnum>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GetPaginatedContractNotesInputType = {
  order?: InputMaybe<OrderType>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type GetPaginatedFieldVerificationsInputType = {
  entityID: Scalars['ID']['input'];
  entityType: EntityTypeEnum;
  order?: InputMaybe<OrderType>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type GetPreviewSalesOrderByBillingCycleInputType = {
  billingCycleId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional invoice date to override SendingDate and OrderDate. Must be >= today if provided. */
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  soByBcId?: InputMaybe<Scalars['ID']['input']>;
};

export type GroupedSalesOrdersQuantitiesType = {
  __typename?: 'GroupedSalesOrdersQuantitiesType';
  consolidated?: Maybe<Array<Maybe<SalesOrdersQuantitiesType>>>;
  nonConsolidated?: Maybe<Array<Maybe<SalesOrdersQuantitiesType>>>;
};

export type GuidFilterInput = {
  /** ContainsValues */
  containsValues?: InputMaybe<Array<InputMaybe<Scalars['Guid']['input']>>>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  /** NotContainsValues */
  notContainsValues?: InputMaybe<Array<InputMaybe<Scalars['Guid']['input']>>>;
};

export type IgnoreBillingCycleInput = {
  billingCycleId: Scalars['ID']['input'];
  contractId: Scalars['ID']['input'];
  contractLineId: Scalars['ID']['input'];
};

export type IgnoreBillingCycleResult = {
  __typename?: 'IgnoreBillingCycleResult';
  code: ResultEnum;
  message?: Maybe<Scalars['String']['output']>;
};

export type IgnoreBillingCyclesInput = {
  consolidationCriteriaCode: Scalars['String']['input'];
};

export type IgnoreBillingCyclesResult = {
  __typename?: 'IgnoreBillingCyclesResult';
  code: ResultEnum;
  message?: Maybe<Scalars['String']['output']>;
};

export type IgnoreUsageDetailsInputType = {
  ignoreComment?: InputMaybe<Scalars['String']['input']>;
  usageDetails: Array<UsageDetailDataInputType>;
  usageHeaderId: Scalars['Guid']['input'];
};

export enum ImportDocumentStatusEnum {
  DRAFT = 'DRAFT',
  IMPORTED = 'IMPORTED',
  IMPORTING = 'IMPORTING',
  IMPORT_ERROR = 'IMPORT_ERROR',
  PROCESSED = 'PROCESSED',
  PROCESSING = 'PROCESSING',
  PROCESS_ERROR = 'PROCESS_ERROR',
  UPLOADED = 'UPLOADED',
  VALIDATED = 'VALIDATED',
  VALIDATING = 'VALIDATING',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
}

export type ImportDocumentType = {
  __typename?: 'ImportDocumentType';
  created?: Maybe<Scalars['DateTime']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  iD?: Maybe<Scalars['ID']['output']>;
  logFileID?: Maybe<Scalars['ID']['output']>;
  numberOfRows?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ImportDocumentStatusEnum>;
  tenantID?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<DocumentTypeEnum>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  uploadID?: Maybe<Scalars['String']['output']>;
  uploadedBy?: Maybe<Scalars['ID']['output']>;
};

export type IntFilterInput = {
  /** Between */
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** ContainsValues */
  containsValues?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  /** NotBetween */
  notBetween?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** NotContainsValues */
  notContainsValues?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type LatestFieldVerificationType = {
  __typename?: 'LatestFieldVerificationType';
  field: Scalars['String']['output'];
  type: FieldVerificationTypeEnum;
  userID: Scalars['ID']['output'];
  verifiedAt: Scalars['DateTime']['output'];
};

export type LongFilterInput = {
  /** Between */
  between?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  /** ContainsValues */
  containsValues?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  eq?: InputMaybe<Scalars['Long']['input']>;
  ge?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  le?: InputMaybe<Scalars['Long']['input']>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  ne?: InputMaybe<Scalars['Long']['input']>;
  /** NotBetween */
  notBetween?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  /** NotContainsValues */
  notContainsValues?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type MatchUsageDetailsInputType = {
  billingEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  billingStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  usageHeaderId: Scalars['ID']['input'];
};

export type MergeCustomersInputType = {
  destinationCustomerAccountNumber: Scalars['String']['input'];
  sourceCustomerAccountNumber: Scalars['String']['input'];
};

export type MigrateContractsToOneEvoInput = {
  contractsToMigrate: Array<ContractsToMigrateInput>;
};

export enum NoticePeriodTypeEnum {
  Other = 'Other',
  Standard = 'Standard',
}

export type NullableSalesOrderCustomerType = {
  __typename?: 'NullableSalesOrderCustomerType';
  customerAccountNumber?: Maybe<Scalars['String']['output']>;
  customerID?: Maybe<Scalars['ID']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  parentCustomer?: Maybe<NullableSalesOrderCustomerType>;
};

export type NullableSalesOrderSearchResultType = {
  __typename?: 'NullableSalesOrderSearchResultType';
  amount?: Maybe<Scalars['String']['output']>;
  billDate?: Maybe<Scalars['DateTime']['output']>;
  billedCustomer?: Maybe<NullableSalesOrderCustomerType>;
  billingInterval?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  billingType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  comment?: Maybe<Scalars['String']['output']>;
  consolidated?: Maybe<Scalars['Boolean']['output']>;
  contractID?: Maybe<Scalars['ID']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  contracts?: Maybe<Array<Maybe<SalesOrderContractInfoType>>>;
  created?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  divertCustomer?: Maybe<NullableSalesOrderCustomerType>;
  hasMixedSoEndDate?: Maybe<Scalars['Boolean']['output']>;
  hasMixedSoStartDate?: Maybe<Scalars['Boolean']['output']>;
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  isAbandoned?: Maybe<Scalars['Boolean']['output']>;
  reasonCode?: Maybe<Scalars['String']['output']>;
  referenceSalesOrderID?: Maybe<Scalars['String']['output']>;
  salesOrderID?: Maybe<Scalars['ID']['output']>;
  sentDate?: Maybe<Scalars['DateTime']['output']>;
  soEndDate?: Maybe<Scalars['DateTime']['output']>;
  soStartDate?: Maybe<Scalars['DateTime']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SalesOrderStatusType>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** A connection from an object to a list of objects of type `NullableUnionSalesOrderSearchOutput`. */
export type NullableUnionSalesOrderSearchOutputConnection = {
  __typename?: 'NullableUnionSalesOrderSearchOutputConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<NullableUnionSalesOrderSearchOutputEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<NullableSalesOrderSearchResultType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `NullableUnionSalesOrderSearchOutput`. */
export type NullableUnionSalesOrderSearchOutputEdge = {
  __typename?: 'NullableUnionSalesOrderSearchOutputEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<NullableSalesOrderSearchResultType>;
};

export enum OrderType {
  Ascending = 'Ascending',
  Descending = 'Descending',
}

export type PONumberInputType = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  required: Scalars['Boolean']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginatedCommissionsReport = {
  __typename?: 'PaginatedCommissionsReport';
  data: Array<CommissionsReportLine>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  pageIndex: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedContractChanges = {
  __typename?: 'PaginatedContractChanges';
  data: Array<ContractChangeType>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  pageIndex: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedContractLineChanges = {
  __typename?: 'PaginatedContractLineChanges';
  data: Array<ContractLineChangeType>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  pageIndex: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedContractLines = {
  __typename?: 'PaginatedContractLines';
  data: Array<ContractLineByBillingCyclesType>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  pageIndex: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedContractLinesByBillingCyclesType = {
  __typename?: 'PaginatedContractLinesByBillingCyclesType';
  data: Array<ContractLineByBillingCyclesType>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  pageIndex: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedContractNotes = {
  __typename?: 'PaginatedContractNotes';
  data: Array<ContractNoteType>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  pageIndex: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedContracts = {
  __typename?: 'PaginatedContracts';
  data: Array<ContractType>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  pageIndex: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedContractsInputType = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  includeContractsFromChildCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PaginatedCustomerChanges = {
  __typename?: 'PaginatedCustomerChanges';
  data: Array<CustomerChangeType>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  pageIndex: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedCustomersDetails = {
  __typename?: 'PaginatedCustomersDetails';
  data: Array<CustomerDetailsType>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  pageIndex: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedFieldVerifications = {
  __typename?: 'PaginatedFieldVerifications';
  data: Array<FieldVerificationType>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  pageIndex: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

/** A connection from an object to a list of objects of type `PaginatedFilteredUplift`. */
export type PaginatedFilteredUpliftConnection = {
  __typename?: 'PaginatedFilteredUpliftConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<PaginatedFilteredUpliftEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<PaginatedFilteredUpliftType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `PaginatedFilteredUplift`. */
export type PaginatedFilteredUpliftEdge = {
  __typename?: 'PaginatedFilteredUpliftEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PaginatedFilteredUpliftType>;
};

export type PaginatedFilteredUpliftType = {
  __typename?: 'PaginatedFilteredUpliftType';
  annualBillingPeriodValueDifference?: Maybe<Scalars['String']['output']>;
  billToParent?: Maybe<Scalars['Boolean']['output']>;
  billingPeriodValueDifference?: Maybe<Scalars['String']['output']>;
  contractID: Scalars['ID']['output'];
  contractNumber?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['Guid']['output']>;
  customerAccountNumber?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['DateTime']['output']>;
  iD?: Maybe<Scalars['ID']['output']>;
  lastSalesOrderDate?: Maybe<Scalars['DateTime']['output']>;
  lastSalesOrderValue?: Maybe<Scalars['String']['output']>;
  nextAnnualBillingPeriodValue?: Maybe<Scalars['String']['output']>;
  nextBillingPeriodValue?: Maybe<Scalars['String']['output']>;
  nextUpliftDate?: Maybe<Scalars['DateTime']['output']>;
  origin?: Maybe<UpliftOriginPascalCaseEnum>;
  parentCustomerAccountNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<UpliftStatusEnum>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  stockCode?: Maybe<Scalars['String']['output']>;
  stockName?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['Guid']['output']>;
  upliftMethod?: Maybe<UpliftMethodPascalCaseEnum>;
  upliftValue?: Maybe<Scalars['String']['output']>;
};

export type PaginatedReasonCodes = {
  __typename?: 'PaginatedReasonCodes';
  data: Array<ReasonCodeType>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  pageIndex: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedReasonCodesInputType = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type PaginatedSalesOrders = {
  __typename?: 'PaginatedSalesOrders';
  data: Array<NullableSalesOrderSearchResultType>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  pageIndex: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedSalesOrdersInputType = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  filters?: InputMaybe<Array<SalesOrderFilterType>>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  status?: InputMaybe<Array<SalesOrderStatusEnum>>;
  type?: InputMaybe<SalesOrderTypeEnum>;
};

export type PauseBillingInputType = {
  collectible?: InputMaybe<Scalars['Boolean']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['ID']['input'];
  endDate: Scalars['DateTime']['input'];
  reasonCode: Scalars['String']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type PauseContractLineInputType = {
  comment?: InputMaybe<Scalars['String']['input']>;
  contracts: Array<ContractWithContractLinesInputType>;
  endDate: Scalars['DateTime']['input'];
  reasonCode?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  /** Optional start date for the pause. If not provided, pause starts immediately. If provided, must be >= current date. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PreReinvoicingChecksInputType = {
  items: Array<PreReinvoicingChecksItemInputType>;
};

export type PreReinvoicingChecksItemInputType = {
  billingEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  billingStartDate: Scalars['DateTime']['input'];
  contractId: Scalars['ID']['input'];
  contractLineId: Scalars['ID']['input'];
};

export type PreReinvoicingChecksOutputType = {
  __typename?: 'PreReinvoicingChecksOutputType';
  activePendingPeriods?: Maybe<Array<Maybe<BillingPeriodType>>>;
  isReinvoicingActivePendingPeriods: Scalars['Boolean']['output'];
  isReinvoicingAlreadyReinvoicedPeriod: Scalars['Boolean']['output'];
  reinvoicedPeriods?: Maybe<Array<Maybe<BillingPeriodType>>>;
};

export type PrevNextContractIds = {
  __typename?: 'PrevNextContractIds';
  contractID: Scalars['ID']['output'];
  nextID?: Maybe<Scalars['ID']['output']>;
  prevID?: Maybe<Scalars['ID']['output']>;
};

export type ProcessUsageDetailsInputType = {
  billingEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  billingStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  usageHeaderId: Scalars['ID']['input'];
};

export type ProductFilterInput = {
  /** DefaultBillingType */
  defaultBillingType?: InputMaybe<StringFilterInput>;
  /** ID */
  iD?: InputMaybe<GuidFilterInput>;
  /** MergeType */
  mergeType?: InputMaybe<ProductMergeTypeEnumEnumFilterInput>;
  /** ProductDivision */
  productDivision?: InputMaybe<StringFilterInput>;
  /** ProductFamily */
  productFamily?: InputMaybe<StringFilterInput>;
  /** ProductName */
  productName?: InputMaybe<StringFilterInput>;
  /** SoftwareCompany */
  softwareCompany?: InputMaybe<StringFilterInput>;
  /** StockCode */
  stockCode?: InputMaybe<StringFilterInput>;
  /** StockName */
  stockName?: InputMaybe<StringFilterInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type ProductMergeDefaultOutputType = {
  __typename?: 'ProductMergeDefaultOutputType';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  iD: Scalars['ID']['output'];
  mergeType?: Maybe<ProductMergeTypeEnum>;
  stockCodeContains: Scalars['String']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
};

export enum ProductMergeTypeEnum {
  MergeByQuantity = 'MergeByQuantity',
  MergeByUnitPrice = 'MergeByUnitPrice',
  NoMerge = 'NoMerge',
}

export type ProductMergeTypeEnumEnumFilterInput = {
  /** ContainsValues */
  containsValues?: InputMaybe<Array<InputMaybe<ProductMergeTypeEnum>>>;
  eq?: InputMaybe<ProductMergeTypeEnum>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<ProductMergeTypeEnum>;
  /** NotContainsValues */
  notContainsValues?: InputMaybe<Array<InputMaybe<ProductMergeTypeEnum>>>;
};

/** A connection from an object to a list of objects of type `ProductOutput`. */
export type ProductOutputConnection = {
  __typename?: 'ProductOutputConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<ProductOutputEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<ProductOutputType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `ProductOutput`. */
export type ProductOutputEdge = {
  __typename?: 'ProductOutputEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ProductOutputType>;
};

export type ProductOutputType = {
  __typename?: 'ProductOutputType';
  defaultBillingType?: Maybe<Scalars['String']['output']>;
  iD?: Maybe<Scalars['ID']['output']>;
  mergeType?: Maybe<ProductMergeTypeEnum>;
  productDivision?: Maybe<Scalars['String']['output']>;
  productFamily?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  softwareCompany?: Maybe<Scalars['String']['output']>;
  stockCode?: Maybe<Scalars['String']['output']>;
  stockName?: Maybe<Scalars['String']['output']>;
};

export enum ProductSort {
  DefaultBillingType = 'DefaultBillingType',
  ID = 'ID',
  MergeType = 'MergeType',
  ProductDivision = 'ProductDivision',
  ProductFamily = 'ProductFamily',
  ProductName = 'ProductName',
  SoftwareCompany = 'SoftwareCompany',
  StockCode = 'StockCode',
  StockName = 'StockName',
}

export type ProductSortSortByInput = {
  /** Field */
  field?: InputMaybe<ProductSort>;
  order: OrderType;
};

export type ProductType = {
  __typename?: 'ProductType';
  defaultBillingType: BillingType;
  id: Scalars['ID']['output'];
  productDivision: Scalars['String']['output'];
  productFamily: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  softwareCompany?: Maybe<Scalars['String']['output']>;
  stockCode: Scalars['String']['output'];
  stockName: Scalars['String']['output'];
  /** @deprecated Please use 'Id' field. */
  value: Scalars['ID']['output'];
};

export type PurchaseOrderFilterInput = {
  customerCode?: InputMaybe<StringFilterInput>;
  customerName?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<GuidFilterInput>;
  poCurrency?: InputMaybe<StringFilterInput>;
  poDate?: InputMaybe<DateTimeFilterInput>;
  poEndDate?: InputMaybe<DateTimeFilterInput>;
  poNumber?: InputMaybe<StringFilterInput>;
  poRemainingValue?: InputMaybe<StringifiedDecimalFilterInput>;
  poStartDate?: InputMaybe<DateTimeFilterInput>;
  poStatus?: InputMaybe<PurchaseOrderStatusEnumFilterInput>;
  poTotalValue?: InputMaybe<StringifiedDecimalFilterInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

/** A connection from an object to a list of objects of type `PurchaseOrderOutput`. */
export type PurchaseOrderOutputConnection = {
  __typename?: 'PurchaseOrderOutputConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<PurchaseOrderOutputEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<PurchaseOrderOutputType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `PurchaseOrderOutput`. */
export type PurchaseOrderOutputEdge = {
  __typename?: 'PurchaseOrderOutputEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PurchaseOrderOutputType>;
};

export type PurchaseOrderOutputType = {
  __typename?: 'PurchaseOrderOutputType';
  customerCode?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  poCurrency?: Maybe<Scalars['String']['output']>;
  poDate?: Maybe<Scalars['DateTime']['output']>;
  poEndDate?: Maybe<Scalars['DateTime']['output']>;
  poNote?: Maybe<Scalars['String']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  poRemainingValue?: Maybe<Scalars['String']['output']>;
  poStartDate?: Maybe<Scalars['DateTime']['output']>;
  poStatus?: Maybe<PurchaseOrderStatusEnum>;
  poTotalValue?: Maybe<Scalars['String']['output']>;
};

export enum PurchaseOrderSort {
  Created = 'Created',
  CustomerCode = 'CustomerCode',
  CustomerName = 'CustomerName',
  Id = 'Id',
  PoCurrency = 'PoCurrency',
  PoDate = 'PoDate',
  PoEndDate = 'PoEndDate',
  PoNumber = 'PoNumber',
  PoRemainingValue = 'PoRemainingValue',
  PoStartDate = 'PoStartDate',
  PoStatus = 'PoStatus',
  PoTotalValue = 'PoTotalValue',
}

export type PurchaseOrderSortSortByInput = {
  /** Field */
  field?: InputMaybe<PurchaseOrderSort>;
  order: OrderType;
};

export enum PurchaseOrderStatusEnum {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Expired = 'Expired',
}

export type PurchaseOrderStatusEnumFilterInput = {
  containsValues?: InputMaybe<Array<InputMaybe<PurchaseOrderStatusEnum>>>;
  eq?: InputMaybe<PurchaseOrderStatusEnum>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<PurchaseOrderStatusEnum>;
  notContainsValues?: InputMaybe<Array<InputMaybe<PurchaseOrderStatusEnum>>>;
};

export type RaiseProformaInputType = {
  contractID: Scalars['ID']['input'];
};

export type RaiseProformaResultType = {
  __typename?: 'RaiseProformaResultType';
  code: ResultEnum;
  message?: Maybe<Scalars['String']['output']>;
};

export type ReasonCodeInputType = {
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ReasonCodeType = {
  __typename?: 'ReasonCodeType';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  reasonType?: Maybe<ReasonType>;
  tenantID: Scalars['ID']['output'];
};

export type ReasonType = {
  __typename?: 'ReasonType';
  formattedType: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type RecentSavedSearchFilterInput = {
  includePublicSearches?: InputMaybe<Scalars['Boolean']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type RemoveFieldVerificationInputType = {
  fieldVerificationID: Scalars['ID']['input'];
};

export type RemoveUpliftExemptionInputType = {
  contractId: Scalars['ID']['input'];
};

export type RemoveVerifiableFieldInputType = {
  entityType: EntityTypeEnum;
  field: Scalars['String']['input'];
  reasonCode: Scalars['String']['input'];
};

export type RenewalRangeType = {
  __typename?: 'RenewalRangeType';
  maxDays: Scalars['Int']['output'];
  minDays: Scalars['Int']['output'];
};

export type RenewalSettingsType = {
  __typename?: 'RenewalSettingsType';
  billingInterval: Scalars['String']['output'];
  editable: Scalars['Boolean']['output'];
  renewalDays: Scalars['Int']['output'];
  tenantID: Scalars['ID']['output'];
};

export type ResendSalesOrdersInputType = {
  salesOrderIds?: InputMaybe<Array<InputMaybe<Scalars['Guid']['input']>>>;
};

export type RestoreUsageDetailsInputType = {
  usageDetails: Array<UsageDetailDataInputType>;
  usageHeaderId: Scalars['Guid']['input'];
};

export enum ResultEnum {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
}

export type ResumeBillingInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['ID']['input'];
};

export type ResumeContractLineInputType = {
  comment?: InputMaybe<Scalars['String']['input']>;
  contracts: Array<ContractWithContractLinesInputType>;
};

export enum RevenueForecastGroupBy {
  Currency = 'Currency',
  Customer = 'Customer',
  ProductFamily = 'ProductFamily',
  Vintage = 'Vintage',
}

export type RevenueForecastOutput = {
  __typename?: 'RevenueForecastOutput';
  activeContracts: Scalars['Int']['output'];
  activeLines: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  forecastValue: Scalars['Decimal']['output'];
  groupKey: Scalars['String']['output'];
  groupKeySecondary?: Maybe<Scalars['String']['output']>;
  monthlyRunRate: Scalars['Decimal']['output'];
  uniqueCustomers: Scalars['Int']['output'];
};

export type RevenueLeakageBillingCycleFilterInput = {
  billingCycleID?: InputMaybe<GuidFilterInput>;
  billingDate?: InputMaybe<DateTimeFilterInput>;
  consolidateBilling?: InputMaybe<BooleanFilterInput>;
  contractLineID?: InputMaybe<GuidFilterInput>;
  contractLineStatus?: InputMaybe<StringFilterInput>;
  contractNumber?: InputMaybe<StringFilterInput>;
  contractStatus?: InputMaybe<StringFilterInput>;
  currency?: InputMaybe<StringFilterInput>;
  customerAccountNumber?: InputMaybe<StringFilterInput>;
  customerName?: InputMaybe<StringFilterInput>;
  lineBillingStatus?: InputMaybe<StringFilterInput>;
  noFurtherBilling?: InputMaybe<BooleanFilterInput>;
  processingStatus?: InputMaybe<BillingCycleStatusPascalCaseEnumFilterInput>;
  soCount?: InputMaybe<IntFilterInput>;
  stockCode?: InputMaybe<StringFilterInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type RevenueLeakageBillingCycleOutput = {
  __typename?: 'RevenueLeakageBillingCycleOutput';
  billingCycleID?: Maybe<Scalars['Guid']['output']>;
  billingDate?: Maybe<Scalars['DateTime']['output']>;
  billingValue?: Maybe<Scalars['Decimal']['output']>;
  consolidateBilling?: Maybe<Scalars['Boolean']['output']>;
  contractID?: Maybe<Scalars['Guid']['output']>;
  contractLineID?: Maybe<Scalars['Guid']['output']>;
  contractLineStatus?: Maybe<Scalars['String']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  contractStatus?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerAccountNumber?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  lineBillingPauseEndDate?: Maybe<Scalars['DateTime']['output']>;
  lineBillingStatus?: Maybe<Scalars['String']['output']>;
  nextBillingDate?: Maybe<Scalars['DateTime']['output']>;
  noFurtherBilling?: Maybe<Scalars['Boolean']['output']>;
  noFurtherBillingDate?: Maybe<Scalars['DateTime']['output']>;
  processingStatus?: Maybe<BillingCycleStatusEnum>;
  soCount?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  statusReason?: Maybe<Scalars['String']['output']>;
  stockCode?: Maybe<Scalars['String']['output']>;
  stockName?: Maybe<Scalars['String']['output']>;
};

/** A connection from an object to a list of objects of type `RevenueLeakageBillingCycleOutput`. */
export type RevenueLeakageBillingCycleOutputConnection = {
  __typename?: 'RevenueLeakageBillingCycleOutputConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<RevenueLeakageBillingCycleOutputEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<RevenueLeakageBillingCycleOutput>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `RevenueLeakageBillingCycleOutput`. */
export type RevenueLeakageBillingCycleOutputEdge = {
  __typename?: 'RevenueLeakageBillingCycleOutputEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<RevenueLeakageBillingCycleOutput>;
};

export enum RevenueLeakageBillingCycleSort {
  BillingCycleID = 'BillingCycleID',
  BillingDate = 'BillingDate',
  ConsolidateBilling = 'ConsolidateBilling',
  ContractLineID = 'ContractLineID',
  ContractLineStatus = 'ContractLineStatus',
  ContractNumber = 'ContractNumber',
  ContractStatus = 'ContractStatus',
  Currency = 'Currency',
  CustomerAccountNumber = 'CustomerAccountNumber',
  CustomerName = 'CustomerName',
  EndDate = 'EndDate',
  LineBillingStatus = 'LineBillingStatus',
  NextBillingDate = 'NextBillingDate',
  NoFurtherBilling = 'NoFurtherBilling',
  ProcessingStatus = 'ProcessingStatus',
  SoCount = 'SoCount',
  StartDate = 'StartDate',
  StatusReason = 'StatusReason',
  StockCode = 'StockCode',
  StockName = 'StockName',
}

export type RevenueLeakageBillingCycleSortSortByInput = {
  /** Field */
  field?: InputMaybe<RevenueLeakageBillingCycleSort>;
  order: OrderType;
};

export type RevenueLeakageByContract = {
  __typename?: 'RevenueLeakageByContract';
  contractNumber?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerAccountNumber?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  cycleCount?: Maybe<Scalars['Int']['output']>;
  newestBillingDate?: Maybe<Scalars['DateTime']['output']>;
  oldestBillingDate?: Maybe<Scalars['DateTime']['output']>;
  totalValue?: Maybe<Scalars['Decimal']['output']>;
};

export type RevenueLeakageByCustomer = {
  __typename?: 'RevenueLeakageByCustomer';
  contractCount?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerAccountNumber?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  cycleCount?: Maybe<Scalars['Int']['output']>;
  totalValue?: Maybe<Scalars['Decimal']['output']>;
};

export type RevenueLeakageByProduct = {
  __typename?: 'RevenueLeakageByProduct';
  contractCount?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  cycleCount?: Maybe<Scalars['Int']['output']>;
  stockCode?: Maybe<Scalars['String']['output']>;
  stockName?: Maybe<Scalars['String']['output']>;
  totalValue?: Maybe<Scalars['Decimal']['output']>;
};

export type RevenueLeakageConsolidationGroup = {
  __typename?: 'RevenueLeakageConsolidationGroup';
  consolidationCriteriaCode?: Maybe<Scalars['String']['output']>;
  contractCount?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerAccountNumber?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  oldestBillingDate?: Maybe<Scalars['DateTime']['output']>;
  stuckCycleCount?: Maybe<Scalars['Int']['output']>;
  totalValue?: Maybe<Scalars['Decimal']['output']>;
};

export type RevenueLeakageContextFlag = {
  __typename?: 'RevenueLeakageContextFlag';
  count?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  flag?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  totalValue?: Maybe<Scalars['Decimal']['output']>;
};

export type RevenueLeakageDiagnosisBreakdown = {
  __typename?: 'RevenueLeakageDiagnosisBreakdown';
  count?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  diagnosisCode?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  totalValue?: Maybe<Scalars['Decimal']['output']>;
};

export type RevenueLeakageMonthlyTrend = {
  __typename?: 'RevenueLeakageMonthlyTrend';
  currency?: Maybe<Scalars['String']['output']>;
  cycleCount?: Maybe<Scalars['Int']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  totalValue?: Maybe<Scalars['Decimal']['output']>;
};

export type RevenueLeakageOverdueDistribution = {
  __typename?: 'RevenueLeakageOverdueDistribution';
  bucket?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  cycleCount?: Maybe<Scalars['Int']['output']>;
  maxDays?: Maybe<Scalars['Int']['output']>;
  minDays?: Maybe<Scalars['Int']['output']>;
  totalValue?: Maybe<Scalars['Decimal']['output']>;
};

export type RevenueLeakageSummary = {
  __typename?: 'RevenueLeakageSummary';
  newestBillingDate?: Maybe<Scalars['DateTime']['output']>;
  oldestBillingDate?: Maybe<Scalars['DateTime']['output']>;
  totalCycles?: Maybe<Scalars['Int']['output']>;
  uniqueContracts?: Maybe<Scalars['Int']['output']>;
  uniqueCustomers?: Maybe<Scalars['Int']['output']>;
  withConsolidateBilling?: Maybe<Scalars['Int']['output']>;
  withNoFurtherBilling?: Maybe<Scalars['Int']['output']>;
  withZeroSoCount?: Maybe<Scalars['Int']['output']>;
};

export type RevenueLeakageSummaryByCurrency = {
  __typename?: 'RevenueLeakageSummaryByCurrency';
  count?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Decimal']['output']>;
};

export type RevenueLeakageSummaryByStatus = {
  __typename?: 'RevenueLeakageSummaryByStatus';
  count?: Maybe<Scalars['Int']['output']>;
  statusValue?: Maybe<Scalars['String']['output']>;
};

export enum RevenueRiskCategory {
  All = 'All',
  DNR = 'DNR',
  Renewal = 'Renewal',
}

export enum RevenueRiskGroupBy {
  Customer = 'Customer',
  Month = 'Month',
  ProductFamily = 'ProductFamily',
}

export type RevenueRiskOutput = {
  __typename?: 'RevenueRiskOutput';
  contracts: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  customers: Scalars['Int']['output'];
  groupKey: Scalars['String']['output'];
  groupKeySecondary?: Maybe<Scalars['String']['output']>;
  monthlyRunRateAtRisk: Scalars['Decimal']['output'];
};

export type RevertOneEvoMigrationInput = {
  contractIds: Array<Scalars['Guid']['input']>;
};

export type SalesOrderByBillingCycleFilterInput = {
  amount?: InputMaybe<StringifiedDecimalFilterInput>;
  billedCustomer?: InputMaybe<CustomerAdditionalFilterInput>;
  billingCycleId?: InputMaybe<GuidFilterInput>;
  billingInterval?: InputMaybe<StringFilterInput>;
  billingIntervals?: InputMaybe<StringArrayFilterInput>;
  comment?: InputMaybe<StringFilterInput>;
  consolidated?: InputMaybe<BooleanFilterInput>;
  contractId?: InputMaybe<GuidFilterInput>;
  contractNumber?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<DateFilterInput>;
  currency?: InputMaybe<StringFilterInput>;
  customerAccountNumber?: InputMaybe<StringFilterInput>;
  customerName?: InputMaybe<StringFilterInput>;
  divertCustomer?: InputMaybe<CustomerAdditionalFilterInput>;
  divertPaymentAccountName?: InputMaybe<StringFilterInput>;
  divertPaymentAccountNumber?: InputMaybe<StringFilterInput>;
  invoiceDate?: InputMaybe<DateTimeFilterInput>;
  isAbandoned?: InputMaybe<BooleanFilterInput>;
  reasonCode?: InputMaybe<StringFilterInput>;
  referenceSalesOrderID?: InputMaybe<StringFilterInput>;
  salesOrderID?: InputMaybe<GuidFilterInput>;
  salesOrderStatus?: InputMaybe<StringFilterInput>;
  sentDate?: InputMaybe<DateTimeFilterInput>;
  soEndDate?: InputMaybe<DateTimeFilterInput>;
  soStartDate?: InputMaybe<DateTimeFilterInput>;
  source?: InputMaybe<SalesOrderSourceEnumFilterInput>;
  status?: InputMaybe<SalesOrderStatusFilterInput>;
  statusMessage?: InputMaybe<StringFilterInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SalesOrderTypeEnumFilterInput>;
};

export enum SalesOrderByBillingCycleSort {
  Amount = 'Amount',
  BillingIntervals = 'BillingIntervals',
  BillingType = 'BillingType',
  Comment = 'Comment',
  Consolidated = 'Consolidated',
  ContractNumber = 'ContractNumber',
  Created = 'Created',
  CustomerAccountNumber = 'CustomerAccountNumber',
  CustomerName = 'CustomerName',
  DivertPaymentAccountName = 'DivertPaymentAccountName',
  DivertPaymentAccountNumber = 'DivertPaymentAccountNumber',
  ID = 'ID',
  InvoiceDate = 'InvoiceDate',
  IsAbandoned = 'IsAbandoned',
  ReasonCode = 'ReasonCode',
  ReferenceSalesOrderID = 'ReferenceSalesOrderID',
  SOEndDate = 'SOEndDate',
  SOStartDate = 'SOStartDate',
  SalesOrderID = 'SalesOrderID',
  SalesOrderStatus = 'SalesOrderStatus',
  SentDate = 'SentDate',
  Source = 'Source',
  StatusMessage = 'StatusMessage',
  Type = 'Type',
}

export type SalesOrderByBillingCycleSortSortByInput = {
  /** Field */
  field?: InputMaybe<SalesOrderByBillingCycleSort>;
  order: OrderType;
};

export type SalesOrderContractInfoType = {
  __typename?: 'SalesOrderContractInfoType';
  contractNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type SalesOrderDetailsType = {
  __typename?: 'SalesOrderDetailsType';
  consolidationFlag: Scalars['Boolean']['output'];
  contractClientDatabaseReference?: Maybe<Scalars['String']['output']>;
  contractNumbers: Scalars['String']['output'];
  payload: Scalars['String']['output'];
  salesOrderId: Scalars['Guid']['output'];
  salesOrderStatus: Scalars['String']['output'];
  statusMessage?: Maybe<Scalars['String']['output']>;
};

export enum SalesOrderFilterFieldNameEnum {
  CONTRACT_NUMBER = 'CONTRACT_NUMBER',
}

export type SalesOrderFilterInput = {
  amount?: InputMaybe<StringifiedDecimalFilterInput>;
  billedCustomer?: InputMaybe<CustomerAdditionalFilterInput>;
  billingInterval?: InputMaybe<StringFilterInput>;
  billingIntervals?: InputMaybe<StringArrayFilterInput>;
  consolidated?: InputMaybe<BooleanFilterInput>;
  contractId?: InputMaybe<GuidFilterInput>;
  contractNumber?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<DateFilterInput>;
  customerAccountNumber?: InputMaybe<StringFilterInput>;
  customerName?: InputMaybe<StringFilterInput>;
  divertCustomer?: InputMaybe<CustomerAdditionalFilterInput>;
  divertPaymentAccountName?: InputMaybe<StringFilterInput>;
  divertPaymentAccountNumber?: InputMaybe<StringFilterInput>;
  invoiceDate?: InputMaybe<DateTimeFilterInput>;
  referenceSalesOrderID?: InputMaybe<StringFilterInput>;
  salesOrderID?: InputMaybe<GuidFilterInput>;
  salesOrderStatus?: InputMaybe<StringFilterInput>;
  sentDate?: InputMaybe<DateTimeFilterInput>;
  status?: InputMaybe<SalesOrderStatusFilterInput>;
  statusMessage?: InputMaybe<StringFilterInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SalesOrderTypeEnumFilterInput>;
};

export type SalesOrderFilterType = {
  fieldName?: InputMaybe<SalesOrderFilterFieldNameEnum>;
  fieldValue?: InputMaybe<Scalars['String']['input']>;
};

export enum SalesOrderSort {
  Amount = 'Amount',
  BillingIntervals = 'BillingIntervals',
  BillingType = 'BillingType',
  Consolidated = 'Consolidated',
  ContractNumber = 'ContractNumber',
  Created = 'Created',
  CustomerAccountNumber = 'CustomerAccountNumber',
  CustomerName = 'CustomerName',
  DivertPaymentAccountName = 'DivertPaymentAccountName',
  DivertPaymentAccountNumber = 'DivertPaymentAccountNumber',
  ID = 'ID',
  InvoiceDate = 'InvoiceDate',
  ReferenceSalesOrderID = 'ReferenceSalesOrderID',
  SalesOrderID = 'SalesOrderID',
  SalesOrderStatus = 'SalesOrderStatus',
  SentDate = 'SentDate',
  StatusMessage = 'StatusMessage',
  Type = 'Type',
}

export type SalesOrderSortSortByInput = {
  /** Field */
  field?: InputMaybe<SalesOrderSort>;
  order: OrderType;
};

export type SalesOrderSourceEnumFilterInput = {
  containsValues?: InputMaybe<
    Array<InputMaybe<SalesOrderSourcePascalCaseEnum>>
  >;
  eq?: InputMaybe<SalesOrderSourcePascalCaseEnum>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<SalesOrderSourcePascalCaseEnum>;
  notContainsValues?: InputMaybe<
    Array<InputMaybe<SalesOrderSourcePascalCaseEnum>>
  >;
};

export enum SalesOrderSourcePascalCaseEnum {
  Manual = 'Manual',
  System = 'System',
}

export enum SalesOrderStatusEnum {
  BILLING_PAUSED = 'BILLING_PAUSED',
  CREATED = 'CREATED',
  SENDING_FAILED = 'SENDING_FAILED',
  SENDING_PAUSED = 'SENDING_PAUSED',
  SENDING_SCHEDULED = 'SENDING_SCHEDULED',
  SENDING_SCHEDULING_FAILED = 'SENDING_SCHEDULING_FAILED',
  SENDING_STOPPED = 'SENDING_STOPPED',
  SENT = 'SENT',
}

export type SalesOrderStatusFilterInput = {
  /** FormattedStatus */
  formattedStatus?: InputMaybe<StringFilterInput>;
};

export type SalesOrderStatusType = {
  __typename?: 'SalesOrderStatusType';
  formattedStatus: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type SalesOrderType = {
  __typename?: 'SalesOrderType';
  billDate: Scalars['DateTime']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  consolidated: Scalars['Boolean']['output'];
  consolidatedContractsIds?: Maybe<Array<Scalars['ID']['output']>>;
  contractClientDatabaseReference?: Maybe<Scalars['String']['output']>;
  contractID?: Maybe<Scalars['ID']['output']>;
  created: Scalars['DateTime']['output'];
  isAbandoned: Scalars['Boolean']['output'];
  organisationID?: Maybe<Scalars['ID']['output']>;
  payload: Scalars['String']['output'];
  reasonCode?: Maybe<Scalars['String']['output']>;
  referenceSalesOrderID?: Maybe<Scalars['String']['output']>;
  salesOrderID: Scalars['ID']['output'];
  salesOrderStatus: SalesOrderStatusEnum;
  sendingDate?: Maybe<Scalars['DateTime']['output']>;
  sendingRetriesCount: Scalars['UInt']['output'];
  sentDate?: Maybe<Scalars['DateTime']['output']>;
  source?: Maybe<SalesOrderSourcePascalCaseEnum>;
  status: SalesOrderStatusType;
  statusMessage?: Maybe<Scalars['String']['output']>;
  statusUpdated?: Maybe<Scalars['DateTime']['output']>;
  subscriptionID: Scalars['ID']['output'];
  type?: Maybe<SalesOrderTypeEnum>;
  version: Scalars['String']['output'];
};

export enum SalesOrderTypeEnum {
  PROFORMA = 'PROFORMA',
  SALES_ORDER = 'SALES_ORDER',
}

export type SalesOrderTypeEnumFilterInput = {
  containsValues?: InputMaybe<Array<InputMaybe<SalesOrderTypePascalCaseEnum>>>;
  eq?: InputMaybe<SalesOrderTypePascalCaseEnum>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<SalesOrderTypePascalCaseEnum>;
  notContainsValues?: InputMaybe<
    Array<InputMaybe<SalesOrderTypePascalCaseEnum>>
  >;
};

export enum SalesOrderTypePascalCaseEnum {
  Proforma = 'Proforma',
  SalesOrder = 'SalesOrder',
}

export type SalesOrdersPredictionInputType = {
  endBy?: InputMaybe<Scalars['DateTime']['input']>;
  startFrom: Scalars['DateTime']['input'];
};

export type SalesOrdersPredictionResultType = {
  __typename?: 'SalesOrdersPredictionResultType';
  actual?: Maybe<GroupedSalesOrdersQuantitiesType>;
  date: Scalars['DateTime']['output'];
  expected?: Maybe<GroupedSalesOrdersQuantitiesType>;
};

export type SalesOrdersPredictionResultsType = {
  __typename?: 'SalesOrdersPredictionResultsType';
  quantities?: Maybe<Array<Maybe<SalesOrdersPredictionResultType>>>;
};

export type SalesOrdersQuantitiesType = {
  __typename?: 'SalesOrdersQuantitiesType';
  count: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
};

export type SalesOrdersTotalsOutput = {
  __typename?: 'SalesOrdersTotalsOutput';
  totalSalesOrdersCount: Scalars['Int']['output'];
};

export type SavedSearchFilterInput = {
  form: Forms;
  rowKey?: InputMaybe<Scalars['String']['input']>;
};

export type SavedSearchMutation = {
  __typename?: 'SavedSearchMutation';
  deleteSearch?: Maybe<SucceededResultGraphType>;
  saveSearch?: Maybe<SearchRowKeyResultGraphType>;
  updateSearch?: Maybe<SearchRowKeyResultGraphType>;
};

export type SavedSearchMutationdeleteSearchArgs = {
  form: Forms;
  rowKey: Scalars['String']['input'];
};

export type SavedSearchMutationsaveSearchArgs = {
  search: SearchInput;
};

export type SavedSearchMutationupdateSearchArgs = {
  search: SearchInput;
};

export type Search = {
  __typename?: 'Search';
  created?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  filter?: Maybe<Scalars['String']['output']>;
  form?: Maybe<Forms>;
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  isPrivate: Scalars['Boolean']['output'];
  modified?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  rowKey: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type SearchByIdsInputType = {
  productsIds: Array<Scalars['ID']['input']>;
};

export type SearchInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  form: Forms;
  isPrivate: Scalars['Boolean']['input'];
  rowKey?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SearchRowKey = {
  __typename?: 'SearchRowKey';
  rowKey: Scalars['String']['output'];
};

export type SearchRowKeyResultGraphType =
  | FailedValidation
  | SearchRowKey
  | UnexpectedError;

export type SearchTagInputType = {
  tag?: InputMaybe<Scalars['String']['input']>;
  tagType?: InputMaybe<SearchTagTypeEnum>;
  targetID: Scalars['ID']['input'];
};

export type SearchTagType = {
  __typename?: 'SearchTagType';
  created: Scalars['DateTime']['output'];
  tag: Scalars['String']['output'];
  tagId: Scalars['ID']['output'];
  tagType: SearchTagTypeEnum;
  targetID: Scalars['ID']['output'];
  userID: Scalars['ID']['output'];
};

export enum SearchTagTypeEnum {
  CONTRACT = 'CONTRACT',
  CUSTOMER = 'CUSTOMER',
}

export enum SortDirectionEnum {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING',
}

export enum SpecialContractTypeEnum {
  AccessFixed = 'AccessFixed',
  AgreedExtension = 'AgreedExtension',
  GCloud = 'GCloud',
  None = 'None',
}

export type StaticDataType = {
  __typename?: 'StaticDataType';
  name: Scalars['String']['output'];
  staticDataID: Scalars['ID']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type StringArrayFilterInput = {
  /** Between */
  between?: InputMaybe<
    Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>
  >;
  /** ContainsValues */
  containsValues?: InputMaybe<
    Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>
  >;
  /** Eq */
  eq?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Ge */
  ge?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Gt */
  gt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Le */
  le?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Lt */
  lt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Ne */
  ne?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** NotBetween */
  notBetween?: InputMaybe<
    Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>
  >;
  /** NotContainsValues */
  notContainsValues?: InputMaybe<
    Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>
  >;
};

export type StringFilterInput = {
  beginsWith?: InputMaybe<Scalars['String']['input']>;
  /** Between */
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  /** ContainsValues */
  containsValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  doesNotBeginWith?: InputMaybe<Scalars['String']['input']>;
  doesNotContain?: InputMaybe<Scalars['String']['input']>;
  doesNotEndWith?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  ge?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  le?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  /** NotBetween */
  notBetween?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** NotContainsValues */
  notContainsValues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StringifiedDecimalFilterInput = {
  between?: InputMaybe<
    Array<InputMaybe<Scalars['StringifiedDecimal']['input']>>
  >;
  containsValues?: InputMaybe<
    Array<InputMaybe<Scalars['StringifiedDecimal']['input']>>
  >;
  eq?: InputMaybe<Scalars['StringifiedDecimal']['input']>;
  ge?: InputMaybe<Scalars['StringifiedDecimal']['input']>;
  gt?: InputMaybe<Scalars['StringifiedDecimal']['input']>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  le?: InputMaybe<Scalars['StringifiedDecimal']['input']>;
  lt?: InputMaybe<Scalars['StringifiedDecimal']['input']>;
  ne?: InputMaybe<Scalars['StringifiedDecimal']['input']>;
  notBetween?: InputMaybe<
    Array<InputMaybe<Scalars['StringifiedDecimal']['input']>>
  >;
  notContainsValues?: InputMaybe<
    Array<InputMaybe<Scalars['StringifiedDecimal']['input']>>
  >;
};

export type Succeeded = {
  __typename?: 'Succeeded';
  succeeded: Scalars['Boolean']['output'];
};

export type SucceededErrorResultGraphType = Succeeded | UnexpectedError;

export type SucceededResultGraphType =
  | FailedValidation
  | Succeeded
  | UnexpectedError;

export type TerminateContractLineDataType = {
  comment: Scalars['String']['input'];
  contractLineID: Scalars['ID']['input'];
  reasonCode: Scalars['String']['input'];
  terminationDate: Scalars['DateTime']['input'];
};

export type TerminateContractLinesInputType = {
  comment: Scalars['String']['input'];
  contractId: Scalars['ID']['input'];
  contractLines: Array<ContractLineDataType>;
  reasonCode: Scalars['String']['input'];
  terminationDate: Scalars['DateTime']['input'];
};

export type TermsAndConditionsInputType = {
  breakClauseAdditionalInfo?: InputMaybe<Scalars['String']['input']>;
  breakClauseEnabled: Scalars['Boolean']['input'];
  breakClauseReviewDate?: InputMaybe<Scalars['DateTime']['input']>;
  cancellationAdditionalInfo?: InputMaybe<Scalars['String']['input']>;
  fixedTermAdditionalInfo?: InputMaybe<Scalars['String']['input']>;
  fixedTermReviewDate?: InputMaybe<Scalars['DateTime']['input']>;
  noticePeriodType: NoticePeriodTypeEnum;
  specialContractType: SpecialContractTypeEnum;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type ToggleBillToParentInput = {
  billToParent: Scalars['Boolean']['input'];
  contractId: Scalars['ID']['input'];
};

export type ToggleConsolidateBillingInput = {
  consolidateBilling: Scalars['Boolean']['input'];
  contractId: Scalars['ID']['input'];
};

export type ToggleHidingContractLinesInput = {
  contractId: Scalars['ID']['input'];
  hide: Scalars['Boolean']['input'];
};

export type ToggleHidingContractLinesPayload = {
  __typename?: 'ToggleHidingContractLinesPayload';
  contractID: Scalars['ID']['output'];
  hide: Scalars['Boolean']['output'];
};

export type TogglePONumberRequiredInput = {
  contractId: Scalars['ID']['input'];
  pONumber?: InputMaybe<Scalars['String']['input']>;
  pONumberEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  pONumberRequired: Scalars['Boolean']['input'];
  pONumberStartDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ToggleReasonCodeInputType = {
  code: Scalars['String']['input'];
  enable: Scalars['Boolean']['input'];
};

export type ToggleResellerInput = {
  contractId: Scalars['ID']['input'];
  reseller: Scalars['Boolean']['input'];
};

export type TriggerResendSalesOrdersResultType = {
  __typename?: 'TriggerResendSalesOrdersResultType';
  triggeredCount: Scalars['Int']['output'];
};

export type UnbundleInputType = {
  contractId: Scalars['ID']['input'];
  contractLineIds: Array<InputMaybe<Scalars['Guid']['input']>>;
};

export type UnexpectedError = {
  __typename?: 'UnexpectedError';
  errorMessage: Scalars['String']['output'];
};

export type UnitPriceFrequencyType = {
  __typename?: 'UnitPriceFrequencyType';
  formattedFrequency: Scalars['String']['output'];
  frequency: Scalars['String']['output'];
  monthsCount: Scalars['Int']['output'];
};

export type UpdateBillingIntervalDaysInputType = {
  billingInterval: Scalars['String']['input'];
  renewalDays: Scalars['Int']['input'];
};

export type UpdateBundleInputType = {
  bundleId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  hideInvoiceLines: Scalars['Boolean']['input'];
  hideInvoiceValues: Scalars['Boolean']['input'];
  softwareCompany?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BundleTypeEnum>;
};

export type UpdateContractAdminDataInputType = {
  clientDatabaseID?: InputMaybe<Scalars['String']['input']>;
  contractID: Scalars['ID']['input'];
  contractNumber?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContractAdminDataResponseType = {
  __typename?: 'UpdateContractAdminDataResponseType';
  contract: ContractType;
  salesOrderIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

export type UpdateContractAndContractLinesStatusType = {
  __typename?: 'UpdateContractAndContractLinesStatusType';
  contractId: Scalars['ID']['output'];
  errors?: Maybe<Array<ContractLineErrorType>>;
};

export type UpdateContractClientDatabaseReferenceInputType = {
  clientDatabaseReference?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['ID']['input'];
};

export type UpdateContractCustomerInputType = {
  contractId: Scalars['ID']['input'];
  currentCustomerId: Scalars['ID']['input'];
  newCustomerId: Scalars['ID']['input'];
};

export type UpdateContractInputType = {
  contractEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  contractId: Scalars['ID']['input'];
  contractStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  externalContractID?: InputMaybe<Scalars['String']['input']>;
  initialTerm?: InputMaybe<Scalars['Int']['input']>;
  renewableTerm?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateContractLineBillingCyclesCadenceInputType = {
  billingCycleStartDate: Scalars['DateTime']['input'];
  changeReason?: InputMaybe<ChangeReasonInputType>;
  contractId: Scalars['ID']['input'];
  contractLineIds: Array<InputMaybe<Scalars['Guid']['input']>>;
};

export type UpdateContractLineInputType = {
  billingInterval?: InputMaybe<Scalars['String']['input']>;
  billingType?: InputMaybe<Scalars['String']['input']>;
  changeReason?: InputMaybe<ChangeReasonInputType>;
  comments?: InputMaybe<Scalars['String']['input']>;
  contractID?: InputMaybe<Scalars['ID']['input']>;
  contractLineID: Scalars['ID']['input'];
  lineStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  minCharge?: InputMaybe<Scalars['Decimal']['input']>;
  oppHeaderId?: InputMaybe<Scalars['String']['input']>;
  oppLineId?: InputMaybe<Scalars['String']['input']>;
  proRataEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Long']['input']>;
  salesHandoverNumber?: InputMaybe<Scalars['String']['input']>;
  stockCode?: InputMaybe<Scalars['String']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceFrequency?: InputMaybe<Scalars['String']['input']>;
  unitType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContractLinesInputType = {
  billingInterval?: InputMaybe<Scalars['String']['input']>;
  changeReason?: InputMaybe<ChangeReasonInputType>;
  contractId: Scalars['ID']['input'];
  contractLines: Array<ContractLineDataType>;
  lineStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  minCharge?: InputMaybe<Scalars['Decimal']['input']>;
  salesHandoverNumber?: InputMaybe<Scalars['String']['input']>;
  unitType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContractMessagePayload = {
  __typename?: 'UpdateContractMessagePayload';
  contractID: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export type UpdateContractTermsAndConditionsInputType = {
  breakClauseAdditionalInfo?: InputMaybe<Scalars['String']['input']>;
  breakClauseEnabled: Scalars['Boolean']['input'];
  breakClauseReviewDate?: InputMaybe<Scalars['DateTime']['input']>;
  cancellationAdditionalInfo?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['ID']['input'];
  fixedTermAdditionalInfo?: InputMaybe<Scalars['String']['input']>;
  fixedTermReviewDate?: InputMaybe<Scalars['DateTime']['input']>;
  noticePeriodType: NoticePeriodTypeEnum;
  specialContractType: SpecialContractTypeEnum;
};

export type UpdateContractUpliftSettingsInputType = {
  contractId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  upliftTypeId: Scalars['ID']['input'];
  validThrough?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateCustomerInputType = {
  destinationAccountManagerName?: InputMaybe<Scalars['String']['input']>;
  destinationAddress?: InputMaybe<Scalars['String']['input']>;
  destinationCCEmailAddress?: InputMaybe<Scalars['String']['input']>;
  destinationContactName?: InputMaybe<Scalars['String']['input']>;
  destinationContactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  destinationCountry?: InputMaybe<Scalars['String']['input']>;
  destinationCustomerAccountNumber?: InputMaybe<Scalars['String']['input']>;
  destinationCustomerName?: InputMaybe<Scalars['String']['input']>;
  destinationEmailAddress?: InputMaybe<Scalars['String']['input']>;
  destinationPostCode?: InputMaybe<Scalars['String']['input']>;
  destinationSalesPersonName?: InputMaybe<Scalars['String']['input']>;
  destinationState?: InputMaybe<Scalars['String']['input']>;
  destinationTown?: InputMaybe<Scalars['String']['input']>;
  sourceCustomerAccountNumber: Scalars['String']['input'];
};

export type UpdateDNRContractLinesInputType = {
  contractId: Scalars['ID']['input'];
  dnrContractLineData: Array<DNRContractLineDataType>;
};

export type UpdateDivertCustomerInputType = {
  contractId: Scalars['ID']['input'];
  divertCustomerId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateFullContractLineInputType = {
  billingInterval?: InputMaybe<Scalars['String']['input']>;
  billingType: Scalars['String']['input'];
  changeReason?: InputMaybe<ChangeReasonInputType>;
  comments?: InputMaybe<Scalars['String']['input']>;
  contractID: Scalars['ID']['input'];
  contractLineID: Scalars['ID']['input'];
  lineStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  minCharge?: InputMaybe<Scalars['Decimal']['input']>;
  productId: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Long']['input']>;
  salesHandoverNumber?: InputMaybe<Scalars['String']['input']>;
  unitPrice: Scalars['Decimal']['input'];
  unitPriceFrequency?: InputMaybe<Scalars['String']['input']>;
  unitType?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating an uplift index */
export type UpdateIndexInput = {
  /** The unique identifier of the uplift index */
  id: Scalars['ID']['input'];
  /** The name of the uplift index */
  name: Scalars['String']['input'];
};

export type UpdateInvoiceToCustomerInputType = {
  contractId: Scalars['ID']['input'];
  defaultToLines: Scalars['Boolean']['input'];
  invoiceToCustomerId: Scalars['ID']['input'];
};

export type UpdatePONumberInputType = {
  contractId: Scalars['ID']['input'];
  pONumber?: InputMaybe<Scalars['String']['input']>;
  pONumberEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  pONumberStartDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateParentCustomerInputType = {
  customerID: Scalars['ID']['input'];
  parentCustomerID?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePauseBillingInputType = {
  comment?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['ID']['input'];
  endDate: Scalars['DateTime']['input'];
  reasonCode: Scalars['String']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductDefaultBillingTypeInputType = {
  defaultBillingType?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['Guid']['input'];
};

export type UpdateProductInputType = {
  productDivision?: InputMaybe<Scalars['String']['input']>;
  productFamily?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  softwareCompany?: InputMaybe<Scalars['String']['input']>;
  sourceStockCode: Scalars['String']['input'];
  stockCode?: InputMaybe<Scalars['String']['input']>;
  stockName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductMergeDefaultInputType = {
  id: Scalars['ID']['input'];
  mergeType?: InputMaybe<ProductMergeTypeEnum>;
  stockCodeContains?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRenewalSettingsInputType = {
  billingIntervals?: InputMaybe<
    Array<InputMaybe<UpdateBillingIntervalDaysInputType>>
  >;
};

export type UpdateShipToCustomerInputType = {
  contractId: Scalars['ID']['input'];
  defaultToLines: Scalars['Boolean']['input'];
  shipToCustomerId: Scalars['ID']['input'];
};

export type UpdateTerminateContractLinesInputType = {
  contractId: Scalars['ID']['input'];
  terminateContractLines: Array<TerminateContractLineDataType>;
};

/** Input for updating an uplift index rate */
export type UpdateUpliftIndexRateInput = {
  /** The effective date of the uplift index rate */
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The rate value */
  rate?: InputMaybe<Scalars['Decimal']['input']>;
  /** The unique identifier of the uplift index */
  upliftIndexId: Scalars['ID']['input'];
  /** The unique identifier of the uplift index rate */
  upliftIndexRateId: Scalars['ID']['input'];
};

export type UpdateUsageHeaderInputType = {
  billingEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  billingStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  usageHeaderId: Scalars['ID']['input'];
};

export type UpliftCap = {
  __typename?: 'UpliftCap';
  calculatedCapPercentage?: Maybe<Scalars['Decimal']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  entityId: Scalars['ID']['output'];
  entityType: UpliftCapEntityTypeEnum;
  id: Scalars['ID']['output'];
  modifier1: UpliftModifierEnum;
  modifier2: UpliftModifierEnum;
  rate1: UpliftCapRate;
  rate2?: Maybe<UpliftCapRate>;
  rate3?: Maybe<UpliftCapRate>;
};

export enum UpliftCapEntityTypeEnum {
  Contract = 'Contract',
  ContractLine = 'ContractLine',
}

export type UpliftCapInputType = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  modifier1: UpliftModifierEnum;
  modifier2: UpliftModifierEnum;
  rate1: UpliftCapRateInputType;
  rate2?: InputMaybe<UpliftCapRateInputType>;
  rate3?: InputMaybe<UpliftCapRateInputType>;
};

export type UpliftCapRate = {
  __typename?: 'UpliftCapRate';
  fixedValue?: Maybe<Scalars['Decimal']['output']>;
  indexId?: Maybe<Scalars['ID']['output']>;
  type: UpliftCapRateTypeEnum;
};

export type UpliftCapRateInputType = {
  fixedValue?: InputMaybe<Scalars['Decimal']['input']>;
  indexId?: InputMaybe<Scalars['ID']['input']>;
  type: UpliftCapRateTypeEnum;
};

export enum UpliftCapRateTypeEnum {
  Fixed = 'Fixed',
  Index = 'Index',
}

export type UpliftFilterInput = {
  billToParent?: InputMaybe<BooleanFilterInput>;
  contractNumber?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  createdBy?: InputMaybe<GuidFilterInput>;
  customerAccountNumber?: InputMaybe<StringFilterInput>;
  effectiveDate?: InputMaybe<DateTimeFilterInput>;
  iD?: InputMaybe<GuidFilterInput>;
  nextUpliftDate?: InputMaybe<DateTimeFilterInput>;
  origin?: InputMaybe<UpliftOriginPascalCaseEnumFilterInput>;
  parentCustomerAccountNumber?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<UpliftStatusEnumFilterInput>;
  statusMessage?: InputMaybe<StringFilterInput>;
  stockCode?: InputMaybe<StringFilterInput>;
  stockName?: InputMaybe<StringFilterInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<DateTimeFilterInput>;
  updatedBy?: InputMaybe<GuidFilterInput>;
  upliftMethod?: InputMaybe<UpliftMethodEnumFilterInput>;
  upliftValue?: InputMaybe<StringifiedDecimalFilterInput>;
};

/** An uplift index */
export type UpliftIndex = {
  __typename?: 'UpliftIndex';
  /** The date and time when the uplift index was created */
  created: Scalars['DateTime']['output'];
  /** The unique identifier of the uplift index */
  id?: Maybe<Scalars['ID']['output']>;
  /** The name of the uplift index */
  name: Scalars['String']['output'];
  /** The type of the uplift index */
  type: UpliftIndexTypePascalCaseEnum;
  /** The date and time when the uplift index was last updated */
  updated?: Maybe<Scalars['DateTime']['output']>;
  /** The uplift index rates */
  upliftIndexRates?: Maybe<Array<Maybe<UpliftIndexRate>>>;
  /** The uplift region */
  upliftRegion?: Maybe<UpliftRegion>;
  /** The unique identifier of the uplift region */
  upliftRegionId?: Maybe<Scalars['ID']['output']>;
};

/** An uplift index rate */
export type UpliftIndexRate = {
  __typename?: 'UpliftIndexRate';
  /** The date and time when the uplift index rate was created */
  created: Scalars['DateTime']['output'];
  /** The user who created the rate */
  createdBy?: Maybe<Scalars['ID']['output']>;
  /** The effective date of the rate */
  effectiveDate: Scalars['DateTime']['output'];
  /** The unique identifier of the uplift index rate */
  id?: Maybe<Scalars['ID']['output']>;
  /** The rate value */
  rate: Scalars['Decimal']['output'];
  /** The date and time when the uplift index rate was last updated */
  updated?: Maybe<Scalars['DateTime']['output']>;
  /** The user who last updated the rate */
  updatedBy?: Maybe<Scalars['ID']['output']>;
  /** The unique identifier of the uplift index */
  upliftIndexId?: Maybe<Scalars['ID']['output']>;
};

export type UpliftIndexRateInputType = {
  effectiveDate: Scalars['DateTime']['input'];
  rate: Scalars['Decimal']['input'];
};

export enum UpliftIndexTypePascalCaseEnum {
  Custom = 'Custom',
  Published = 'Published',
}

export enum UpliftMethodEnum {
  PERCENTAGE = 'PERCENTAGE',
  UNIT_COST = 'UNIT_COST',
}

export type UpliftMethodEnumFilterInput = {
  containsValues?: InputMaybe<Array<InputMaybe<UpliftMethodPascalCaseEnum>>>;
  eq?: InputMaybe<UpliftMethodPascalCaseEnum>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<UpliftMethodPascalCaseEnum>;
  notContainsValues?: InputMaybe<Array<InputMaybe<UpliftMethodPascalCaseEnum>>>;
};

export enum UpliftMethodPascalCaseEnum {
  Percentage = 'Percentage',
  UnitCost = 'UnitCost',
}

export enum UpliftModifierEnum {
  Equals = 'Equals',
  GreaterThan = 'GreaterThan',
  LessThan = 'LessThan',
  MaximumOf = 'MaximumOf',
  None = 'None',
  SumOf = 'SumOf',
}

export enum UpliftOriginPascalCaseEnum {
  Document = 'Document',
  UiTool = 'UiTool',
}

export type UpliftOriginPascalCaseEnumFilterInput = {
  containsValues?: InputMaybe<Array<InputMaybe<UpliftOriginPascalCaseEnum>>>;
  eq?: InputMaybe<UpliftOriginPascalCaseEnum>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<UpliftOriginPascalCaseEnum>;
  notContainsValues?: InputMaybe<Array<InputMaybe<UpliftOriginPascalCaseEnum>>>;
};

/** An uplift region */
export type UpliftRegion = {
  __typename?: 'UpliftRegion';
  /** The date and time when the uplift region was created */
  created: Scalars['DateTime']['output'];
  /** The unique identifier of the uplift region */
  id?: Maybe<Scalars['ID']['output']>;
  /** The name of the uplift region */
  name: Scalars['String']['output'];
  /** The subscription ID associated with the uplift region */
  subscriptionId?: Maybe<Scalars['ID']['output']>;
  /** The date and time when the uplift region was last updated */
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type UpliftSearchResultType = {
  __typename?: 'UpliftSearchResultType';
  annualBillingPeriodValue?: Maybe<Scalars['String']['output']>;
  billingInterval?: Maybe<BillingIntervalType>;
  billingPeriodValue: Scalars['String']['output'];
  contractID: Scalars['ID']['output'];
  contractLineID: Scalars['ID']['output'];
  contractNumber: Scalars['String']['output'];
  contractStartDate: Scalars['DateTime']['output'];
  daysBeforeRenewal?: Maybe<Scalars['Int']['output']>;
  nextUpliftDate?: Maybe<Scalars['DateTime']['output']>;
  pONumber?: Maybe<Scalars['String']['output']>;
  poEndDate?: Maybe<Scalars['DateTime']['output']>;
  poRemainingValue?: Maybe<Scalars['String']['output']>;
  pricePerUnit: Scalars['String']['output'];
  product?: Maybe<ProductType>;
  quantity: Scalars['Long']['output'];
  renewableTerm: Scalars['Int']['output'];
  status: ContractLineStatusType;
  unitPriceFrequency?: Maybe<UnitPriceFrequencyType>;
};

export type UpliftSettingsInputType = {
  cappingOptionUplift?: InputMaybe<Scalars['Decimal']['input']>;
  type: Scalars['String']['input'];
  upliftNotes?: InputMaybe<Scalars['String']['input']>;
  upliftValidUntil?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum UpliftSort {
  BillToParent = 'BillToParent',
  ContractNumber = 'ContractNumber',
  Created = 'Created',
  CreatedBy = 'CreatedBy',
  CustomerAccountNumber = 'CustomerAccountNumber',
  EffectiveDate = 'EffectiveDate',
  ID = 'ID',
  NextUpliftDate = 'NextUpliftDate',
  Origin = 'Origin',
  ParentCustomerAccountNumber = 'ParentCustomerAccountNumber',
  Status = 'Status',
  StatusMessage = 'StatusMessage',
  StockCode = 'StockCode',
  StockName = 'StockName',
  UpliftMethod = 'UpliftMethod',
  UpliftValue = 'UpliftValue',
}

export type UpliftSortSortByInput = {
  /** Field */
  field?: InputMaybe<UpliftSort>;
  order: OrderType;
};

export enum UpliftStatusEnum {
  Applied = 'Applied',
  Cancelled = 'Cancelled',
  Failed = 'Failed',
  Pending = 'Pending',
}

export type UpliftStatusEnumFilterInput = {
  containsValues?: InputMaybe<Array<InputMaybe<UpliftStatusPascalCaseEnum>>>;
  eq?: InputMaybe<UpliftStatusPascalCaseEnum>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<UpliftStatusPascalCaseEnum>;
  notContainsValues?: InputMaybe<Array<InputMaybe<UpliftStatusPascalCaseEnum>>>;
};

export enum UpliftStatusPascalCaseEnum {
  Applied = 'Applied',
  Cancelled = 'Cancelled',
  Failed = 'Failed',
  Pending = 'Pending',
}

export type UpliftType = {
  __typename?: 'UpliftType';
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  isValueRequired: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type UpsertContractUpliftCapsInputType = {
  contractId: Scalars['ID']['input'];
  existingUpliftCap?: InputMaybe<UpliftCapInputType>;
  furtherUpliftCap?: InputMaybe<UpliftCapInputType>;
};

export type UpsertCustomerInputType = {
  accountManagerName?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  ccEmailAddress?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customerAccountNumber: Scalars['String']['input'];
  customerName: Scalars['String']['input'];
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  salesPersonName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  town?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertProductInputType = {
  productDivision: Scalars['String']['input'];
  productFamily: Scalars['String']['input'];
  productName: Scalars['String']['input'];
  softwareCompany?: InputMaybe<Scalars['String']['input']>;
  stockCode: Scalars['String']['input'];
  stockName: Scalars['String']['input'];
};

export type UpsertPurchaseOrderInputType = {
  poDate?: InputMaybe<Scalars['DateTime']['input']>;
  poEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  poNote?: InputMaybe<Scalars['String']['input']>;
  poNumber: Scalars['String']['input'];
  poStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  poStatus?: InputMaybe<PurchaseOrderStatusEnum>;
  poTotalValue?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UsageDetailDataInputType = {
  usageDetailId: Scalars['Guid']['input'];
};

export type UsageDetailStatus = {
  __typename?: 'UsageDetailStatus';
  formattedStatus: Scalars['String']['output'];
  status?: Maybe<VarBillingUsageDetailStatusEnum>;
};

export type UsageHeader = {
  __typename?: 'UsageHeader';
  billingEndDate?: Maybe<Scalars['DateTime']['output']>;
  billingStartDate?: Maybe<Scalars['DateTime']['output']>;
  importDocument: ImportDocumentType;
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<VarBillingUsageHeaderStatusEnum>;
  usageHeaderID: Scalars['ID']['output'];
};

export type UsageHeaderFilterInput = {
  /** CalculatedTotalValue */
  calculatedTotalValue?: InputMaybe<StringifiedDecimalFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  fileName?: InputMaybe<StringFilterInput>;
  iD?: InputMaybe<GuidFilterInput>;
  numberOfRows?: InputMaybe<IntFilterInput>;
  productName?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<UsageHeaderStatusPascalCaseEnumFilterInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
  /** TotalNet */
  totalNet?: InputMaybe<StringifiedDecimalFilterInput>;
  uploadedBy?: InputMaybe<GuidFilterInput>;
};

export type UsageHeaderOutput = {
  __typename?: 'UsageHeaderOutput';
  calculatedTotalValue?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  iD?: Maybe<Scalars['ID']['output']>;
  numberOfRows?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<VarBillingUsageHeaderStatusEnum>;
  totalNet?: Maybe<Scalars['String']['output']>;
  uploadedBy?: Maybe<Scalars['ID']['output']>;
};

/** A connection from an object to a list of objects of type `UsageHeaderOutput`. */
export type UsageHeaderOutputConnection = {
  __typename?: 'UsageHeaderOutputConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<UsageHeaderOutputEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<UsageHeaderOutput>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `UsageHeaderOutput`. */
export type UsageHeaderOutputEdge = {
  __typename?: 'UsageHeaderOutputEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<UsageHeaderOutput>;
};

export enum UsageHeaderSort {
  CalculatedTotalValue = 'CalculatedTotalValue',
  Created = 'Created',
  FileName = 'FileName',
  ID = 'ID',
  NumberOfRows = 'NumberOfRows',
  ProductName = 'ProductName',
  Status = 'Status',
  TotalNet = 'TotalNet',
  UploadedBy = 'UploadedBy',
}

export type UsageHeaderSortSortByInput = {
  /** Field */
  field?: InputMaybe<UsageHeaderSort>;
  order: OrderType;
};

export type UsageHeaderStatus = {
  __typename?: 'UsageHeaderStatus';
  formattedStatus: Scalars['String']['output'];
  status?: Maybe<VarBillingUsageHeaderStatusEnum>;
};

export enum UsageHeaderStatusPascalCaseEnum {
  Abandoned = 'Abandoned',
  Archived = 'Archived',
  Draft = 'Draft',
  ImportError = 'ImportError',
  Imported = 'Imported',
  Matched = 'Matched',
  Matching = 'Matching',
  MatchingError = 'MatchingError',
  PartiallyProcessed = 'PartiallyProcessed',
  SalesOrdersGenerated = 'SalesOrdersGenerated',
  SalesOrdersGeneration = 'SalesOrdersGeneration',
  SalesOrdersGenerationError = 'SalesOrdersGenerationError',
}

export type UsageHeaderStatusPascalCaseEnumFilterInput = {
  containsValues?: InputMaybe<
    Array<InputMaybe<UsageHeaderStatusPascalCaseEnum>>
  >;
  eq?: InputMaybe<UsageHeaderStatusPascalCaseEnum>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<UsageHeaderStatusPascalCaseEnum>;
  notContainsValues?: InputMaybe<
    Array<InputMaybe<UsageHeaderStatusPascalCaseEnum>>
  >;
};

export type UsageHeaderTotalsOutput = {
  __typename?: 'UsageHeaderTotalsOutput';
  totalCount: Scalars['Int']['output'];
};

export type UserConfiguration = {
  __typename?: 'UserConfiguration';
  advancedFilters?: Maybe<Array<Maybe<UserConfigurationAdvancedFilter>>>;
  advancedFiltersPinned?: Maybe<Scalars['Boolean']['output']>;
  columns?: Maybe<Array<Maybe<UserConfigurationColumn>>>;
  form?: Maybe<Scalars['String']['output']>;
  grouping?: Maybe<Array<Maybe<UserConfigurationGroup>>>;
  username?: Maybe<Scalars['String']['output']>;
};

export type UserConfigurationAdvancedFilter = {
  __typename?: 'UserConfigurationAdvancedFilter';
  hidden?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
};

export type UserConfigurationAdvancedFilterInput = {
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type UserConfigurationColumn = {
  __typename?: 'UserConfigurationColumn';
  hidden?: Maybe<Scalars['Boolean']['output']>;
  isDetailColumn?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  pinned?: Maybe<Scalars['String']['output']>;
  sorted?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type UserConfigurationColumnInput = {
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  isDetailColumn?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  pinned?: InputMaybe<Scalars['String']['input']>;
  sorted?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type UserConfigurationGroup = {
  __typename?: 'UserConfigurationGroup';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
};

export type UserConfigurationGroupInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type UserConfigurationInput = {
  advancedFilters?: InputMaybe<
    Array<InputMaybe<UserConfigurationAdvancedFilterInput>>
  >;
  advancedFiltersPinned?: InputMaybe<Scalars['Boolean']['input']>;
  columns?: InputMaybe<Array<InputMaybe<UserConfigurationColumnInput>>>;
  form?: InputMaybe<Scalars['String']['input']>;
  grouping?: InputMaybe<Array<InputMaybe<UserConfigurationGroupInput>>>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserConfigurationMutation = {
  __typename?: 'UserConfigurationMutation';
  deleteUserConfiguration?: Maybe<SucceededResultGraphType>;
  writeUserConfiguration?: Maybe<SucceededErrorResultGraphType>;
};

export type UserConfigurationMutationdeleteUserConfigurationArgs = {
  formName: Scalars['String']['input'];
  userName: Scalars['String']['input'];
};

export type UserConfigurationMutationwriteUserConfigurationArgs = {
  configuration: UserConfigurationInput;
};

export type UserConfigurationQuery = {
  __typename?: 'UserConfigurationQuery';
  userConfigurationByRowKey?: Maybe<UserConfiguration>;
};

export type UserConfigurationQueryuserConfigurationByRowKeyArgs = {
  formName: Scalars['String']['input'];
  userName: Scalars['String']['input'];
};

export type ValidationItem = {
  __typename?: 'ValidationItem';
  details: Array<ValidationItemDetails>;
  message: Scalars['String']['output'];
};

export type ValidationItemDetails = {
  __typename?: 'ValidationItemDetails';
  field?: Maybe<Scalars['String']['output']>;
  primaryKey?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type VarBillingUsageDetailFilterInput = {
  /** CalculatedNet */
  calculatedNet?: InputMaybe<StringifiedDecimalFilterInput>;
  /** Comment */
  comment?: InputMaybe<StringFilterInput>;
  /** ContractLineID */
  contractLineID?: InputMaybe<GuidFilterInput>;
  /** ContractLineMinCharge */
  contractLineMinCharge?: InputMaybe<StringifiedDecimalFilterInput>;
  /** ContractLinePrice */
  contractLinePrice?: InputMaybe<StringifiedDecimalFilterInput>;
  /** ContractNumber */
  contractNumber?: InputMaybe<StringFilterInput>;
  /** Currency */
  currency?: InputMaybe<StringFilterInput>;
  /** CustomerCode */
  customerCode?: InputMaybe<StringFilterInput>;
  /** DimensionsInvoiceID */
  dimensionsInvoiceID?: InputMaybe<StringFilterInput>;
  /** ExternalContractID */
  externalContractID?: InputMaybe<StringFilterInput>;
  /** HeaderPrimaryKey */
  headerPrimaryKey?: InputMaybe<GuidFilterInput>;
  /** Net */
  net?: InputMaybe<StringifiedDecimalFilterInput>;
  /** Price */
  price?: InputMaybe<StringifiedDecimalFilterInput>;
  /** Pricing Model */
  pricingModel?: InputMaybe<VarBillingUsageDetailPricingModelEnumEnumFilterInput>;
  /** ProductCode */
  productCode?: InputMaybe<StringFilterInput>;
  /** Quantity */
  quantity?: InputMaybe<LongFilterInput>;
  /** Status */
  status?: InputMaybe<VarBillingUsageDetailStatusEnumEnumFilterInput>;
};

export type VarBillingUsageDetailOutput = {
  __typename?: 'VarBillingUsageDetailOutput';
  calculatedNet?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  contractID?: Maybe<Scalars['ID']['output']>;
  contractLineID?: Maybe<Scalars['ID']['output']>;
  contractLineMinCharge?: Maybe<Scalars['String']['output']>;
  contractLinePrice?: Maybe<Scalars['String']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerCode?: Maybe<Scalars['String']['output']>;
  customerID?: Maybe<Scalars['ID']['output']>;
  dimensionsInvoiceID?: Maybe<Scalars['String']['output']>;
  externalContractID?: Maybe<Scalars['String']['output']>;
  ignoreComment?: Maybe<Scalars['String']['output']>;
  net?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  pricingModel?: Maybe<VarBillingUsageDetailPricingModelEnum>;
  productCode?: Maybe<Scalars['String']['output']>;
  productID?: Maybe<Scalars['ID']['output']>;
  quantity: Scalars['Long']['output'];
  rowNumber?: Maybe<Scalars['Int']['output']>;
  salesOrderByBillingCycleID?: Maybe<Scalars['ID']['output']>;
  salesOrderID?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<VarBillingUsageDetailStatusEnum>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  usageDetailID: Scalars['ID']['output'];
  usageHeaderID: Scalars['ID']['output'];
};

/** A connection from an object to a list of objects of type `VarBillingUsageDetailOutput`. */
export type VarBillingUsageDetailOutputConnection = {
  __typename?: 'VarBillingUsageDetailOutputConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<VarBillingUsageDetailOutputEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<VarBillingUsageDetailOutput>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `VarBillingUsageDetailOutput`. */
export type VarBillingUsageDetailOutputEdge = {
  __typename?: 'VarBillingUsageDetailOutputEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<VarBillingUsageDetailOutput>;
};

export enum VarBillingUsageDetailPricingModelEnum {
  MinCharge = 'MinCharge',
  Price = 'Price',
}

export type VarBillingUsageDetailPricingModelEnumEnumFilterInput = {
  /** ContainsValues */
  containsValues?: InputMaybe<
    Array<InputMaybe<VarBillingUsageDetailPricingModelEnum>>
  >;
  eq?: InputMaybe<VarBillingUsageDetailPricingModelEnum>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<VarBillingUsageDetailPricingModelEnum>;
  /** NotContainsValues */
  notContainsValues?: InputMaybe<
    Array<InputMaybe<VarBillingUsageDetailPricingModelEnum>>
  >;
};

export enum VarBillingUsageDetailSort {
  CalculatedNet = 'CalculatedNet',
  Comment = 'Comment',
  ContractLineID = 'ContractLineID',
  ContractLineMinCharge = 'ContractLineMinCharge',
  ContractLinePrice = 'ContractLinePrice',
  ContractNumber = 'ContractNumber',
  Currency = 'Currency',
  CustomerCode = 'CustomerCode',
  DimensionsInvoiceID = 'DimensionsInvoiceID',
  ExternalContractID = 'ExternalContractID',
  Net = 'Net',
  Price = 'Price',
  PricingModel = 'PricingModel',
  ProductCode = 'ProductCode',
  Quantity = 'Quantity',
  RowNumber = 'RowNumber',
  Status = 'Status',
  UsageDetailID = 'UsageDetailID',
}

export type VarBillingUsageDetailSortSortByInput = {
  /** Field */
  field?: InputMaybe<VarBillingUsageDetailSort>;
  order: OrderType;
};

export enum VarBillingUsageDetailStatusEnum {
  Ignored = 'Ignored',
  Imported = 'Imported',
  Matched = 'Matched',
  Matching = 'Matching',
  MatchingError = 'MatchingError',
  SalesOrdersGenerated = 'SalesOrdersGenerated',
  SalesOrdersGeneration = 'SalesOrdersGeneration',
  SalesOrdersGenerationError = 'SalesOrdersGenerationError',
}

export type VarBillingUsageDetailStatusEnumEnumFilterInput = {
  /** ContainsValues */
  containsValues?: InputMaybe<
    Array<InputMaybe<VarBillingUsageDetailStatusEnum>>
  >;
  eq?: InputMaybe<VarBillingUsageDetailStatusEnum>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<VarBillingUsageDetailStatusEnum>;
  /** NotContainsValues */
  notContainsValues?: InputMaybe<
    Array<InputMaybe<VarBillingUsageDetailStatusEnum>>
  >;
};

export type VarBillingUsageDetailsTotalsOutput = {
  __typename?: 'VarBillingUsageDetailsTotalsOutput';
  matchedNet?: Maybe<Scalars['String']['output']>;
  matchedUsageRecordsCount: Scalars['Int']['output'];
  totalNet?: Maybe<Scalars['String']['output']>;
  totalUsageRecordsCount: Scalars['Int']['output'];
  unmatchedUsageRecordsCount: Scalars['Int']['output'];
};

export enum VarBillingUsageHeaderStatusEnum {
  Abandoned = 'Abandoned',
  Archived = 'Archived',
  Draft = 'Draft',
  ImportError = 'ImportError',
  Imported = 'Imported',
  Matched = 'Matched',
  Matching = 'Matching',
  MatchingError = 'MatchingError',
  PartiallyProcessed = 'PartiallyProcessed',
  SalesOrdersGenerated = 'SalesOrdersGenerated',
  SalesOrdersGeneration = 'SalesOrdersGeneration',
  SalesOrdersGenerationError = 'SalesOrdersGenerationError',
}

export type VariableContractLineFilterInput = {
  created?: InputMaybe<DateTimeFilterInput>;
  headerPrimaryKey?: InputMaybe<GuidFilterInput>;
  iD?: InputMaybe<GuidFilterInput>;
  minCharge?: InputMaybe<DecimalFilterInput>;
  salesHandoverNumber?: InputMaybe<StringFilterInput>;
  updated?: InputMaybe<DateTimeFilterInput>;
};

export type VariableContractLineOutput = {
  __typename?: 'VariableContractLineOutput';
  billingInterval?: Maybe<Scalars['String']['output']>;
  billingType?: Maybe<BillingTypeEnum>;
  bundleDescription?: Maybe<Scalars['String']['output']>;
  bundleHideInvoiceLines?: Maybe<Scalars['Boolean']['output']>;
  bundleHideInvoiceValues?: Maybe<Scalars['Boolean']['output']>;
  bundleId?: Maybe<Scalars['ID']['output']>;
  bundleSoftwareCompany?: Maybe<Scalars['String']['output']>;
  bundleType?: Maybe<BundleTypeEnum>;
  contractID: Scalars['Guid']['output'];
  created: Scalars['DateTime']['output'];
  iD: Scalars['Guid']['output'];
  invoiceToCustomerAccountManagerName?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerAccountNumber?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerAddress?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerCCEmailAddress?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerContactName?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerContactPhoneNumber?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerCountry?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerEmailAddress?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerId: Scalars['Guid']['output'];
  invoiceToCustomerName?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerPostcode?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerSalesPersonName?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerState?: Maybe<Scalars['String']['output']>;
  invoiceToCustomerTown?: Maybe<Scalars['String']['output']>;
  lastSOEndDate?: Maybe<Scalars['DateTime']['output']>;
  lastSOQuantity?: Maybe<Scalars['Long']['output']>;
  lastSOStartDate?: Maybe<Scalars['DateTime']['output']>;
  lastSOTotalValue?: Maybe<Scalars['String']['output']>;
  lineBillingCurrentStatusEndDate?: Maybe<Scalars['DateTime']['output']>;
  lineBillingCurrentStatusStartDate?: Maybe<Scalars['DateTime']['output']>;
  lineBillingStatus?: Maybe<ContractBillingStatusPascalCaseEnum>;
  lineBillingStatusUpdateComment?: Maybe<Scalars['String']['output']>;
  lineBillingStatusUpdateReasonCode?: Maybe<Scalars['String']['output']>;
  lineBillingStatusUpdateReference?: Maybe<Scalars['String']['output']>;
  lineBillingStatusUpdated?: Maybe<Scalars['DateTime']['output']>;
  minCharge?: Maybe<Scalars['Decimal']['output']>;
  nextUpliftDate?: Maybe<Scalars['DateTime']['output']>;
  noFurtherBilling?: Maybe<Scalars['Boolean']['output']>;
  noFurtherBillingDate?: Maybe<Scalars['DateTime']['output']>;
  oppHeaderId?: Maybe<Scalars['String']['output']>;
  oppLineId?: Maybe<Scalars['String']['output']>;
  origin: ContractOriginEnum;
  poDate?: Maybe<Scalars['DateTime']['output']>;
  poEndDate?: Maybe<Scalars['DateTime']['output']>;
  poNote?: Maybe<Scalars['String']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  poRemainingValue?: Maybe<Scalars['String']['output']>;
  poStartDate?: Maybe<Scalars['DateTime']['output']>;
  poStatus?: Maybe<PurchaseOrderStatusEnum>;
  poTotalValue?: Maybe<Scalars['String']['output']>;
  predictedAnnualValue?: Maybe<Scalars['String']['output']>;
  predictedSOEndDate?: Maybe<Scalars['DateTime']['output']>;
  predictedSOInvoiceDate?: Maybe<Scalars['DateTime']['output']>;
  predictedSOStartDate?: Maybe<Scalars['DateTime']['output']>;
  productId: Scalars['Guid']['output'];
  salesHandoverNumber?: Maybe<Scalars['String']['output']>;
  shipToCustomerAccountManagerName?: Maybe<Scalars['String']['output']>;
  shipToCustomerAccountNumber?: Maybe<Scalars['String']['output']>;
  shipToCustomerAddress?: Maybe<Scalars['String']['output']>;
  shipToCustomerCCEmailAddress?: Maybe<Scalars['String']['output']>;
  shipToCustomerContactName?: Maybe<Scalars['String']['output']>;
  shipToCustomerContactPhoneNumber?: Maybe<Scalars['String']['output']>;
  shipToCustomerCountry?: Maybe<Scalars['String']['output']>;
  shipToCustomerEmailAddress?: Maybe<Scalars['String']['output']>;
  shipToCustomerId: Scalars['Guid']['output'];
  shipToCustomerName?: Maybe<Scalars['String']['output']>;
  shipToCustomerPostcode?: Maybe<Scalars['String']['output']>;
  shipToCustomerSalesPersonName?: Maybe<Scalars['String']['output']>;
  shipToCustomerState?: Maybe<Scalars['String']['output']>;
  shipToCustomerTown?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  status?: Maybe<ContractStatusEnum>;
  statusChangeComment?: Maybe<Scalars['String']['output']>;
  statusChangeDate?: Maybe<Scalars['DateTime']['output']>;
  statusChangeReason?: Maybe<Scalars['String']['output']>;
  statusChangeReasonName?: Maybe<Scalars['String']['output']>;
  statusChangeReasonType?: Maybe<Scalars['String']['output']>;
  stockCode?: Maybe<Scalars['String']['output']>;
  stockName?: Maybe<Scalars['String']['output']>;
  terminationDate?: Maybe<Scalars['DateTime']['output']>;
  unitPrice?: Maybe<Scalars['Decimal']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection from an object to a list of objects of type `VariableContractLineOutput`. */
export type VariableContractLineOutputConnection = {
  __typename?: 'VariableContractLineOutputConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<VariableContractLineOutputEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<VariableContractLineOutput>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `VariableContractLineOutput`. */
export type VariableContractLineOutputEdge = {
  __typename?: 'VariableContractLineOutputEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<VariableContractLineOutput>;
};

export enum VariableContractLineSort {
  ContractID = 'ContractID',
  Created = 'Created',
  ID = 'ID',
  MinCharge = 'MinCharge',
  SalesHandoverNumber = 'SalesHandoverNumber',
  UnitPrice = 'UnitPrice',
  Updated = 'Updated',
}

export type VariableContractLineSortSortByInput = {
  /** Field */
  field?: InputMaybe<VariableContractLineSort>;
  order: OrderType;
};

export type VerifiableFieldType = {
  __typename?: 'VerifiableFieldType';
  entityType: EntityTypeEnum;
  field: Scalars['String']['output'];
  reasonCode: Scalars['String']['output'];
};

export type VerifyFieldsInputType = {
  comment?: InputMaybe<Scalars['String']['input']>;
  entityID: Scalars['ID']['input'];
  entityType: EntityTypeEnum;
  fields: Array<InputMaybe<Scalars['String']['input']>>;
  reasonCode: Scalars['String']['input'];
};
